const BASE_URL = 'https://runbizops.com/api';
// const BASE_URL = 'https://runbizops.com/api';

export const ENDPOINTS = {
    AUTH: {
        LOGIN: `${BASE_URL}/authentication`,
        REFRESH: `${BASE_URL}/authentication/refresh`,
        LOGOUT: `${BASE_URL}/authentication/logout`,
        IMPERSONATE_EXIT: `${BASE_URL}/authentication/impersonate/exit`,
        IMPERSONATE: (userId: string) => `${BASE_URL}/authentication/impersonate/${userId}`,
        VERIFY_TWO_FACTOR: `${BASE_URL}/authentication/verify`,
    },
    IMPERSONATION_GRANT: {
        MY: `${BASE_URL}/impersonation-grant/my`,
        AVAILABLE: `${BASE_URL}/impersonation-grant/available`,
        BASE: `${BASE_URL}/impersonation-grant`,
    },
    USER_PROFILE: {
        LOGGED_IN_USER_PROFILE: `${BASE_URL}/user-profile/logged-in-user-profile`,
        UPDATE_PROFILE: (id: string) => `${BASE_URL}/user-profile/${id}`,
        BY_USER: (userId: string) => `${BASE_URL}/user-profile/user/${userId}`,
    },
    TWO_FACTOR: {
        SETUP: `${BASE_URL}/user/2fa/setup`,
        ENABLE: `${BASE_URL}/user/2fa/enable`,
        DISABLE: `${BASE_URL}/user/2fa/disable`,
        REGENERATE_BACKUP_CODES: `${BASE_URL}/user/2fa/backup-codes/regenerate`,
        STATUS: `${BASE_URL}/user/2fa/status`,
        ADMIN_RESET: (userId: string) => `${BASE_URL}/user/2fa/admin/reset/${userId}`,
        ADMIN_BLOCK_BACKUP_CODES: (userId: string) => `${BASE_URL}/user/2fa/admin/backup-codes/block/${userId}`,
        ADMIN_UNBLOCK_BACKUP_CODES: (userId: string) => `${BASE_URL}/user/2fa/admin/backup-codes/unblock/${userId}`,
        ADMIN_STATUS: (userId: string) => `${BASE_URL}/user/2fa/admin/status/${userId}`,
    },
    USER: {
        BASE: `${BASE_URL}/user`,
        INSTITUTION_USERS: `${BASE_URL}/user/institution-users`,
        BULK_ONBOARD: (institutionId: string) => `${BASE_URL}/user/institution-users/${institutionId}/bulk`,
        UPDATE_PASSWORD: `${BASE_URL}/user/update-password`,
        LOGOUT_ALL_DEVICES: `${BASE_URL}/user/logout-all-devices`,
        RESET_PASSWORD: (userId: string, institutionId: string) => `${BASE_URL}/user/${userId}/institution/${institutionId}/reset-user-password`,
        UPDATE_USERNAME: (userId: string) => `${BASE_URL}/user/update-username/${userId}`,
        CHECK_USERNAME: `${BASE_URL}/user/check-username-available`,
        TOGGLE_ACTIVE: (id: string) => `${BASE_URL}/user/toggle-active/${id}`,
        DELETE: (id: string) => `${BASE_URL}/user/${id}`,
    },
    INSTITUTION: {
        BASE: `${BASE_URL}/institution`,
        LOGGED_IN_USER_INSTITUTIONS: `${BASE_URL}/institution/logged-in-user-institutions`,
        CHECK_CODE_UNIQUENESS: `${BASE_URL}/institution/check-code-unique`,
        UPDATE: (id: string) => `${BASE_URL}/institution/${id}`,
        DELETE: (id: string) => `${BASE_URL}/institution/${id}`,
        UPLOAD_LOGO: (id: string) => `${BASE_URL}/institution/${id}/logo`,
        DELETE_LOGO: (id: string) => `${BASE_URL}/institution/${id}/logo`,
        TOGGLE_ACTIVE: (id: string) => `${BASE_URL}/institution/toggle-active/${id}`,
        BY_USER_ID: (userId: string) => `${BASE_URL}/institution/user/${userId}`,
        PREMIUM_DASHBOARD: (id: string) => `${BASE_URL}/institution/${id}/premium-dashboard`,
        ENABLED_MODULES: (id: string) => `${BASE_URL}/institution/${id}/enabled-modules`,
        PLAN: (id: string) => `${BASE_URL}/institution/${id}/plan`,
        MODULE_ACCESS: (id: string) => `${BASE_URL}/institution/${id}/module-access`,
    },
    APPROVAL_CONTROLS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/approval-controls/institution/${institutionId}`,
    },
    USAGE: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/institutions/${institutionId}/usage`,
        POLICY: (institutionId: string) => `${BASE_URL}/institutions/${institutionId}/usage/policy`,
        PLATFORM: `${BASE_URL}/platform/usage`,
        BACKFILL_STORAGE: `${BASE_URL}/platform/usage/backfill-storage`,
    },
    INSTITUTION_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/institution-settings/institution/${institutionId}`,
        WEEKEND_DAYS: (institutionId: string) => `${BASE_URL}/institution-settings/institution/${institutionId}/weekend-days`,
        TWO_FACTOR_POLICY: (institutionId: string) => `${BASE_URL}/institution-settings/institution/${institutionId}/two-factor-policy`,
        LOCATION_POLICY: (institutionId: string) =>
            `${BASE_URL}/institution-settings/institution/${institutionId}/location-policy`,
    },
    ATTENDANCE: {
        BASE: `${BASE_URL}/attendance`,
        LOGGED_IN_USER_ATTENDANCE: `${BASE_URL}/attendance/logged-in-user-attendance`,
        CLOCK_IN: `${BASE_URL}/attendance/in`,
        CLOCK_OUT: `${BASE_URL}/attendance/out`,
        UPDATE: (id: string) => `${BASE_URL}/attendance/${id}`,
        EMPLOYEE_ATTENDANCE: (employeeUserId: string) =>
            `${BASE_URL}/attendance/employee/${employeeUserId}`,
        INSTITUTION_TODAY: (institutionId: string) =>
            `${BASE_URL}/attendance/institution/${institutionId}/today`,
        INSTITUTION_TODAY_ROSTER: (institutionId: string) =>
            `${BASE_URL}/attendance/institution/${institutionId}/today/roster`,
        MONTHLY_REPORT: (institutionId: string) =>
            `${BASE_URL}/attendance/institution/${institutionId}/monthly-report`,
        LOCATION_REVIEW: (id: string) => `${BASE_URL}/attendance/${id}/location-review`,
    },
    WORK_SITE: {
        BASE: `${BASE_URL}/work-sites`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/work-sites/institution/${institutionId}`,
        UPDATE: (id: string) => `${BASE_URL}/work-sites/${id}`,
        DELETE: (id: string) => `${BASE_URL}/work-sites/${id}`,
        EMPLOYEES: (id: string) => `${BASE_URL}/work-sites/${id}/employees`,
    },
    DEPARTMENT: {
        BASE: `${BASE_URL}/department`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/department/institution/${institutionId}`,
        BY_ID: (id: string) => `${BASE_URL}/department/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/department/${id}`,
        DELETE: (id: string) => `${BASE_URL}/department/${id}`,
        USERS: (departmentId: string) => `${BASE_URL}/department/${departmentId}/users`,
        TOGGLE_ADMIN: (departmentId: string, userId: string) => `${BASE_URL}/department/${departmentId}/users/${userId}/toggle-admin`,
        TREE: (institutionId: string) => `${BASE_URL}/department/institution/${institutionId}/tree`,
    },
    HOLIDAY: {
        BASE: `${BASE_URL}/holiday`,
        HOLIDAY_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/holiday/institution/${institutionId}`,
        DELETE: (id: string) => `${BASE_URL}/holiday/${id}`,
    },
    LEAVE_APPLICATION: {
        BASE: `${BASE_URL}/leave-application`,
        LOGGED_IN_USER_APPLICATION_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/leave-application/logged-in-user/institution/${institutionId}`,
        ALL_APPLICATION_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/leave-application/institution/${institutionId}`,
        CANCEL: (id: string) => `${BASE_URL}/leave-application/${id}/cancel`,
        APPROVE: (id: string) => `${BASE_URL}/leave-application/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/leave-application/${id}/reject`,
        MATERNITY_BENEFIT_STATEMENT: (id: string) => `${BASE_URL}/leave-application/${id}/maternity-benefit-statement`,
        MATERNITY_INSTALMENTS: (id: string) => `${BASE_URL}/leave-application/${id}/maternity-instalments`,
        MATERNITY_INSTALMENT_DELETE: (id: string, instalmentId: string) => `${BASE_URL}/leave-application/${id}/maternity-instalments/${instalmentId}`
    },
    LEAVE_TYPE: {
        BASE: `${BASE_URL}/leave-type`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/leave-type/institution/${institutionId}`,
        UPDATE_DOC_REQUIREMENT: (id: string) => `${BASE_URL}/leave-type/${id}/document-requirement`,
        UPDATE_PAID: (id: string) => `${BASE_URL}/leave-type/${id}/paid`,
        SET_ACTIVE: (id: string) => `${BASE_URL}/leave-type/${id}/active`,
        UPDATE_ENCASHABLE: (id: string) => `${BASE_URL}/leave-type/${id}/encashable`,
        UPDATE_ACCRUAL: (id: string) => `${BASE_URL}/leave-type/${id}/accrual`,
        UPDATE_MINIMUM_TENURE_MONTHS: (id: string) => `${BASE_URL}/leave-type/${id}/minimum-tenure-months`,
        UPDATE_ATTENDANCE_BONUS_EXEMPT: (id: string) => `${BASE_URL}/leave-type/${id}/attendance-bonus-exempt`
    },
    LEAVE_ACCRUAL: {
        RUN: (institutionId: string, year: number, month: number) =>
            `${BASE_URL}/leave/accrual/institution/${institutionId}/run?year=${year}&month=${month}`,
        CARRY_FORWARD: (institutionId: string, closingFiscalYear: number, force = false) =>
            `${BASE_URL}/leave/accrual/institution/${institutionId}/carry-forward?closingFiscalYear=${closingFiscalYear}&force=${force}`,
        UNDO_CARRY_FORWARD: (institutionId: string, closingFiscalYear: number) =>
            `${BASE_URL}/leave/accrual/institution/${institutionId}/carry-forward/undo?closingFiscalYear=${closingFiscalYear}`,
        HISTORY: (institutionId: string, userId: string, leaveTypeId: string) =>
            `${BASE_URL}/leave/accrual/institution/${institutionId}/history?userId=${userId}&leaveTypeId=${leaveTypeId}`
    },
    LEAVE_DOCUMENT: {
        DOWNLOAD: (id: string) => `${BASE_URL}/leave-document/${id}/download`,
        BY_APPLICATION: (applicationId: string) => `${BASE_URL}/leave-document/leave-application/${applicationId}`,
    },
    EMPLOYEE_DOCUMENT: {
        UPLOAD: `${BASE_URL}/employee-document/upload`,
        UPLOAD_FOR_USER: (userId: string) => `${BASE_URL}/employee-document/upload/user/${userId}`,
        MY_DOCUMENTS: `${BASE_URL}/employee-document/my-documents`,
        BY_USER: (userId: string) => `${BASE_URL}/employee-document/user/${userId}`,
        DOWNLOAD: (id: string) => `${BASE_URL}/employee-document/${id}/download`,
    },
    EMPLOYEE_LETTER: {
        APPOINTMENT_LETTER: (institutionId: string, userId: string) =>
            `${BASE_URL}/employee-letter/institution/${institutionId}/user/${userId}/appointment-letter`,
        ID_CARD: (institutionId: string, userId: string) =>
            `${BASE_URL}/employee-letter/institution/${institutionId}/user/${userId}/id-card`,
        EXPERIENCE_LETTER: (institutionId: string, userId: string) =>
            `${BASE_URL}/employee-letter/institution/${institutionId}/user/${userId}/experience-letter`,
        SALARY_CERTIFICATE: (institutionId: string, userId: string) =>
            `${BASE_URL}/employee-letter/institution/${institutionId}/user/${userId}/salary-certificate`,
        FINAL_SETTLEMENT: (institutionId: string, settlementId: string) =>
            `${BASE_URL}/employee-letter/institution/${institutionId}/final-settlement/${settlementId}`,
        MATERNITY_STATEMENT: (institutionId: string, leaveApplicationId: string) =>
            `${BASE_URL}/employee-letter/institution/${institutionId}/maternity-statement/${leaveApplicationId}`,
    },
    LEAVE_POLICY: {
        BASE: `${BASE_URL}/leave-policy`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/leave-policy/institution/${institutionId}`,
        SET_ACTIVE: (id: string) => `${BASE_URL}/leave-policy/${id}/active`
    },
    USER_LEAVE_ALLOCATION: {
        BASE: `${BASE_URL}/user-leave-allocation`,
        BY_INSTITUTION_AND_FISCAL_YEAR: (institutionId: string, fiscalYear: number) =>
            `${BASE_URL}/user-leave-allocation/institution/${institutionId}/fiscal-year/${fiscalYear}`,
        DELETE: (id: string) => `${BASE_URL}/user-leave-allocation/${id}`
    },
    LEAVE_BALANCE: {
        MY_BALANCE: (institutionId: string) => `${BASE_URL}/leave-balance/my-balance/institution/${institutionId}`,
        ALL_USER_BALANCES: (institutionId: string) => `${BASE_URL}/leave-balance/institution/${institutionId}`
    },
    STORE: {
        BASE: `${BASE_URL}/store`,
        LIST_BY_INSTITUTION: `${BASE_URL}/store/institution`,
        DELETE: (id: string) => `${BASE_URL}/store/${id}`,
        IN_CHARGE: (id: string) => `${BASE_URL}/store/${id}/in-charge`,
        // ---- FW-1 ----
        DEACTIVATE: (id: string) => `${BASE_URL}/store/${id}/deactivate`,
        ACTIVATE: (id: string) => `${BASE_URL}/store/${id}/activate`,
        // ---- end FW-1 ----
    },
    ITEM_CATEGORY: {
        BASE: `${BASE_URL}/item-category`,
        LIST_BY_INSTITUTION: `${BASE_URL}/item-category/institution`,
        UPDATE: (id: string) => `${BASE_URL}/item-category/${id}`,
        DELETE: (id: string) => `${BASE_URL}/item-category/${id}`
    },
    STOCK_RESERVATION: {
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/stock-reservation/institution/${institutionId}`,
        RELEASE: (institutionId: string, id: string) => `${BASE_URL}/stock-reservation/institution/${institutionId}/${id}/release`,
        RESERVE_SHORTFALL: (institutionId: string, buyerOrderId: string) =>
            `${BASE_URL}/stock-reservation/institution/${institutionId}/buyer-order/${buyerOrderId}/reserve-shortfall`,
        RAISE_SHORTFALL_REQUISITION: (institutionId: string, buyerOrderId: string) =>
            `${BASE_URL}/stock-reservation/institution/${institutionId}/buyer-order/${buyerOrderId}/raise-shortfall-requisition`,
    },
    ITEM_CUSTODY: {
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/item-custody/institution/${institutionId}`,
        RETURN: (id: string) => `${BASE_URL}/item-custody/${id}/return`,
        WRITE_OFF: (id: string) => `${BASE_URL}/item-custody/${id}/write-off`,
    },
    ITEM: {
        BASE: `${BASE_URL}/item`,
        LIST_BY_INSTITUTION: `${BASE_URL}/item/institution`,
        UPDATE: (id: string) => `${BASE_URL}/item/${id}`,
        DELETE: (id: string) => `${BASE_URL}/item/${id}`,
        GET: (id: string) => `${BASE_URL}/item/${id}`,
        LOOKUP: (institutionId: string) => `${BASE_URL}/item/institution/${institutionId}/lookup`,   // Q3
        SUGGEST_BARCODE: (institutionId: string) => `${BASE_URL}/item/institution/${institutionId}/suggest-barcode`,   // Q3
    },
    STORE_LABELS: `${BASE_URL}/inventory/labels`,   // Q3
    REQUISITION: {
        BASE: `${BASE_URL}/requisition`,
        CREATE: `${BASE_URL}/requisition/create`,
        LOGGED_IN_USER_REQUISITIONS: (institutionId: string) => `${BASE_URL}/requisition/logged-in-user-requisitions/institution/${institutionId}`,
        PENDING_APPROVAL_REQUISITIONS_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/requisition/pending-approval/institution/${institutionId}`,
        PENDING_ISSUE_REQUISITIONS_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/requisition/pending-issue/institution/${institutionId}`,
        DELETE: (id: string) => `${BASE_URL}/requisition/${id}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/requisition/${id}`,
        APPROVE: (id: string) => `${BASE_URL}/requisition/approve/${id}`,
        REJECT: (id: string) => `${BASE_URL}/requisition/reject/${id}`,
        ISSUE: (id: string) => `${BASE_URL}/requisition/issue/${id}`,
    },
    REPORT: {
        EMPLOYEE_CONSUMPTION: `${BASE_URL}/report/employee-consumption`,
    },
    PUBLIC: {
        CHECK_CODE_UNIQUENESS: `${BASE_URL}/public/institution/check-code-unique`,
        INSTITUTION_CREATE: `${BASE_URL}/public/institution`
    },
    STOCK: {
        STOCK_BY_STORE_AND_ITEM: (storeId: string, itemId: string) => `${BASE_URL}/stock/store-id/${storeId}/item-id/${itemId}`,
        STOCK_IN: `${BASE_URL}/stock/stock-in`,
        STOCK_OUT: `${BASE_URL}/stock/stock-out`,
        STOCK_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/stock/institution/${institutionId}`,
        STOCK_BY_STORE: (storeId: string) => `${BASE_URL}/stock/store-id/${storeId}`,
        HISTORY_SEARCH: (institutionId: string) => `${BASE_URL}/stock/institution/${institutionId}/history`,
        STOCK_HISTORY: (storeId: string, itemId: string) => `${BASE_URL}/stock/history/store-id/${storeId}/item-id/${itemId}`,
        LOTS: (storeId: string, itemId: string) => `${BASE_URL}/stock/lots/${storeId}/${itemId}`,
        LOW_STOCK: (institutionId: string) => `${BASE_URL}/stock/institution/${institutionId}/low-stock`,
        REORDER_LEVEL: (stockId: string) => `${BASE_URL}/stock/${stockId}/reorder-level`,
        LOT_SEARCH: (institutionId: string) => `${BASE_URL}/stock/institution/${institutionId}/lots`,
        LOT_REGISTER_XLSX: (institutionId: string) => `${BASE_URL}/stock/institution/${institutionId}/lots.xlsx`,
        AVAILABLE_LOTS: (storeId: string, itemId: string) => `${BASE_URL}/stock/lots/${storeId}/${itemId}/available`,
    },
    STOCKTAKE: {
        BASE: `${BASE_URL}/stocktake`,
        CREATE: `${BASE_URL}/stocktake`,
        GET_BY_ID: (id: string) => `${BASE_URL}/stocktake/${id}`,
        COUNTS: (id: string) => `${BASE_URL}/stocktake/${id}/counts`,
        APPROVE: (id: string) => `${BASE_URL}/stocktake/${id}/approve`,
        CANCEL: (id: string) => `${BASE_URL}/stocktake/${id}/cancel`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/stocktake/institution/${institutionId}`,
    },
    STOCK_TRANSFER: {
        BASE: `${BASE_URL}/stock-transfer`,
        CREATE: `${BASE_URL}/stock-transfer`,
        GET_BY_ID: (id: string) => `${BASE_URL}/stock-transfer/${id}`,
        SUBMIT: (id: string) => `${BASE_URL}/stock-transfer/${id}/submit`,
        APPROVE: (id: string) => `${BASE_URL}/stock-transfer/${id}/approve`,
        CANCEL: (id: string) => `${BASE_URL}/stock-transfer/${id}/cancel`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/stock-transfer/institution/${institutionId}`,
    },
    ACCOUNT: {
        BASE: `${BASE_URL}/account`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}`,
        /** Names-only account list for pickers (no balances); open to fixed-asset managers who lack ACCOUNT_VIEW. */
        LOOKUP: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/lookup`,
        TREE_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/tree`,
        BY_TYPE: (institutionId: string, type: string) => `${BASE_URL}/account/institution/${institutionId}/type/${type}`,
        BY_ID: (id: string) => `${BASE_URL}/account/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/account/${id}`,
        DELETE: (id: string) => `${BASE_URL}/account/${id}`,
        HIDE: (institutionId: string, accountId: string) => `${BASE_URL}/account/institution/${institutionId}/hide/${accountId}`,
        UNHIDE: (institutionId: string, accountId: string) => `${BASE_URL}/account/institution/${institutionId}/hide/${accountId}`,
        HIDDEN: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/hidden`,
        LEDGER: (id: string) => `${BASE_URL}/account/${id}/ledger`,
        TRIAL_BALANCE: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/trial-balance`,
        SEGMENT_TRIAL_BALANCE: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/segment-trial-balance`,
        INCOME_STATEMENT: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/income-statement`,
        BALANCE_SHEET: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/balance-sheet`,
        CASH_FLOW: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/cash-flow`,
        CASH_FLOW_CLASSIFICATION: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/cash-flow-classification`,
        DAY_BOOK: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/day-book`,
        DAY_BOOK_REFERENCE_TYPES: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/day-book/reference-types`,
        DAY_BOOK_XLSX: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/day-book/export.xlsx`,
        TRIAL_BALANCE_EXPORT: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/trial-balance/export`,
        INCOME_STATEMENT_EXPORT: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/income-statement/export`,
        BALANCE_SHEET_EXPORT: (institutionId: string) => `${BASE_URL}/account/institution/${institutionId}/balance-sheet/export`,
        LEDGER_EXPORT: (id: string) => `${BASE_URL}/account/${id}/ledger/export`,
    },
    SEGMENT: {
        BASE: `${BASE_URL}/segment`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/segment/institution/${institutionId}`,
        BY_ID: (id: string) => `${BASE_URL}/segment/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/segment/${id}`,
    },
    ALLOCATION_RULE: {
        BASE: `${BASE_URL}/allocation-rule`,
        UPDATE: (id: string) => `${BASE_URL}/allocation-rule/${id}`,
    },
    SEGMENT_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/segment-settings/institution/${institutionId}`,
        UPDATE: (institutionId: string) => `${BASE_URL}/segment-settings/institution/${institutionId}`,
    },
    LEDGER_CLOSE_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/ledger-close-settings/institution/${institutionId}`,
        UPDATE: (institutionId: string) => `${BASE_URL}/ledger-close-settings/institution/${institutionId}`,
    },
    YEAR_END_CLOSE: {
        LIST: (institutionId: string) => `${BASE_URL}/year-end-close/institution/${institutionId}`,
        PREVIEW: (institutionId: string) => `${BASE_URL}/year-end-close/institution/${institutionId}/preview`,
        CLOSE: (institutionId: string) => `${BASE_URL}/year-end-close/institution/${institutionId}/close`,
        REOPEN: (institutionId: string) => `${BASE_URL}/year-end-close/institution/${institutionId}/reopen`,
        SETTINGS: (institutionId: string) => `${BASE_URL}/year-end-close/institution/${institutionId}/settings`,
        SETTINGS_UPDATE: `${BASE_URL}/year-end-close/settings`,
    },
    RECURRING_JOURNAL: {
        BASE: `${BASE_URL}/recurring-journal`,
        LIST: (institutionId: string) => `${BASE_URL}/recurring-journal/institution/${institutionId}`,
        BY_ID: (id: string) => `${BASE_URL}/recurring-journal/${id}`,
        RUNS: (id: string) => `${BASE_URL}/recurring-journal/${id}/runs`,
        RUN_NOW: (id: string) => `${BASE_URL}/recurring-journal/${id}/run-now`,
        SKIP_NEXT: (id: string) => `${BASE_URL}/recurring-journal/${id}/skip-next`,
        PAUSE: (id: string) => `${BASE_URL}/recurring-journal/${id}/pause`,
        RESUME: (id: string) => `${BASE_URL}/recurring-journal/${id}/resume`,
        DEACTIVATE: (id: string) => `${BASE_URL}/recurring-journal/${id}/deactivate`,
        RETRY_RUN: (runId: string) => `${BASE_URL}/recurring-journal/runs/${runId}/retry`,
    },
    // ---- FW-2C ----
    RECURRING_DOCUMENT: {
        BASE: `${BASE_URL}/recurring-document`,
        LIST: (institutionId: string) => `${BASE_URL}/recurring-document/institution/${institutionId}`,
        PREFILL: (institutionId: string, kind: string, documentId: string) =>
            `${BASE_URL}/recurring-document/institution/${institutionId}/prefill/${kind}/${documentId}`,
        BY_ID: (id: string) => `${BASE_URL}/recurring-document/${id}`,
        PAUSE: (id: string) => `${BASE_URL}/recurring-document/${id}/pause`,
        RESUME: (id: string) => `${BASE_URL}/recurring-document/${id}/resume`,
        END: (id: string) => `${BASE_URL}/recurring-document/${id}/end`,
        RUN_NOW: (id: string) => `${BASE_URL}/recurring-document/${id}/run-now`,
        RETRY_RUN: (runId: string) => `${BASE_URL}/recurring-document/runs/${runId}/retry`,
        SKIP_RUN: (runId: string) => `${BASE_URL}/recurring-document/runs/${runId}/skip`,
        LINK_RUN: (runId: string) => `${BASE_URL}/recurring-document/runs/${runId}/link`,
    },
    // ---- end FW-2C ----
    JOURNAL_ENTRY: {
        BASE: `${BASE_URL}/journal-entry`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/journal-entry/institution/${institutionId}`,
        REFERENCE_TYPES: (institutionId: string) => `${BASE_URL}/journal-entry/institution/${institutionId}/reference-types`,
        BY_ID: (id: string) => `${BASE_URL}/journal-entry/${id}`,
        POST: (id: string) => `${BASE_URL}/journal-entry/${id}/post`,
        VOID: (id: string) => `${BASE_URL}/journal-entry/${id}/void`,
        CONTRA: `${BASE_URL}/journal-entry/contra`,
        CONTRA_ACCOUNTS: (institutionId: string) => `${BASE_URL}/journal-entry/contra/accounts/institution/${institutionId}`,
        VOUCHER_PDF: (id: string) => `${BASE_URL}/journal-entry/${id}/voucher-pdf`,
    },
    ATTACHMENT: {
        BASE: `${BASE_URL}/attachment`,
        DOWNLOAD: (id: string) => `${BASE_URL}/attachment/${id}/download`,
        DELETE: (id: string) => `${BASE_URL}/attachment/${id}`,
        KIND: (id: string) => `${BASE_URL}/attachment/${id}/kind`, // S4
    },
    OPENING_BALANCE: {
        STATUS: (institutionId: string) => `${BASE_URL}/opening-balance/institution/${institutionId}/status`,
        ACCOUNTS_IMPORT: `${BASE_URL}/opening-balance/accounts-import`,
        TRIAL_BALANCE: `${BASE_URL}/opening-balance/trial-balance`,
        CUSTOMERS: `${BASE_URL}/opening-balance/customers`,
        SUPPLIERS: `${BASE_URL}/opening-balance/suppliers`,
    },
    GROUP_ACCOUNT_RECLASS: {
        LIST: (institutionId: string) => `${BASE_URL}/journal-entry/group-balances/institution/${institutionId}`,
        RECLASSIFY: (institutionId: string) => `${BASE_URL}/journal-entry/group-balances/institution/${institutionId}/reclassify`,
    },
    TRANSACTION: {
        BASE: `${BASE_URL}/transaction`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/transaction/institution/${institutionId}`,
        BY_ID: (id: string) => `${BASE_URL}/transaction/${id}`,
        DELETE: (id: string) => `${BASE_URL}/transaction/${id}`,
        // ---- FW-3B ----
        POST: (id: string) => `${BASE_URL}/transaction/${id}/post`,
        EDIT: (id: string) => `${BASE_URL}/transaction/${id}`,
        DISCARD_HELD: (id: string) => `${BASE_URL}/transaction/${id}/held`,
        // ---- end FW-3B ----
        SUGGEST_CATEGORY: (institutionId: string) => `${BASE_URL}/transaction/institution/${institutionId}/suggest-category`,   // F11 (11c)
    },
    // ---- F11 (11b) per-cashbook access (EndPoint.CashbookAccess = "api/cashbook-access") ----
    CASHBOOK_ACCESS: {
        ACCOUNTS: (institutionId: string) => `${BASE_URL}/cashbook-access/institution/${institutionId}/accounts`,
        USERS: (institutionId: string, accountId: string) =>
            `${BASE_URL}/cashbook-access/institution/${institutionId}/accounts/${accountId}/users`,
        MINE: (institutionId: string) => `${BASE_URL}/cashbook-access/institution/${institutionId}/mine`,
    },
    // ---- F11 (11c) transaction mapping rules (EndPoint.TxnMappingRules = "api/txn-mapping-rules") ----
    TXN_MAPPING_RULES: {
        FIELDS: `${BASE_URL}/txn-mapping-rules/fields`,
        LIST: (institutionId: string) => `${BASE_URL}/txn-mapping-rules/institution/${institutionId}`,
        ONE: (institutionId: string, ruleId: string) => `${BASE_URL}/txn-mapping-rules/institution/${institutionId}/${ruleId}`,
        ACTIVATE: (institutionId: string, ruleId: string) => `${BASE_URL}/txn-mapping-rules/institution/${institutionId}/${ruleId}/activate`,
        DEACTIVATE: (institutionId: string, ruleId: string) => `${BASE_URL}/txn-mapping-rules/institution/${institutionId}/${ruleId}/deactivate`,
        ORDER: (institutionId: string) => `${BASE_URL}/txn-mapping-rules/institution/${institutionId}/order`,
    },
    // ---- end F11 ----
    // Managed dashboards (lane D1): role/department defaults, other people's boards, own-board reset.
    DASHBOARD_LAYOUTS: {
        PEOPLE: (institutionId: string) => `${BASE_URL}/dashboard-layouts/institution/${institutionId}/people`,
        TARGETS: (institutionId: string) => `${BASE_URL}/dashboard-layouts/institution/${institutionId}/targets`,
        USER_BOARD: (institutionId: string, userId: string, boardKey = 'home') =>
            `${BASE_URL}/dashboard-layouts/institution/${institutionId}/user/${userId}?boardKey=${encodeURIComponent(boardKey)}`,
        USER_AUDIT: (institutionId: string, userId: string) =>
            `${BASE_URL}/dashboard-layouts/institution/${institutionId}/user/${userId}/audit`,
        DEFAULTS: (institutionId: string, boardKey = 'home') =>
            `${BASE_URL}/dashboard-layouts/institution/${institutionId}/defaults?boardKey=${encodeURIComponent(boardKey)}`,
        DEFAULTS_UPSERT: (institutionId: string) => `${BASE_URL}/dashboard-layouts/institution/${institutionId}/defaults`,
        DEFAULTS_AUDIT: (institutionId: string) => `${BASE_URL}/dashboard-layouts/institution/${institutionId}/defaults/audit`,
        DEFAULT_BY_ID: (id: string) => `${BASE_URL}/dashboard-layouts/defaults/${id}`,
        MY_BOARD_RESET: (institutionId: string, boardKey = 'home') =>
            `${BASE_URL}/dashboard-layouts/institution/${institutionId}/my-board/reset?boardKey=${encodeURIComponent(boardKey)}`,
    },
    DASHBOARD: {
        WORK_SUMMARY: (institutionId: string) => `${BASE_URL}/dashboard/work-summary/institution/${institutionId}`,
        THREAD_LENS: (institutionId: string, lens: string) =>
            `${BASE_URL}/dashboard/thread/institution/${institutionId}?lens=${encodeURIComponent(lens)}`,
        INSTITUTION: (institutionId: string) => `${BASE_URL}/dashboard/institution/${institutionId}`,
        MY_SUMMARY: (institutionId: string) => `${BASE_URL}/dashboard/my-summary/institution/${institutionId}`,
        STYLE: (institutionId: string) => `${BASE_URL}/dashboard/style/institution/${institutionId}`,
        KPI_STRIP: (institutionId: string) => `${BASE_URL}/dashboard/kpi-strip/institution/${institutionId}`,
        ACTION_CENTER_PREF: (institutionId: string) => `${BASE_URL}/dashboard/action-center-pref/institution/${institutionId}`,
        STORE_ADMIN: (institutionId: string) => `${BASE_URL}/dashboard/store-admin/institution/${institutionId}`,
        ATTENDANCE_STATUS_USERS: (institutionId: string, status: string) =>
            `${BASE_URL}/dashboard/institution/${institutionId}/attendance-status/${status}`,
        ATTENDANCE_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/summary/institution/${institutionId}`,
        LEAVE_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/leave/summary/institution/${institutionId}`,
        PEOPLE_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/people/summary/institution/${institutionId}`,
        ACTION_CENTER: (institutionId: string) =>
            `${BASE_URL}/dashboard/action-center/institution/${institutionId}`,
        ATTENDANCE_KPIS: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/kpis/institution/${institutionId}`,
        ATTENDANCE_COMPOSITION: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/composition/institution/${institutionId}`,
        ATTENDANCE_ARRIVALS: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/arrivals/institution/${institutionId}`,
        ATTENDANCE_WEEKDAY: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/weekday/institution/${institutionId}`,
        ATTENDANCE_TOP_LATE: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/top-late/institution/${institutionId}`,
        ATTENDANCE_TOP_OT: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/top-ot/institution/${institutionId}`,
        ATTENDANCE_DEPARTMENT: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/department/institution/${institutionId}`,
        ATTENDANCE_TODAY_LOG: (institutionId: string) =>
            `${BASE_URL}/dashboard/attendance/today-log/institution/${institutionId}`,
        ACCOUNTING_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/accounting/summary/institution/${institutionId}`,
        INVENTORY_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/inventory/summary/institution/${institutionId}`,
        SALES_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/sales/summary/institution/${institutionId}`,
        PAYROLL_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/payroll/summary/institution/${institutionId}`,
        EXPENSE_SUMMARY: (institutionId: string) =>
            `${BASE_URL}/dashboard/expense/summary/institution/${institutionId}`,
        LAYOUT: (institutionId: string, boardKey = 'home') =>
            `${BASE_URL}/dashboard/layout/institution/${institutionId}?boardKey=${encodeURIComponent(boardKey)}`,
        KPI_TARGETS: (institutionId: string) =>
            `${BASE_URL}/dashboard/kpi-targets/institution/${institutionId}`,
        ACCOUNTING_AR_AGING: (institutionId: string) =>
            `${BASE_URL}/dashboard/accounting/ar-aging/institution/${institutionId}`,
        ACCOUNTING_TOP_RECEIVABLES: (institutionId: string) =>
            `${BASE_URL}/dashboard/accounting/top-receivables/institution/${institutionId}`,
        ACCOUNTING_TREND: (institutionId: string) =>
            `${BASE_URL}/dashboard/accounting/trend/institution/${institutionId}`,
        ACCOUNTING_EXPENSE_BY_ACCOUNT: (institutionId: string) =>
            `${BASE_URL}/dashboard/accounting/expense-by-account/institution/${institutionId}`,
        INVENTORY_VALUE_BY_STORE: (institutionId: string) =>
            `${BASE_URL}/dashboard/inventory/value-by-store/institution/${institutionId}`,
        INVENTORY_MOVEMENT: (institutionId: string) =>
            `${BASE_URL}/dashboard/inventory/movement/institution/${institutionId}`,
        INVENTORY_REORDER: (institutionId: string) =>
            `${BASE_URL}/dashboard/inventory/reorder/institution/${institutionId}`,
        INVENTORY_TOP_ITEMS: (institutionId: string) =>
            `${BASE_URL}/dashboard/inventory/top-items/institution/${institutionId}`,
        SALES_PIPELINE: (institutionId: string) =>
            `${BASE_URL}/dashboard/sales/pipeline/institution/${institutionId}`,
        SALES_REVENUE: (institutionId: string) =>
            `${BASE_URL}/dashboard/sales/revenue/institution/${institutionId}`,
        SALES_OUTCOMES: (institutionId: string) =>
            `${BASE_URL}/dashboard/sales/outcomes/institution/${institutionId}`,
        SALES_TOP_DEALS: (institutionId: string) =>
            `${BASE_URL}/dashboard/sales/top-deals/institution/${institutionId}`,
        PAYROLL_TREND: (institutionId: string) =>
            `${BASE_URL}/dashboard/payroll/trend/institution/${institutionId}`,
        PAYROLL_BY_DEPARTMENT: (institutionId: string) =>
            `${BASE_URL}/dashboard/payroll/by-department/institution/${institutionId}`,
        PAYROLL_OVERTIME: (institutionId: string) =>
            `${BASE_URL}/dashboard/payroll/overtime/institution/${institutionId}`,
        EXPENSE_QUEUE: (institutionId: string) =>
            `${BASE_URL}/dashboard/expense/queue/institution/${institutionId}`,
        EXPENSE_TREND: (institutionId: string) =>
            `${BASE_URL}/dashboard/expense/trend/institution/${institutionId}`,
        EXPENSE_BY_CATEGORY: (institutionId: string) =>
            `${BASE_URL}/dashboard/expense/by-category/institution/${institutionId}`,
        EXPENSE_TOP_CLAIMANTS: (institutionId: string) =>
            `${BASE_URL}/dashboard/expense/top-claimants/institution/${institutionId}`,
        LEAVE_TREND: (institutionId: string) =>
            `${BASE_URL}/dashboard/leave/trend/institution/${institutionId}`,
        LEAVE_BY_TYPE: (institutionId: string) =>
            `${BASE_URL}/dashboard/leave/by-type/institution/${institutionId}`,
        PEOPLE_GROWTH: (institutionId: string) =>
            `${BASE_URL}/dashboard/people/growth/institution/${institutionId}`,
    },
    DEVICE_USER: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/device-user/institution/${institutionId}`,
        UNMAPPED: (institutionId: string) => `${BASE_URL}/device-user/unmapped/${institutionId}`,
        MAP: (id: string) => `${BASE_URL}/device-user/${id}/map`,
        UNMAP: (id: string) => `${BASE_URL}/device-user/${id}/unmap`,
    },
    DEVICE_API_KEY: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/device-api-key/institution/${institutionId}`,
        ROTATE: (id: string) => `${BASE_URL}/device-api-key/${id}/rotate`,
        TOGGLE_ACTIVE: (id: string) => `${BASE_URL}/device-api-key/${id}/toggle-active`,
        CLOCK_ZONE: (id: string) => `${BASE_URL}/device-api-key/${id}/clock-zone`,
        SYNC_STATUS: (institutionId: string) => `${BASE_URL}/device-api-key/institution/${institutionId}/sync-status`,
        DELETE: (id: string) => `${BASE_URL}/device-api-key/${id}`,
    },
    UNMAPPED_DEVICE_PUNCH: {
        GROUPS: (institutionId: string) => `${BASE_URL}/unmapped-device-punch/institution/${institutionId}/groups`,
        COUNT: (institutionId: string) => `${BASE_URL}/unmapped-device-punch/institution/${institutionId}/count`,
        PUNCHES: (institutionId: string) => `${BASE_URL}/unmapped-device-punch/institution/${institutionId}/punches`,
        ASSIGN: (institutionId: string) => `${BASE_URL}/unmapped-device-punch/institution/${institutionId}/assign`,
        DISCARD: (institutionId: string) => `${BASE_URL}/unmapped-device-punch/institution/${institutionId}/discard`,
    },
    BUDGET: {
        BASE: `${BASE_URL}/budget`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/budget/institution/${institutionId}`,
        COMPARISON: (institutionId: string) => `${BASE_URL}/budget/institution/${institutionId}/comparison`,
        BY_ID: (id: string) => `${BASE_URL}/budget/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/budget/${id}`,
        DELETE: (id: string) => `${BASE_URL}/budget/${id}`,
    },
    SALARY_COMPONENT: {
        BASE: `${BASE_URL}/salary-component`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/salary-component/institution/${institutionId}`,
        UPDATE: (id: string) => `${BASE_URL}/salary-component/${id}`,
        DELETE: (id: string) => `${BASE_URL}/salary-component/${id}`,
        SEED_DEFAULTS: (institutionId: string) => `${BASE_URL}/salary-component/institution/${institutionId}/seed-defaults`,
    },
    EMPLOYEE_SALARY: {
        BASE: `${BASE_URL}/employee-salary`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/employee-salary/institution/${institutionId}`,
        BY_USER: (institutionId: string, userId: string) => `${BASE_URL}/employee-salary/institution/${institutionId}/user/${userId}`,
        UPDATE: (id: string) => `${BASE_URL}/employee-salary/${id}`,
    },
    WAGE_GRADE: {
        BASE: `${BASE_URL}/wage-grade`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/wage-grade/institution/${institutionId}`,
        UPDATE: (id: string) => `${BASE_URL}/wage-grade/${id}`,
        SEED_DEFAULTS: (institutionId: string) => `${BASE_URL}/wage-grade/institution/${institutionId}/seed-defaults`,
    },
    // H-1 annual increment (WageIncrementController).
    WAGE_INCREMENT: {
        DUE: (institutionId: string, asOfYear: number) => `${BASE_URL}/wage-increment/institution/${institutionId}/due?asOfYear=${asOfYear}`,
        APPLY: `${BASE_URL}/wage-increment/apply`,
    },
    PAYROLL_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/payroll-settings/institution/${institutionId}`,
        OVERTIME_FIXED_COUNT: (institutionId: string) => `${BASE_URL}/payroll-settings/institution/${institutionId}/overtime-fixed-count`,
        // T3b: N6 cold-start warning -- how many active PIECE_RATE employees currently have
        // fewer than 3 qualifying trailing-average months (PayrollSettingsController).
        PIECE_RATE_COLD_START_COUNT: (institutionId: string) => `${BASE_URL}/payroll-settings/institution/${institutionId}/piece-rate-cold-start-count`,
    },
    PIECE_RATE_OPERATION: {
        BASE: `${BASE_URL}/piece-rate-operation`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/piece-rate-operation/institution/${institutionId}`,
        UPDATE: (id: string) => `${BASE_URL}/piece-rate-operation/${id}`,
        DELETE: (id: string) => `${BASE_URL}/piece-rate-operation/${id}`,
    },
    PRODUCTION_ENTRY: {
        BASE: `${BASE_URL}/production-entry`,
        BY_USER: (institutionId: string, userId: string) => `${BASE_URL}/production-entry/institution/${institutionId}/user/${userId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/production-entry/institution/${institutionId}/${id}`,
        DELETE: (institutionId: string, id: string) => `${BASE_URL}/production-entry/institution/${institutionId}/${id}`,
        APPROVE: (institutionId: string, id: string) => `${BASE_URL}/production-entry/institution/${institutionId}/${id}/approve`,
        UNAPPROVE: (institutionId: string, id: string) => `${BASE_URL}/production-entry/institution/${institutionId}/${id}/unapprove`,
        APPROVE_RANGE: (institutionId: string) => `${BASE_URL}/production-entry/institution/${institutionId}/approve-range`,
    },
    NOTICE: {
        CREATE: (institutionId: string) => `${BASE_URL}/notice/institution/${institutionId}`,
        UPDATE: (noticeId: string, institutionId: string) => `${BASE_URL}/notice/${noticeId}/institution/${institutionId}`,
        DELETE: (noticeId: string, institutionId: string) => `${BASE_URL}/notice/${noticeId}/institution/${institutionId}`,
        ADMIN_LIST: (institutionId: string) => `${BASE_URL}/notice/institution/${institutionId}/admin`,
        FEED: (institutionId: string) => `${BASE_URL}/notice/institution/${institutionId}/feed`,
        GET: (noticeId: string) => `${BASE_URL}/notice/${noticeId}`,
        MARK_READ: (noticeId: string) => `${BASE_URL}/notice/${noticeId}/read`,
        READERS: (noticeId: string, institutionId: string) => `${BASE_URL}/notice/${noticeId}/institution/${institutionId}/readers`,
        ATTACHMENT: (noticeId: string) => `${BASE_URL}/notice/${noticeId}/attachment`,
    },
    TASK: {
        CREATE: (institutionId: string) => `${BASE_URL}/task/institution/${institutionId}`,
        UPDATE: (taskId: string, institutionId: string) => `${BASE_URL}/task/${taskId}/institution/${institutionId}`,
        DELETE: (taskId: string, institutionId: string) => `${BASE_URL}/task/${taskId}/institution/${institutionId}`,
        MY: (institutionId: string) => `${BASE_URL}/task/institution/${institutionId}/my`,
        ASSIGNED_BY_ME: (institutionId: string) => `${BASE_URL}/task/institution/${institutionId}/assigned-by-me`,
        ADMIN_LIST: (institutionId: string) => `${BASE_URL}/task/institution/${institutionId}/admin`,
        GET: (taskId: string) => `${BASE_URL}/task/${taskId}`,
        UPDATE_STATUS: (taskId: string) => `${BASE_URL}/task/${taskId}/status`,
    },
    UNIT_OF_MEASUREMENT: {
        ALL: `${BASE_URL}/unit-of-measurement`,
        BY_ID: (id: string) => `${BASE_URL}/unit-of-measurement/${id}`,
    },
    PAYROLL: {
        GENERATE: `${BASE_URL}/payroll/generate`,
        LIST: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}`,
        RUN_TOTALS: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/totals`,
        UNPAID_WAGES: (institutionId: string) => `${BASE_URL}/payroll/institution/${institutionId}/unpaid-wages`,
        OT_HOURS_WARNING: (institutionId: string) => `${BASE_URL}/payroll/institution/${institutionId}/ot-hours-warning`,
        NO_SALARY_EXCLUSIONS: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/no-salary-exclusions`,
        FINALIZED_SELECTION: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/finalized-selection`,
        RUN_APPROVAL: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/approval`,
        RUN_APPROVAL_APPROVE: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/approval/approve`,
        RUN_APPROVAL_REJECT: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/approval/reject`,
        RUN_APPROVAL_VARIANCE: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/approval/variance`,
        AWAITING_APPROVAL: (institutionId: string) => `${BASE_URL}/payroll/institution/${institutionId}/approval/awaiting`,
        BATCH_APPROVAL: (institutionId: string) => `${BASE_URL}/payroll/institution/${institutionId}/batch-approval`,
        BY_ID: (id: string) => `${BASE_URL}/payroll/${id}`,
        FINALIZE: (id: string) => `${BASE_URL}/payroll/${id}/finalize`,
        RETRY_ACCRUAL: (id: string) => `${BASE_URL}/payroll/${id}/accrual/retry`,
        FINALIZE_ALL: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/finalize`,
        VOID_DRAFT: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/draft`,
        PAYSLIP: (id: string, lang?: 'EN' | 'BN') => `${BASE_URL}/payroll/${id}/payslip${lang ? `?lang=${lang}` : ''}`,
        PAYSLIPS_ZIP: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/payslips.zip`,
        PAYSLIPS_PDF: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/payslips.pdf`,
        // Employee self-service ("My Payslips"): caller's own FINALIZED payslips only.
        MY_PAYSLIPS: (institutionId: string, page = 0, size = 20) => `${BASE_URL}/payroll/me/institution/${institutionId}?page=${page}&size=${size}`,
        MY_PAYSLIP: (id: string) => `${BASE_URL}/payroll/me/${id}`,
        MY_PAYSLIP_PDF: (id: string, lang?: 'EN' | 'BN') => `${BASE_URL}/payroll/me/${id}/payslip${lang ? `?lang=${lang}` : ''}`,
        PAYSLIP_EMAIL: (id: string) => `${BASE_URL}/payroll/${id}/payslip/email`,
        PAYSLIPS_EMAIL: (institutionId: string, year: number, month: number) => `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/payslips/email`,
        BANK_ADVICE_CSV: (batchId: string) => `${BASE_URL}/payroll/batches/${batchId}/bank-advice.csv`,
        DISBURSEMENT_SUMMARY: (institutionId: string, year: number, month: number) =>
            `${BASE_URL}/payroll/institution/${institutionId}/year/${year}/month/${month}/disbursement-summary`,
        MFS_DISBURSEMENT_PREVIEW: (batchId: string) => `${BASE_URL}/payroll/batches/${batchId}/mfs-disbursement/preview`,
        MFS_DISBURSEMENT_CSV: (batchId: string) => `${BASE_URL}/payroll/batches/${batchId}/mfs-disbursement.csv`,
        RECORD_PAYMENT: (payrollId: string) => `${BASE_URL}/payroll/${payrollId}/payments`,
        REVERSE_PAYMENT: (paymentId: string) => `${BASE_URL}/payroll/payments/${paymentId}/reverse`,
        PAYMENT_STATUS: (payrollId: string) => `${BASE_URL}/payroll/${payrollId}/payment-status`,
        RETRY_JOURNAL_POST: (paymentId: string) => `${BASE_URL}/payroll/payments/${paymentId}/retry-journal-post`,
        SKIP_JOURNAL_POST: (paymentId: string) => `${BASE_URL}/payroll/payments/${paymentId}/skip-journal-post`,
        RECORD_BATCH: `${BASE_URL}/payroll/payments/batches`,
        VOID_BATCH: (batchId: string) => `${BASE_URL}/payroll/payments/batches/${batchId}/void`,
        LIST_BATCHES: `${BASE_URL}/payroll/payments/batches`,
        RECONCILIATION: `${BASE_URL}/payroll/payments/reconciliation`,
        SEGMENT: (id: string) => `${BASE_URL}/payroll/${id}/segment`,
        BULK_SEGMENT: `${BASE_URL}/payroll/segment`,
    },
    FESTIVAL_BONUS: {
        BASE: (institutionId: string) => `${BASE_URL}/payroll/institution/${institutionId}/festival-bonus`,
        LIST: (institutionId: string, year: number) => `${BASE_URL}/payroll/institution/${institutionId}/festival-bonus?year=${year}`,
        PREVIEW: (grantId: string) => `${BASE_URL}/payroll/festival-bonus/${grantId}/preview`,
        DELETE: (grantId: string) => `${BASE_URL}/payroll/festival-bonus/${grantId}`,
        VOID: (institutionId: string, grantId: string) => `${BASE_URL}/payroll/institution/${institutionId}/festival-bonus/${grantId}/void`,
    },
    LEAVE_ENCASHMENT: {
        BASE: (institutionId: string) => `${BASE_URL}/payroll/leave-encashment/institution/${institutionId}`,
        LIST: (institutionId: string, year?: number) => `${BASE_URL}/payroll/leave-encashment/institution/${institutionId}${year ? `?year=${year}` : ''}`,
        REMAINING: (institutionId: string, userId: string, leaveTypeId: string) =>
            `${BASE_URL}/payroll/leave-encashment/institution/${institutionId}/remaining?userId=${userId}&leaveTypeId=${leaveTypeId}`,
        DELETE: (id: string, institutionId: string) => `${BASE_URL}/payroll/leave-encashment/${id}?institutionId=${institutionId}`,
    },
    // Fix round 1 (F6): EMPLOYEE_EXIT's BASE/LIST built the identical string (unlike
    // FESTIVAL_BONUS/LEAVE_ENCASHMENT's LIST, which genuinely differs by an appended query
    // param) -- one key, used for both create (POST) and list (GET).
    EMPLOYEE_EXIT: {
        BASE: (institutionId: string) => `${BASE_URL}/payroll/exits/institution/${institutionId}`,
        DELETE: (id: string, institutionId: string) => `${BASE_URL}/payroll/exits/${id}?institutionId=${institutionId}`,
    },
    FINAL_SETTLEMENT: {
        COMPUTE: (institutionId: string, exitId: string) => `${BASE_URL}/payroll/settlements/institution/${institutionId}/compute/${exitId}`,
        FINALIZE: (id: string, institutionId: string) => `${BASE_URL}/payroll/settlements/${id}/finalize?institutionId=${institutionId}`,
        UNFINALIZE: (id: string, institutionId: string) => `${BASE_URL}/payroll/settlements/${id}/unfinalize?institutionId=${institutionId}`,
        PAY: (id: string, institutionId: string) => `${BASE_URL}/payroll/settlements/${id}/pay?institutionId=${institutionId}`,
        VOID: (id: string, institutionId: string) => `${BASE_URL}/payroll/settlements/${id}/void?institutionId=${institutionId}`,
        LIST: (institutionId: string) => `${BASE_URL}/payroll/settlements/institution/${institutionId}`,
        // Fix round 1 (F6): DETAIL/DELETE built the identical string -- one key, used for both
        // GET (detail) and DELETE.
        BY_ID: (id: string, institutionId: string) => `${BASE_URL}/payroll/settlements/${id}?institutionId=${institutionId}`,
    },
    TAX_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/tax-settings/institution/${institutionId}`,
        UPSERT: `${BASE_URL}/tax-settings`,
    },
    TAX_YEAR: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/tax-year/institution/${institutionId}`,
        SAVE: `${BASE_URL}/tax-year`,
        ACTIVATE: (id: string) => `${BASE_URL}/tax-year/${id}/activate`,
        DELETE: (id: string) => `${BASE_URL}/tax-year/${id}`,
    },
    TAX_EXEMPTION: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/tax-exemption/institution/${institutionId}`,
        SAVE_ALL: (institutionId: string) => `${BASE_URL}/tax-exemption/institution/${institutionId}/save-all`,
    },
    EMPLOYEE_TAX: {
        SUMMARY: (institutionId: string, taxYearId: string) =>
            `${BASE_URL}/employee-tax/institution/${institutionId}/tax-year/${taxYearId}`,
    },
    TAX_REPORT: {
        MONTHLY: (institutionId: string, taxYearId: string) =>
            `${BASE_URL}/tax-report/institution/${institutionId}/tax-year/${taxYearId}/monthly`,
        MONTHLY_PDF: (institutionId: string, taxYearId: string) =>
            `${BASE_URL}/tax-report/institution/${institutionId}/tax-year/${taxYearId}/monthly/pdf`,
        CERTIFICATE_PDF: (institutionId: string, taxYearId: string, userId: string) =>
            `${BASE_URL}/tax-report/institution/${institutionId}/tax-year/${taxYearId}/certificate/${userId}/pdf`,
    },
    SHIFT: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/shifts/institution/${institutionId}`,
        BY_ID: (institutionId: string, id: string) => `${BASE_URL}/shifts/institution/${institutionId}/${id}`,
        ASSIGNMENTS_BY_INSTITUTION: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/assignments`,
        ASSIGNMENT_BY_ID: (institutionId: string, id: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/assignments/${id}`,
        ASSIGNMENTS_BULK: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/assignments/bulk`,
        ME_TODAY: `${BASE_URL}/shifts/me/today`,
        ME_UPCOMING: `${BASE_URL}/shifts/me/upcoming`,
        ROTATION_PATTERNS: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/rotation-patterns`,
        ROTATION_PATTERN_BY_ID: (institutionId: string, id: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/rotation-patterns/${id}`,
        ROSTER: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster`,
        ROSTER_OVERRIDE: (institutionId: string, instanceId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster/override/${instanceId}`,
        ROSTER_RESET: (institutionId: string, instanceId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster/reset/${instanceId}`,
        ROSTER_BULK_SWAP: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster/bulk-swap`,
        ROSTER_REGENERATE: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/roster/regenerate`,
        ORPHANS: (institutionId: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/orphan-punches`,
        ORPHAN_ATTACH: (institutionId: string, id: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/orphan-punches/${id}/attach`,
        ORPHAN_DELETE: (institutionId: string, id: string) =>
            `${BASE_URL}/shifts/institution/${institutionId}/orphan-punches/${id}`,
    },
    SUPPLIER: {
        BASE: `${BASE_URL}/supplier`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/supplier/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/supplier/${id}`,
        CREATE: `${BASE_URL}/supplier`,
        UPDATE: (id: string) => `${BASE_URL}/supplier/${id}`,
        DELETE: (id: string) => `${BASE_URL}/supplier/${id}`,
        // ---- FW-1 ----
        DEACTIVATE: (id: string) => `${BASE_URL}/supplier/${id}/deactivate`,
        ACTIVATE: (id: string) => `${BASE_URL}/supplier/${id}/activate`,
        // ---- end FW-1 ----
    },
    SUPPLIER_ITEM: {
        BASE: `${BASE_URL}/supplier-item`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/supplier-item/institution/${institutionId}`,
        LIST_BY_SUPPLIER: (supplierId: string) => `${BASE_URL}/supplier-item/supplier/${supplierId}`,
        BY_ITEM: (itemId: string) => `${BASE_URL}/supplier-item/by-item/${itemId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/supplier-item/${id}`,
        CREATE: `${BASE_URL}/supplier-item`,
        UPDATE: (id: string) => `${BASE_URL}/supplier-item/${id}`,
        DELETE: (id: string) => `${BASE_URL}/supplier-item/${id}`,
    },
    PROCUREMENT_SETTINGS: {
        GET_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/procurement-settings/institution/${institutionId}`,
        UPSERT: (institutionId: string) => `${BASE_URL}/procurement-settings/institution/${institutionId}`,
    },
    // ---- W3-F import landed cost ----
    SUPPLIER_SERVICE_BILL: `${BASE_URL}/supplier-service-bill`,
    BILL_OF_ENTRY: {
        BASE: `${BASE_URL}/bill-of-entry`,
        LIST: (institutionId: string) => `${BASE_URL}/bill-of-entry/institution/${institutionId}`,
        BY_ID: (id: string) => `${BASE_URL}/bill-of-entry/${id}`,
        CNF_BILLS: (institutionId: string) => `${BASE_URL}/bill-of-entry/institution/${institutionId}/cnf-bills`,
        GRN_LINES: (institutionId: string) => `${BASE_URL}/bill-of-entry/institution/${institutionId}/grn-lines`,
        PREVIEW: `${BASE_URL}/bill-of-entry/preview`,
        POST: (id: string) => `${BASE_URL}/bill-of-entry/${id}/post`,
        REVERSE: (id: string) => `${BASE_URL}/bill-of-entry/${id}/reverse`,
    },
    CUSTOMS_PAYMENT: {
        BASE: `${BASE_URL}/customs-payment`,
        LIST: (institutionId: string) => `${BASE_URL}/customs-payment/institution/${institutionId}`,
        REVERSE: (id: string) => `${BASE_URL}/customs-payment/${id}/reverse`,
    },
    // ---- end W3-F ----
    PURCHASE_ORDER: {
        BASE: `${BASE_URL}/purchase-order`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/purchase-order/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/purchase-order/${id}`,
        PDF: (id: string) => `${BASE_URL}/purchase-order/${id}/pdf`,
        CREATE: `${BASE_URL}/purchase-order`,
        UPDATE_DRAFT: (id: string) => `${BASE_URL}/purchase-order/${id}`,
        SUBMIT: (id: string) => `${BASE_URL}/purchase-order/${id}/submit`,
        APPROVE: (id: string) => `${BASE_URL}/purchase-order/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/purchase-order/${id}/reject`,
        MARK_ORDERED: (id: string) => `${BASE_URL}/purchase-order/${id}/mark-ordered`,
        CANCEL: (id: string) => `${BASE_URL}/purchase-order/${id}/cancel`,
        BULK_APPROVE: `${BASE_URL}/purchase-order/bulk-approve`,
        BULK_REJECT: `${BASE_URL}/purchase-order/bulk-reject`,
        MINOR_AMENDMENT: (id: string) => `${BASE_URL}/purchase-order/${id}/minor-amendment`,
        AMEND: (id: string) => `${BASE_URL}/purchase-order/${id}/amend`,
        DELETE: (id: string) => `${BASE_URL}/purchase-order/${id}`,
    },
    GOODS_RECEIPT: {
        BASE: `${BASE_URL}/goods-receipt`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/goods-receipt/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/goods-receipt/${id}`,
        CREATE: `${BASE_URL}/goods-receipt`,
        POST: (id: string) => `${BASE_URL}/goods-receipt/${id}/post`,
        REVERSE: (id: string) => `${BASE_URL}/goods-receipt/${id}/reverse`,
    },
    SUPPLIER_BILL: {
        BASE: `${BASE_URL}/supplier-bill`,
        LIST_BY_PURCHASE_ORDER: (purchaseOrderId: string) => `${BASE_URL}/supplier-bill/purchase-order/${purchaseOrderId}`,
        LIST_BY_SUPPLIER: (supplierId: string) => `${BASE_URL}/supplier-bill/supplier/${supplierId}`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/supplier-bill/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/supplier-bill/${id}`,
        CREATE: `${BASE_URL}/supplier-bill`,
        REVERSE: (id: string) => `${BASE_URL}/supplier-bill/${id}/reverse`,
        RELEASE_BLOCK: (id: string) => `${BASE_URL}/supplier-bill/${id}/release-block`,
        EDIT: (id: string) => `${BASE_URL}/supplier-bill/${id}/edit`,
        EDIT_HISTORY: (id: string) => `${BASE_URL}/supplier-bill/${id}/edit-history`,
    },
    SUPPLIER_PAYMENT: {
        BASE: `${BASE_URL}/supplier-payment`,
        LIST_BY_BILL: (supplierBillId: string) => `${BASE_URL}/supplier-payment/bill/${supplierBillId}`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/supplier-payment/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/supplier-payment/${id}`,
        CREATE: `${BASE_URL}/supplier-payment`,
        REVERSE: (id: string) => `${BASE_URL}/supplier-payment/${id}/reverse`,
        EDIT: (id: string) => `${BASE_URL}/supplier-payment/${id}/edit`,
        EDIT_HISTORY: (id: string) => `${BASE_URL}/supplier-payment/${id}/edit-history`,
    },
    EXPENSE_CATEGORY: {
        BASE: `${BASE_URL}/expense-category`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/expense-category/institution/${institutionId}`,
        GET_BY_ID: (id: string, institutionId: string) => `${BASE_URL}/expense-category/${id}/institution/${institutionId}`,
        CREATE: `${BASE_URL}/expense-category`,
        UPDATE: (id: string) => `${BASE_URL}/expense-category/${id}`,
        DELETE: (id: string, institutionId: string) => `${BASE_URL}/expense-category/${id}/institution/${institutionId}`,
    },
    EXPENSE_POLICY: {
        GET_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/expense-policy/institution/${institutionId}`,
        UPSERT: `${BASE_URL}/expense-policy`,
        APPROVER_ROLES: (institutionId: string) => `${BASE_URL}/expense-policy/institution/${institutionId}/approver-roles`,
        ADD_TIER: (institutionId: string) => `${BASE_URL}/expense-policy/institution/${institutionId}/tiers`,
        UPDATE_TIER: (id: string) => `${BASE_URL}/expense-policy/tiers/${id}`,
        DELETE_TIER: (id: string) => `${BASE_URL}/expense-policy/tiers/${id}`,
    },
    EXPENSE_CLAIM: {
        CREATE: `${BASE_URL}/expense-claim`,
        UPDATE: (id: string) => `${BASE_URL}/expense-claim/${id}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/expense-claim/${id}`,
        SUBMIT: (id: string) => `${BASE_URL}/expense-claim/${id}/submit`,
        RECALL: (id: string) => `${BASE_URL}/expense-claim/${id}/recall`,
        DELETE: (id: string) => `${BASE_URL}/expense-claim/${id}`,
        LIST_MINE: (institutionId: string) => `${BASE_URL}/expense-claim/mine/institution/${institutionId}`,
        APPROVE: (id: string) => `${BASE_URL}/expense-claim/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/expense-claim/${id}/reject`,
        EDIT_LINE: (id: string, lineId: string) => `${BASE_URL}/expense-claim/${id}/lines/${lineId}`,
        REMOVE_LINE: (id: string, lineId: string) => `${BASE_URL}/expense-claim/${id}/lines/${lineId}`,
        PENDING_APPROVAL: (institutionId: string) => `${BASE_URL}/expense-claim/pending-approval/institution/${institutionId}`,
        PAY_STANDALONE: (id: string) => `${BASE_URL}/expense-claim/${id}/pay-standalone`,
        LINK_ADVANCE: (id: string, advanceId: string) => `${BASE_URL}/expense-claim/${id}/link-advance/${advanceId}`,
        UNLINK_ADVANCE: (id: string) => `${BASE_URL}/expense-claim/${id}/link-advance`,
        LIST_ALL: (institutionId: string) => `${BASE_URL}/expense-claim/all/institution/${institutionId}`,
        RECEIPTS: (id: string) => `${BASE_URL}/expense-claim/${id}/receipts`,
        RECEIPT: (id: string, attachmentId: string) => `${BASE_URL}/expense-claim/${id}/receipts/${attachmentId}`,
    },
    EXPENSE_ADVANCE: {
        REQUEST: `${BASE_URL}/expense-advance`,
        GET_BY_ID: (id: string) => `${BASE_URL}/expense-advance/${id}`,
        APPROVE: (id: string) => `${BASE_URL}/expense-advance/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/expense-advance/${id}/reject`,
        PAY: (id: string) => `${BASE_URL}/expense-advance/${id}/pay`,
        LIST_MINE: (institutionId: string) => `${BASE_URL}/expense-advance/mine/institution/${institutionId}`,
        PENDING_APPROVAL: (institutionId: string) => `${BASE_URL}/expense-advance/pending-approval/institution/${institutionId}`,
    },
    CUSTOMER: {
        BASE: `${BASE_URL}/customer`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/customer/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/customer/${id}`,
        CREATE: `${BASE_URL}/customer`,
        UPDATE: (id: string) => `${BASE_URL}/customer/${id}`,
        DELETE: (id: string) => `${BASE_URL}/customer/${id}`,
        // ---- FW-1 ----
        DEACTIVATE: (id: string) => `${BASE_URL}/customer/${id}/deactivate`,
        ACTIVATE: (id: string) => `${BASE_URL}/customer/${id}/activate`,
        // ---- end FW-1 ----,
    },
    SALES_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/sales-settings/institution/${institutionId}`,
        UPSERT: `${BASE_URL}/sales-settings`,
        DISCOUNT_LIMITS: (institutionId: string) => `${BASE_URL}/sales-settings/institution/${institutionId}/discount-limits`,   // S1
    },
    INVOICE_BRANDING: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/invoice-branding/institution/${institutionId}`,
        UPSERT: `${BASE_URL}/invoice-branding`,
        LOGO: (institutionId: string) => `${BASE_URL}/invoice-branding/institution/${institutionId}/logo`,
        SIGNATURE_IMAGE: (institutionId: string) => `${BASE_URL}/invoice-branding/institution/${institutionId}/signature-image`, // F7
    },
    SALES_INVOICE: {
        BASE: `${BASE_URL}/sales-invoice`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/sales-invoice/institution/${institutionId}`,
        LIST_BY_CUSTOMER: (customerId: string) => `${BASE_URL}/sales-invoice/customer/${customerId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/sales-invoice/${id}`,
        CREATE: `${BASE_URL}/sales-invoice`,
        UPDATE: (id: string) => `${BASE_URL}/sales-invoice/${id}`,
        DELETE: (id: string) => `${BASE_URL}/sales-invoice/${id}`,
        ISSUE: (id: string) => `${BASE_URL}/sales-invoice/${id}/issue`,
        SUBMIT_APPROVAL: (id: string) => `${BASE_URL}/sales-invoice/${id}/submit-for-approval`,   // FW-3A
        WITHDRAW_APPROVAL: (id: string) => `${BASE_URL}/sales-invoice/${id}/withdraw-approval`,   // FW-3A
        VOID: (id: string) => `${BASE_URL}/sales-invoice/${id}/void`,
        EDIT: (id: string) => `${BASE_URL}/sales-invoice/${id}/edit`,
        EDIT_HISTORY: (id: string) => `${BASE_URL}/sales-invoice/${id}/edit-history`,
        PDF: (id: string) => `${BASE_URL}/sales-invoice/${id}/pdf`,
        EMAIL: (id: string) => `${BASE_URL}/sales-invoice/${id}/email`,
    },
    RECEIPT: {
        LIST_BY_INVOICE: (invoiceId: string) => `${BASE_URL}/receipt/invoice/${invoiceId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/receipt/${id}`,
        CREATE: `${BASE_URL}/receipt`,
        REVERSE: (id: string) => `${BASE_URL}/receipt/${id}/reverse`,
        EDIT: (id: string) => `${BASE_URL}/receipt/${id}/edit`,
        EDIT_HISTORY: (id: string) => `${BASE_URL}/receipt/${id}/edit-history`,
        ON_ACCOUNT: `${BASE_URL}/receipt/on-account`,
        UNAPPLIED_BY_CUSTOMER: (customerId: string) => `${BASE_URL}/receipt/customer/${customerId}/unapplied`,
        APPLY: (id: string) => `${BASE_URL}/receipt/${id}/apply`,
        PDF: (id: string) => `${BASE_URL}/receipt/${id}/pdf`,
    },
    // ---- S0 sales teams and scoping ----
    SALES_TEAMS: {
        OVERVIEW: (institutionId: string) => `${BASE_URL}/sales-teams/institution/${institutionId}`,
        DEPARTMENTS: (institutionId: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/departments`,
        DEPARTMENT: (institutionId: string, id: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/departments/${id}`,
        HEADS: (institutionId: string, id: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/departments/${id}/heads`,
        HEAD: (institutionId: string, id: string, userId: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/departments/${id}/heads/${userId}`,
        TEAMS: (institutionId: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/teams`,
        TEAM: (institutionId: string, id: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/teams/${id}`,
        MANAGERS: (institutionId: string, id: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/teams/${id}/managers`,
        MANAGER: (institutionId: string, id: string, userId: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/teams/${id}/managers/${userId}`,
        MEMBERS: (institutionId: string, id: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/teams/${id}/members`,
        MEMBER: (institutionId: string, id: string, userId: string) => `${BASE_URL}/sales-teams/institution/${institutionId}/teams/${id}/members/${userId}`,
    },
    // ---- S2 sales targets and the team board ----
    SALES_TARGETS: {
        MONTH: (institutionId: string) => `${BASE_URL}/sales-targets/institution/${institutionId}`,
        MY: (institutionId: string) => `${BASE_URL}/sales-targets/institution/${institutionId}/my`,
        UPSERT: (institutionId: string) => `${BASE_URL}/sales-targets/institution/${institutionId}`,
        DELETE: (id: string) => `${BASE_URL}/sales-targets/${id}`,
        TEAM_BOARD: (institutionId: string) => `${BASE_URL}/sales-dashboard/institution/${institutionId}/team-board`,
    },
    SALES_SCOPE: {
        REASSIGN: (type: string, id: string) => `${BASE_URL}/sales-scope/reassign/${type}/${id}`,
        HISTORY: (institutionId: string, type: string, id: string) => `${BASE_URL}/sales-scope/institution/${institutionId}/reassign/${type}/${id}/history`,
    },

    // ---- W3-O sales orders and delivery challans ----
    SALES_ORDER: {
        LIST: (institutionId: string) => `${BASE_URL}/sales-order/institution/${institutionId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/sales-order/institution/${institutionId}`,
        GET: (id: string) => `${BASE_URL}/sales-order/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/sales-order/${id}`,
        DELETE: (id: string) => `${BASE_URL}/sales-order/${id}`,
        CONFIRM: (id: string) => `${BASE_URL}/sales-order/${id}/confirm`,
        CLOSE: (id: string) => `${BASE_URL}/sales-order/${id}/close`,
        CANCEL: (id: string) => `${BASE_URL}/sales-order/${id}/cancel`,
        FROM_QUOTATION: (quotationId: string) => `${BASE_URL}/sales-order/from-quotation/${quotationId}`,
        BACK_ORDERS: (institutionId: string) => `${BASE_URL}/sales-order/institution/${institutionId}/back-orders`,
        SETTINGS: (institutionId: string) => `${BASE_URL}/sales-order/institution/${institutionId}/settings`,
        INVOICE_FROM_CHALLANS: (institutionId: string) => `${BASE_URL}/sales-order/institution/${institutionId}/invoice-from-challans`,
    },
    DELIVERY_CHALLAN: {
        LIST: (institutionId: string) => `${BASE_URL}/delivery-challan/institution/${institutionId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/delivery-challan/institution/${institutionId}`,
        GET: (id: string) => `${BASE_URL}/delivery-challan/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/delivery-challan/${id}`,
        POST: (id: string) => `${BASE_URL}/delivery-challan/${id}/post`,
        CANCEL: (id: string) => `${BASE_URL}/delivery-challan/${id}/cancel`,
        PDF: (id: string) => `${BASE_URL}/delivery-challan/${id}/pdf`,
    },
    // ---- end W3-O ----
    // ---- B4-D customer returns and the stock period report ----
    SALES_RETURN: {
        LIST: (institutionId: string) => `${BASE_URL}/sales-return/institution/${institutionId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/sales-return/institution/${institutionId}`,
        SETTINGS: (institutionId: string) => `${BASE_URL}/sales-return/institution/${institutionId}/settings`,
        RETURNABLE: (challanId: string) => `${BASE_URL}/sales-return/challan/${challanId}/returnable`,
        GET: (id: string) => `${BASE_URL}/sales-return/${id}`,
        UPDATE: (id: string) => `${BASE_URL}/sales-return/${id}`,
        POST: (id: string) => `${BASE_URL}/sales-return/${id}/post`,
        CANCEL: (id: string) => `${BASE_URL}/sales-return/${id}/cancel`,
        CREDIT_NOTE_DRAFT: (id: string) => `${BASE_URL}/sales-return/${id}/credit-note-draft`,
    },
    STOCK_PERIOD_REPORT: {
        REPORT: `${BASE_URL}/inventory/reports/stock-period`,
        XLSX: `${BASE_URL}/inventory/reports/stock-period/xlsx`,
        PDF: `${BASE_URL}/inventory/reports/stock-period/pdf`,
    },
    // ---- end B4-D ----
    QUOTATION: {
        BASE: `${BASE_URL}/quotation`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/quotation/institution/${institutionId}`,
        LIST_BY_CUSTOMER: (customerId: string) => `${BASE_URL}/quotation/customer/${customerId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/quotation/${id}`,
        CREATE: `${BASE_URL}/quotation`,
        UPDATE: (id: string) => `${BASE_URL}/quotation/${id}`,
        DELETE: (id: string) => `${BASE_URL}/quotation/${id}`,
        SEND: (id: string) => `${BASE_URL}/quotation/${id}/send`,
        CONFIRM: (id: string) => `${BASE_URL}/quotation/${id}/confirm`,
        REJECT: (id: string) => `${BASE_URL}/quotation/${id}/reject`,
        CONVERT: (id: string) => `${BASE_URL}/quotation/${id}/convert`,
        CLONE: (id: string) => `${BASE_URL}/quotation/${id}/clone`,
        PDF: (id: string) => `${BASE_URL}/quotation/${id}/pdf`,
        EMAIL: (id: string) => `${BASE_URL}/quotation/${id}/email`,
        WITHDRAW_APPROVAL: (id: string) => `${BASE_URL}/quotation/${id}/withdraw-approval`,   // S1
    },
    CRM: {
        LEAD: {
            BASE: `${BASE_URL}/lead`,
            LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/lead/institution/${institutionId}`,
            GET_BY_ID: (id: string) => `${BASE_URL}/lead/${id}`,
            CREATE: `${BASE_URL}/lead`,
            UPDATE: (id: string) => `${BASE_URL}/lead/${id}`,
            DELETE: (id: string) => `${BASE_URL}/lead/${id}`,
            CONVERT: (id: string) => `${BASE_URL}/lead/${id}/convert`,
            DISQUALIFY: (id: string) => `${BASE_URL}/lead/${id}/disqualify`,
        },
        OPPORTUNITY: {
            BASE: `${BASE_URL}/opportunity`,
            BOARD_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/opportunity/board/institution/${institutionId}`,
            LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/opportunity/institution/${institutionId}`,
            GET_BY_ID: (id: string) => `${BASE_URL}/opportunity/${id}`,
            CREATE: `${BASE_URL}/opportunity`,
            UPDATE: (id: string) => `${BASE_URL}/opportunity/${id}`,
            CHANGE_STAGE: (id: string) => `${BASE_URL}/opportunity/${id}/stage`,
            CREATE_QUOTATION: (id: string) => `${BASE_URL}/opportunity/${id}/quotation`,
            DELETE: (id: string) => `${BASE_URL}/opportunity/${id}`,
        },
        ACTIVITY: {
            BASE: `${BASE_URL}/activity`,
            LIST_BY_OWNER: (ownerType: string, ownerId: string) =>
                `${BASE_URL}/activity?ownerType=${ownerType}&ownerId=${ownerId}`,
            CREATE: `${BASE_URL}/activity`,
            DELETE: (id: string) => `${BASE_URL}/activity/${id}`,
        },
    },
    SUPPLIER_REPORT: {
        AGING: (institutionId: string) => `${BASE_URL}/supplier-report/aging/institution/${institutionId}`,
        STATEMENT: (supplierId: string, from: string, to: string) =>
            `${BASE_URL}/supplier-report/statement/supplier/${supplierId}?from=${from}&to=${to}`,
    },
    SALES_REPORT: {
        AGING: (institutionId: string) => `${BASE_URL}/sales-report/aging/institution/${institutionId}`,
        STATEMENT: (customerId: string, from: string, to: string) =>
            `${BASE_URL}/sales-report/statement/customer/${customerId}?from=${from}&to=${to}`,
    },
    // ---- W3-N collections and receipts ----
    COLLECTIONS: {
        WORKLIST: (institutionId: string) => `${BASE_URL}/collections/institution/${institutionId}/worklist`,
        SETTINGS: (institutionId: string) => `${BASE_URL}/collections/institution/${institutionId}/settings`,
        SETTINGS_SAVE: `${BASE_URL}/collections/settings`,
        CREDIT: (customerId: string) => `${BASE_URL}/collections/customer/${customerId}/credit`,
        DEFAULT_DUE_DATE: (customerId: string, issueDate: string) =>
            `${BASE_URL}/collections/customer/${customerId}/default-due-date?issueDate=${issueDate}`,
    },
    COLLECTION_ACTIVITY: {
        BASE: `${BASE_URL}/collection-activity`,
        BY_CUSTOMER: (customerId: string) => `${BASE_URL}/collection-activity/customer/${customerId}`,
        ONE: (id: string) => `${BASE_URL}/collection-activity/${id}`,
    },
    CUSTOMER_REMITTANCE: {
        BASE: `${BASE_URL}/customer-remittance`,
        PREVIEW: `${BASE_URL}/customer-remittance/preview`,
        LIST: (institutionId: string) => `${BASE_URL}/customer-remittance/institution/${institutionId}`,
        SUGGEST: (institutionId: string) => `${BASE_URL}/customer-remittance/institution/${institutionId}/suggest-invoices`,
        ONE: (id: string) => `${BASE_URL}/customer-remittance/${id}`,
        REVERSE: (id: string) => `${BASE_URL}/customer-remittance/${id}/reverse`,
    },
    DUNNING: {
        LEVELS: (institutionId: string) => `${BASE_URL}/dunning/levels/institution/${institutionId}`,
        LEVELS_BASE: `${BASE_URL}/dunning/levels`,
        LEVEL: (id: string) => `${BASE_URL}/dunning/levels/${id}`,
        LOAD_DEFAULTS: (institutionId: string) => `${BASE_URL}/dunning/levels/institution/${institutionId}/load-defaults`,
        PREVIEW: (institutionId: string) => `${BASE_URL}/dunning/run/preview/institution/${institutionId}`,
        SEND: `${BASE_URL}/dunning/run/send`,
        HISTORY: (institutionId: string) => `${BASE_URL}/dunning/run/institution/${institutionId}`,
    },
    // W3-T customer payment links (public pay page is unauthenticated: the token in the URL is the capability)
    PAYMENT_LINK: {
        BASE: `${BASE_URL}/payment-link`,
        LIST: (institutionId: string) => `${BASE_URL}/payment-link/institution/${institutionId}`,
        AVAILABILITY: (institutionId: string) => `${BASE_URL}/payment-link/institution/${institutionId}/availability`,
        ATTEMPTS: (institutionId: string) => `${BASE_URL}/payment-link/institution/${institutionId}/attempts`,
        BY_INVOICE: (invoiceId: string) => `${BASE_URL}/payment-link/invoice/${invoiceId}`,
        SEND: `${BASE_URL}/payment-link/send`,
        CANCEL: (id: string) => `${BASE_URL}/payment-link/${id}/cancel`,
        REVERIFY: (attemptId: string) => `${BASE_URL}/payment-link/attempt/${attemptId}/reverify`,
        RESOLVE: (attemptId: string) => `${BASE_URL}/payment-link/attempt/${attemptId}/resolve`,
    },
    PAYMENT_GATEWAY_CONFIG: {
        BASE: `${BASE_URL}/payment-gateway-config`,
        LIST: (institutionId: string) => `${BASE_URL}/payment-gateway-config/institution/${institutionId}`,
        SUGGESTED_ACCOUNTS: (institutionId: string) => `${BASE_URL}/payment-gateway-config/institution/${institutionId}/suggested-accounts`,
    },
    GATEWAY_PAYOUT: {
        BASE: `${BASE_URL}/gateway-payout`,
        LIST: (institutionId: string) => `${BASE_URL}/gateway-payout/institution/${institutionId}`,
        CANDIDATES: (institutionId: string) => `${BASE_URL}/gateway-payout/institution/${institutionId}/candidates`,
        ONE: (id: string) => `${BASE_URL}/gateway-payout/${id}`,
        REVERSE: (id: string) => `${BASE_URL}/gateway-payout/${id}/reverse`,
    },
    PUBLIC_PAY: {
        DETAILS: (token: string) => `${BASE_URL}/public/pay/${token}`,
        START: (token: string, provider: string) => `${BASE_URL}/public/pay/${token}/start?provider=${provider}`,
        RESULT: (ref: string) => `${BASE_URL}/public/pay/result/${ref}`,
    },
    STATEMENT_DELIVERY: {
        PDF: (customerId: string, from: string, to: string) =>
            `${BASE_URL}/sales-report/statement/customer/${customerId}/pdf?from=${from}&to=${to}`,
        EMAIL: (customerId: string) => `${BASE_URL}/sales-report/statement/customer/${customerId}/email`,
        BULK: `${BASE_URL}/sales-report/statement/bulk-email`,
    },
    // ---- end W3-N ----
    FIXED_ASSET: {
        BASE: `${BASE_URL}/fixed-asset`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/fixed-asset/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/fixed-asset/${id}`,
        CREATE: `${BASE_URL}/fixed-asset`,                       // new-purchase (posts JE)
        REGISTER: `${BASE_URL}/fixed-asset/register`,            // register-existing (opening JE)
        UPDATE: (id: string) => `${BASE_URL}/fixed-asset/${id}`,
        DELETE: (id: string) => `${BASE_URL}/fixed-asset/${id}`,
        DISPOSE: (id: string) => `${BASE_URL}/fixed-asset/${id}/dispose`,
        DISPOSE_REVERSE: (id: string) => `${BASE_URL}/fixed-asset/${id}/dispose-reverse`,
    },
    // ---- B4-E: fixed-asset revaluation, impairment, bill-line registration ----
    FIXED_ASSET_VALUE: {
        SUMMARY: (assetId: string) => `${BASE_URL}/fixed-asset-value/${assetId}/summary`,
        REVALUE: (assetId: string) => `${BASE_URL}/fixed-asset-value/${assetId}/revalue`,
        IMPAIR: (assetId: string) => `${BASE_URL}/fixed-asset-value/${assetId}/impair`,
        IMPAIRMENT_REVERSAL: (assetId: string) => `${BASE_URL}/fixed-asset-value/${assetId}/impairment-reversal`,
        RESERVE_TRANSFER: (assetId: string) => `${BASE_URL}/fixed-asset-value/${assetId}/reserve-transfer`,
        REVERSE_EVENT: (assetId: string, eventId: string) => `${BASE_URL}/fixed-asset-value/${assetId}/events/${eventId}/reverse`,
        BILL_LINES: (billId: string) => `${BASE_URL}/fixed-asset-value/bill/${billId}/lines`,
        FROM_BILL_LINE: `${BASE_URL}/fixed-asset-value/from-bill-line`,
    },
    // ---- end B4-E ----
    FIXED_ASSET_DEPRECIATION: {
        RUN: (institutionId: string) => `${BASE_URL}/fixed-asset-depreciation/run/${institutionId}`,
        SCHEDULE_BY_ASSET: (assetId: string) => `${BASE_URL}/fixed-asset-depreciation/asset/${assetId}`,
    },
    FIXED_ASSET_SETTINGS: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/fixed-asset-settings/institution/${institutionId}`,
        UPSERT: `${BASE_URL}/fixed-asset-settings`,
    },
    FIXED_ASSET_REPORT: {
        REGISTER: (institutionId: string) => `${BASE_URL}/fixed-asset-report/register/institution/${institutionId}`,
        SCHEDULE: (institutionId: string) => `${BASE_URL}/fixed-asset-report/schedule/institution/${institutionId}`,
        TIE_OUT: (institutionId: string) => `${BASE_URL}/fixed-asset-report/tie-out/institution/${institutionId}`,
    },
    // ---- Q1 QR labels and scanning ----
    SCAN: {
        RESOLVE: `${BASE_URL}/scan/resolve`,
    },
    FIXED_ASSET_LABELS: `${BASE_URL}/fixed-asset/labels`,
    // ---- Q2 machine labels and receipt verify ----
    MAINTENANCE_EQUIPMENT_LABELS: `${BASE_URL}/maintenance/equipment-labels`,
    PUBLIC_RECEIPT_VERIFY: (id: string, token: string) => `${BASE_URL}/public/receipt-verify/${id}?t=${encodeURIComponent(token)}`,
    FIXED_ASSET_COUNT: {
        BASE: `${BASE_URL}/fixed-asset-count`,
        GET: (id: string) => `${BASE_URL}/fixed-asset-count/${id}`,
        LINES: (id: string) => `${BASE_URL}/fixed-asset-count/${id}/lines`,
        LINE: (id: string, lineId: string) => `${BASE_URL}/fixed-asset-count/${id}/lines/${lineId}`,
        SCAN: (id: string) => `${BASE_URL}/fixed-asset-count/${id}/scan`,
        CLOSE: (id: string) => `${BASE_URL}/fixed-asset-count/${id}/close`,
        CANCEL: (id: string) => `${BASE_URL}/fixed-asset-count/${id}/cancel`,
        EXPORT_CSV: (id: string) => `${BASE_URL}/fixed-asset-count/${id}/export.csv`,
        EXPORT_PDF: (id: string) => `${BASE_URL}/fixed-asset-count/${id}/export.pdf`,
    },
    // ---- end Q1 ----
    INVENTORY_REPORT: {
        TIE_OUT: (institutionId: string) => `${BASE_URL}/inventory-report/tie-out/institution/${institutionId}`,
    },
    SUBSCRIPTION_INVOICE: {
        BASE: `${BASE_URL}/subscription-invoice`,
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/subscription-invoice/institution/${institutionId}`,
        ISSUE: (id: string) => `${BASE_URL}/subscription-invoice/${id}/issue`,
        CANCEL: (id: string) => `${BASE_URL}/subscription-invoice/${id}/cancel`,
        MARK_PAID: (id: string) => `${BASE_URL}/subscription-invoice/${id}/mark-paid`,
        PAY_BKASH: (id: string) => `${BASE_URL}/subscription-invoice/${id}/pay/bkash`,
        RESOLVE_PAYMENT: (paymentId: string) => `${BASE_URL}/subscription-invoice/payment/${paymentId}/resolve`,
        MARK_REFUNDED: (paymentId: string) => `${BASE_URL}/subscription-invoice/payment/${paymentId}/refunded`,
    },
    FEEDBACK: {
        SEND: `${BASE_URL}/feedback`,
        MINE: `${BASE_URL}/feedback/mine`,
        PLATFORM: `${BASE_URL}/platform/feedback`,
        PLATFORM_NEW_COUNT: `${BASE_URL}/platform/feedback/new-count`,
        PLATFORM_UPDATE: (id: string) => `${BASE_URL}/platform/feedback/${id}`,
        ATTACHMENTS: (id: string) => `${BASE_URL}/feedback/${id}/attachments`,
        ATTACHMENT: (id: string, attachmentId: string) => `${BASE_URL}/feedback/${id}/attachments/${attachmentId}`,
        PLATFORM_ATTACHMENT: (id: string, attachmentId: string) => `${BASE_URL}/platform/feedback/${id}/attachments/${attachmentId}`,
    },
    ADDONS: {
        GLOBAL: `${BASE_URL}/addons`,
        PLATFORM: `${BASE_URL}/platform/addons`,
        PLATFORM_UPDATE: (key: string) => `${BASE_URL}/platform/addons/${key}`,
    },
    HELP: {
        ROLES_WITH_KEYS: (institutionId: string) => `${BASE_URL}/help/institution/${institutionId}/roles-with-keys`,
        MISSING: `${BASE_URL}/help/missing`,
    },
    ROLES: {
        LIST: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/roles`,
        ASSIGNABLE: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/assignable-roles`,
        BY_ID: (institutionId: string, roleId: string) => `${BASE_URL}/institution/${institutionId}/roles/${roleId}`,
        ACTIVE: (institutionId: string, roleId: string) => `${BASE_URL}/institution/${institutionId}/roles/${roleId}/active`,
        MEMBERS: (institutionId: string, roleId: string) => `${BASE_URL}/institution/${institutionId}/roles/${roleId}/members`,
        CATALOG: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/roles/catalog`,
        TEMPLATES: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/roles/templates`,
        USER_ROLES: (institutionId: string, userId: string) => `${BASE_URL}/institution/${institutionId}/users/${userId}/roles`,
    },
    ME: {
        PERMISSIONS: `${BASE_URL}/me/permissions`,
    },
    STATUTORY_REGISTER: {
        BONUS: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/bonus`,
        BONUS_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/bonus/xlsx`,
        BONUS_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/bonus/pdf`,
        OVERTIME: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/overtime`,
        OVERTIME_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/overtime/xlsx`,
        OVERTIME_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/overtime/pdf`,
        LEAVE: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/leave`,
        LEAVE_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/leave/xlsx`,
        LEAVE_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/leave/pdf`,
        SERVICE_RECORD: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/service-record`,
        SERVICE_RECORD_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/service-record/xlsx`,
        SERVICE_RECORD_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/service-record/pdf`,
        HOUR_BREACHES: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/hour-breaches`,
        HOUR_BREACHES_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/hour-breaches/xlsx`,
        HOUR_BREACHES_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/hour-breaches/pdf`,
        WPPF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wppf`,
        WPPF_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wppf/xlsx`,
        WPPF_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wppf/pdf`,
        WAGE_COMPLIANCE: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wage-compliance`,
        WAGE_COMPLIANCE_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wage-compliance/xlsx`,
        WAGE_COMPLIANCE_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wage-compliance/pdf`,
        INSURANCE: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/insurance`,
        INSURANCE_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/insurance/xlsx`,
        INSURANCE_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/insurance/pdf`,
        WAGE_SHEET: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wage-sheet`,
        WAGE_SHEET_XLSX: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wage-sheet/xlsx`,
        WAGE_SHEET_PDF: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wage-sheet/pdf`,
        AUDIT_PACK: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/audit-pack`,
        // Task 6 (2026-09-11 closeout-payroll-money): WPPF §234 provision booking/reversal/retry.
        WPPF_PROVISION: (institutionId: string) => `${BASE_URL}/statutory-register/institution/${institutionId}/wppf/provision`,
        WPPF_PROVISION_REVERSE: (institutionId: string, provisionId: string) =>
            `${BASE_URL}/statutory-register/institution/${institutionId}/wppf/provision/${provisionId}/reverse`,
        WPPF_PROVISION_RETRY: (institutionId: string, provisionId: string) =>
            `${BASE_URL}/statutory-register/institution/${institutionId}/wppf/provision/${provisionId}/retry-posting`,
    },
    INSURANCE_POLICY: {
        LIST: (institutionId: string) => `${BASE_URL}/insurance-policy/institution/${institutionId}`,
        ACTIVE: (institutionId: string) => `${BASE_URL}/insurance-policy/institution/${institutionId}/active`,
        CREATE: (institutionId: string) => `${BASE_URL}/insurance-policy/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/insurance-policy/institution/${institutionId}/${id}`,
        ACTIVATE: (institutionId: string, id: string) => `${BASE_URL}/insurance-policy/institution/${institutionId}/${id}/activate`,
        DEACTIVATE: (institutionId: string, id: string) => `${BASE_URL}/insurance-policy/institution/${institutionId}/${id}/deactivate`,
        OPEN_ENROLLMENT_COUNT: (institutionId: string, id: string) => `${BASE_URL}/insurance-policy/institution/${institutionId}/${id}/open-enrollment-count`,
        DELETE: (institutionId: string, id: string) => `${BASE_URL}/insurance-policy/institution/${institutionId}/${id}`,
    },
    INSURANCE_ENROLLMENT: {
        LIST: (institutionId: string, policyId: string) => `${BASE_URL}/insurance-enrollment/institution/${institutionId}/policy/${policyId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/insurance-enrollment/institution/${institutionId}`,
        END: (institutionId: string, id: string) => `${BASE_URL}/insurance-enrollment/institution/${institutionId}/${id}/end`,
        ENROLL_ALL_PREVIEW: (institutionId: string, policyId: string) => `${BASE_URL}/insurance-enrollment/institution/${institutionId}/policy/${policyId}/enroll-all/preview`,
        ENROLL_ALL: (institutionId: string, policyId: string) => `${BASE_URL}/insurance-enrollment/institution/${institutionId}/policy/${policyId}/enroll-all`,
    },
    // ---- MERCHANDISING (garments-merchandising T7 — backend T1-T6 already live)
    BUYER: {
        LIST: (institutionId: string) => `${BASE_URL}/buyer/institution/${institutionId}`,
        GET: (institutionId: string, id: string) => `${BASE_URL}/buyer/institution/${institutionId}/${id}`,
        CREATE: (institutionId: string) => `${BASE_URL}/buyer/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/buyer/institution/${institutionId}/${id}`,
        ACTIVATE: (institutionId: string, id: string) => `${BASE_URL}/buyer/institution/${institutionId}/${id}/activate`,
        DEACTIVATE: (institutionId: string, id: string) => `${BASE_URL}/buyer/institution/${institutionId}/${id}/deactivate`,
        UPLOAD_ATTACHMENT: (institutionId: string, buyerId: string) => `${BASE_URL}/buyer/institution/${institutionId}/${buyerId}/attachments`,
        LIST_ATTACHMENTS: (institutionId: string, buyerId: string) => `${BASE_URL}/buyer/institution/${institutionId}/${buyerId}/attachments`,
        DOWNLOAD_ATTACHMENT: (institutionId: string, buyerId: string, attachmentId: string) =>
            `${BASE_URL}/buyer/institution/${institutionId}/${buyerId}/attachments/${attachmentId}/download`,
        DELETE_ATTACHMENT: (institutionId: string, buyerId: string, attachmentId: string) =>
            `${BASE_URL}/buyer/institution/${institutionId}/${buyerId}/attachments/${attachmentId}`,
    },
    STYLE: {
        LIST: (institutionId: string) => `${BASE_URL}/style/institution/${institutionId}`,
        GET: (institutionId: string, id: string) => `${BASE_URL}/style/institution/${institutionId}/${id}`,
        CREATE: (institutionId: string) => `${BASE_URL}/style/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/style/institution/${institutionId}/${id}`,
        STAGE: (institutionId: string, id: string) => `${BASE_URL}/style/institution/${institutionId}/${id}/stage`,
        ARCHIVE: (institutionId: string, id: string) => `${BASE_URL}/style/institution/${institutionId}/${id}/archive`,
        ACTIVATE: (institutionId: string, id: string) => `${BASE_URL}/style/institution/${institutionId}/${id}/activate`,
        REPLACE_COST_LINES: (institutionId: string, id: string) => `${BASE_URL}/style/institution/${institutionId}/${id}/cost-lines`,
        UPLOAD_ATTACHMENT: (institutionId: string, id: string) => `${BASE_URL}/style/institution/${institutionId}/${id}/attachments`,
        LIST_ATTACHMENTS: (institutionId: string, id: string) => `${BASE_URL}/style/institution/${institutionId}/${id}/attachments`,
        DOWNLOAD_ATTACHMENT: (institutionId: string, id: string, attachmentId: string) =>
            `${BASE_URL}/style/institution/${institutionId}/${id}/attachments/${attachmentId}/download`,
        DELETE_ATTACHMENT: (institutionId: string, id: string, attachmentId: string) =>
            `${BASE_URL}/style/institution/${institutionId}/${id}/attachments/${attachmentId}`,
    },
    SAMPLE_REQUEST: {
        LIST: (institutionId: string) => `${BASE_URL}/sample-request/institution/${institutionId}`,
        GET: (institutionId: string, id: string) => `${BASE_URL}/sample-request/institution/${institutionId}/${id}`,
        CREATE: (institutionId: string) => `${BASE_URL}/sample-request/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/sample-request/institution/${institutionId}/${id}`,
        UPDATE_STATUS: (institutionId: string, id: string) => `${BASE_URL}/sample-request/institution/${institutionId}/${id}/status`,
        DECISION: (institutionId: string, id: string) => `${BASE_URL}/sample-request/institution/${institutionId}/${id}/decision`,
        RESUBMIT: (institutionId: string, id: string) => `${BASE_URL}/sample-request/institution/${institutionId}/${id}/resubmit`,
    },
    BUYER_ORDER: {
        LIST: (institutionId: string) => `${BASE_URL}/buyer-order/institution/${institutionId}`,
        GET: (institutionId: string, id: string) => `${BASE_URL}/buyer-order/institution/${institutionId}/${id}`,
        PICK: (institutionId: string) => `${BASE_URL}/buyer-order/institution/${institutionId}/pick`,
        CREATE: (institutionId: string) => `${BASE_URL}/buyer-order/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/buyer-order/institution/${institutionId}/${id}`,
        REPLACE_LINES: (institutionId: string, id: string) => `${BASE_URL}/buyer-order/institution/${institutionId}/${id}/lines`,
        AMEND: (institutionId: string, id: string) => `${BASE_URL}/buyer-order/institution/${institutionId}/${id}/amend`,
        CHANGE_STATUS: (institutionId: string, id: string) => `${BASE_URL}/buyer-order/institution/${institutionId}/${id}/status`,
    },
    TNA_MILESTONE: {
        LIST: (institutionId: string, orderId: string) => `${BASE_URL}/institution/${institutionId}/buyer-order/${orderId}/tna`,
        GENERATE: (institutionId: string, orderId: string) => `${BASE_URL}/institution/${institutionId}/buyer-order/${orderId}/tna/generate`,
        CREATE: (institutionId: string, orderId: string) => `${BASE_URL}/institution/${institutionId}/buyer-order/${orderId}/tna`,
        UPDATE: (institutionId: string, orderId: string, milestoneId: string) =>
            `${BASE_URL}/institution/${institutionId}/buyer-order/${orderId}/tna/${milestoneId}`,
        DELETE: (institutionId: string, orderId: string, milestoneId: string) =>
            `${BASE_URL}/institution/${institutionId}/buyer-order/${orderId}/tna/${milestoneId}`,
    },
    MERCHANDISING_REPORT: {
        ORDER_BOOK: (institutionId: string) => `${BASE_URL}/merchandising-report/institution/${institutionId}/order-book`,
        ORDER_BOOK_XLSX: (institutionId: string) => `${BASE_URL}/merchandising-report/institution/${institutionId}/order-book/xlsx`,
        SAMPLE_TRACKER: (institutionId: string) => `${BASE_URL}/merchandising-report/institution/${institutionId}/sample-tracker`,
        SAMPLE_TRACKER_XLSX: (institutionId: string) => `${BASE_URL}/merchandising-report/institution/${institutionId}/sample-tracker/xlsx`,
        MATERIAL_REQUIREMENT: (institutionId: string, buyerOrderId: string) =>
            `${BASE_URL}/merchandising-report/institution/${institutionId}/buyer-order/${buyerOrderId}/material-requirement`,
        ORDER_DASHBOARD: (institutionId: string) => `${BASE_URL}/merchandising-report/institution/${institutionId}/order-dashboard`,
        ORDER_DASHBOARD_XLSX: (institutionId: string) => `${BASE_URL}/merchandising-report/institution/${institutionId}/order-dashboard/xlsx`,
        SAMPLE_WORKLOAD: (institutionId: string) => `${BASE_URL}/merchandising-report/institution/${institutionId}/sample-workload`,
        SAMPLE_WORKLOAD_XLSX: (institutionId: string) => `${BASE_URL}/merchandising-report/institution/${institutionId}/sample-workload/xlsx`,
    },
    BOM_LINE: {
        LIST: (institutionId: string, styleId: string) => `${BASE_URL}/style-bom-line/institution/${institutionId}/style/${styleId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/style-bom-line/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/style-bom-line/institution/${institutionId}/${id}`,
        DELETE: (institutionId: string, id: string) => `${BASE_URL}/style-bom-line/institution/${institutionId}/${id}`,
    },
    MATERIAL_CONSUMPTION: {
        LIST: (institutionId: string, buyerOrderId: string) => `${BASE_URL}/material-consumption/institution/${institutionId}/buyer-order/${buyerOrderId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/material-consumption/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/material-consumption/institution/${institutionId}/${id}`,
        DELETE: (institutionId: string, id: string) => `${BASE_URL}/material-consumption/institution/${institutionId}/${id}`,
    },
    // ---- COMMERCIAL (T9): export LC + amendments + checklist, back-to-back LC + utilizations,
    // and read/write commercial settings. Mirrors backend com.kervolt.oms.common.EndPoint's
    // ExportLc/BackToBackLc/CommercialSettings routes (each "api/..." there; BASE_URL already
    // ends in /api, so only the path segment after "api/" is repeated here).
    EXPORT_LC: {
        LIST: (institutionId: string) => `${BASE_URL}/export-lc/institution/${institutionId}`,
        GET_BY_ID: (institutionId: string, lcId: string) => `${BASE_URL}/export-lc/institution/${institutionId}/${lcId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/export-lc/institution/${institutionId}`,
        UPDATE: (institutionId: string, lcId: string) => `${BASE_URL}/export-lc/institution/${institutionId}/${lcId}`,
        UPDATE_STATUS: (institutionId: string, lcId: string) => `${BASE_URL}/export-lc/institution/${institutionId}/${lcId}/status`,
        DELETE: (institutionId: string, lcId: string) => `${BASE_URL}/export-lc/institution/${institutionId}/${lcId}`,
        AMENDMENTS: (institutionId: string, lcId: string) => `${BASE_URL}/export-lc/institution/${institutionId}/${lcId}/amendments`,
        CHECKLIST: (institutionId: string, lcId: string) => `${BASE_URL}/export-lc/institution/${institutionId}/${lcId}/checklist`,
        CHECKLIST_ITEM: (institutionId: string, lcId: string, itemId: string) =>
            `${BASE_URL}/export-lc/institution/${institutionId}/${lcId}/checklist/${itemId}`,
    },
    BACK_TO_BACK_LC: {
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/back-to-back-lc/institution/${institutionId}`,
        LIST_BY_MASTER: (institutionId: string, lcId: string) => `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}`,
        GET_BY_ID: (institutionId: string, lcId: string, b2bId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}`,
        CREATE: (institutionId: string, lcId: string) => `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}`,
        UPDATE: (institutionId: string, lcId: string, b2bId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}`,
        DELETE: (institutionId: string, lcId: string, b2bId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}`,
        UTILIZATIONS: (institutionId: string, lcId: string, b2bId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/utilizations`,
        UTILIZATION_ITEM: (institutionId: string, lcId: string, b2bId: string, utilId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/utilizations/${utilId}`,
        // B2B accounting (wave 2): margin, bank acceptances, maturity payments, maturity schedule.
        ACCOUNTING: (institutionId: string, lcId: string, b2bId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/accounting`,
        MARGIN: (institutionId: string, lcId: string, b2bId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/margin`,
        MARGIN_RELEASE: (institutionId: string, lcId: string, b2bId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/margin/release`,
        ACCEPTANCES: (institutionId: string, lcId: string, b2bId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/acceptances`,
        ACCEPTANCE_ITEM: (institutionId: string, lcId: string, b2bId: string, acceptanceId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/acceptances/${acceptanceId}`,
        ACCEPTANCE_PAYMENTS: (institutionId: string, lcId: string, b2bId: string, acceptanceId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/acceptances/${acceptanceId}/payments`,
        ACCEPTANCE_PAYMENT_ITEM: (institutionId: string, lcId: string, b2bId: string, acceptanceId: string, paymentId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/master/${lcId}/${b2bId}/acceptances/${acceptanceId}/payments/${paymentId}`,
        MATURITY_SCHEDULE: (institutionId: string) =>
            `${BASE_URL}/back-to-back-lc/institution/${institutionId}/maturity-schedule`,
    },
    // ---- Commercial / customs (T10, garments LC / bond-UD / EXP / cash incentive). UD, EXP and
    // incentive-claim routes only -- LC/B2B routes belong to T9's LC screens on a parallel branch.
    UD_REGISTER: {
        LIST: (institutionId: string) => `${BASE_URL}/ud-register/institution/${institutionId}`,
        GET: (institutionId: string, udId: string) => `${BASE_URL}/ud-register/institution/${institutionId}/${udId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/ud-register/institution/${institutionId}`,
        UPDATE: (institutionId: string, udId: string) => `${BASE_URL}/ud-register/institution/${institutionId}/${udId}`,
        DELETE: (institutionId: string, udId: string) => `${BASE_URL}/ud-register/institution/${institutionId}/${udId}`,
        LINES: (institutionId: string, udId: string) => `${BASE_URL}/ud-register/institution/${institutionId}/${udId}/lines`,
        LINE: (institutionId: string, udId: string, lineId: string) => `${BASE_URL}/ud-register/institution/${institutionId}/${udId}/lines/${lineId}`,
        UTILIZATIONS: (institutionId: string, udId: string, lineId: string) => `${BASE_URL}/ud-register/institution/${institutionId}/${udId}/lines/${lineId}/utilizations`,
        UTILIZATION: (institutionId: string, udId: string, lineId: string, utilId: string) => `${BASE_URL}/ud-register/institution/${institutionId}/${udId}/lines/${lineId}/utilizations/${utilId}`,
    },
    EXP_FORM: {
        LIST: (institutionId: string) => `${BASE_URL}/exp-form/institution/${institutionId}`,
        GET: (institutionId: string, expId: string) => `${BASE_URL}/exp-form/institution/${institutionId}/${expId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/exp-form/institution/${institutionId}`,
        UPDATE: (institutionId: string, expId: string) => `${BASE_URL}/exp-form/institution/${institutionId}/${expId}`,
        DELETE: (institutionId: string, expId: string) => `${BASE_URL}/exp-form/institution/${institutionId}/${expId}`,
        REALIZATIONS: (institutionId: string, expId: string) => `${BASE_URL}/exp-form/institution/${institutionId}/${expId}/realizations`,
        REALIZATION: (institutionId: string, expId: string, realId: string) => `${BASE_URL}/exp-form/institution/${institutionId}/${expId}/realizations/${realId}`,
        REALIZATION_PREVIEW: (institutionId: string, expId: string) => `${BASE_URL}/exp-form/institution/${institutionId}/${expId}/realizations/preview`, // W3-B2
        REALIZATION_POST_LEDGER: (institutionId: string, expId: string, realId: string) => `${BASE_URL}/exp-form/institution/${institutionId}/${expId}/realizations/${realId}/post-ledger`,
        BOOK_RECEIVABLE: (institutionId: string, expId: string) => `${BASE_URL}/exp-form/institution/${institutionId}/${expId}/book-receivable`,
        BOOKING_RATE_SUGGESTION: (institutionId: string, currency: string) =>
            `${BASE_URL}/exp-form/institution/${institutionId}/booking-rate-suggestion?currency=${encodeURIComponent(currency)}`,
    },
    // ---- Shipping & export docs (15.2/15.3): packing list (header + carton child lines) + bill
    // of lading / forwarder (flat header). Reuses EXP_VIEW/EXP_MANAGE — no new permission catalog
    // entry. Mirrors backend EndPoint.PackingList/BillOfLading ("api/packing-list"/"api/bill-of-lading").
    PACKING_LIST: {
        LIST: (institutionId: string) => `${BASE_URL}/packing-list/institution/${institutionId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/packing-list/institution/${institutionId}`,
        GET_BY_ID: (institutionId: string, id: string) => `${BASE_URL}/packing-list/institution/${institutionId}/${id}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/packing-list/institution/${institutionId}/${id}`,
        DELETE: (institutionId: string, id: string) => `${BASE_URL}/packing-list/institution/${institutionId}/${id}`,
        CARTONS: (institutionId: string, id: string) => `${BASE_URL}/packing-list/institution/${institutionId}/${id}/cartons`,
        CARTON: (institutionId: string, id: string, cartonId: string) =>
            `${BASE_URL}/packing-list/institution/${institutionId}/${id}/cartons/${cartonId}`,
        PDF: (institutionId: string, id: string) => `${BASE_URL}/packing-list/institution/${institutionId}/${id}/pdf`,
    },
    BILL_OF_LADING: {
        LIST: (institutionId: string) => `${BASE_URL}/bill-of-lading/institution/${institutionId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/bill-of-lading/institution/${institutionId}`,
        GET_BY_ID: (institutionId: string, id: string) => `${BASE_URL}/bill-of-lading/institution/${institutionId}/${id}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/bill-of-lading/institution/${institutionId}/${id}`,
        DELETE: (institutionId: string, id: string) => `${BASE_URL}/bill-of-lading/institution/${institutionId}/${id}`,
        PDF: (institutionId: string, id: string) => `${BASE_URL}/bill-of-lading/institution/${institutionId}/${id}/pdf`,
    },
    // Export invoice (15.1, plan task 7) -- mirrors PACKING_LIST's shape, minus per-carton CRUD:
    // lines are a replace-all (LIST_LINES/REPLACE_LINES), matching backend ExportInvoiceController
    // routes 1:1.
    EXPORT_INVOICE: {
        LIST: (institutionId: string) => `${BASE_URL}/export-invoice/institution/${institutionId}`,
        GET: (institutionId: string, id: string) => `${BASE_URL}/export-invoice/institution/${institutionId}/${id}`,
        CREATE: (institutionId: string) => `${BASE_URL}/export-invoice/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/export-invoice/institution/${institutionId}/${id}`,
        DELETE: (institutionId: string, id: string) => `${BASE_URL}/export-invoice/institution/${institutionId}/${id}`,
        LIST_LINES: (institutionId: string, id: string) => `${BASE_URL}/export-invoice/institution/${institutionId}/${id}/lines`,
        REPLACE_LINES: (institutionId: string, id: string) => `${BASE_URL}/export-invoice/institution/${institutionId}/${id}/lines`,
        PDF: (institutionId: string, id: string) => `${BASE_URL}/export-invoice/institution/${institutionId}/${id}/pdf`,
    },
    // Commercial party master (Task 4a, spec §2, 7.4) -- mirrors backend
    // EndPoint.CommercialParty ("api/commercial-party"). LC_VIEW/LC_MANAGE guard every route,
    // no dedicated permission catalog entry.
    COMMERCIAL_PARTY: {
        LIST: (institutionId: string) => `${BASE_URL}/commercial-party/institution/${institutionId}`,
        GET_BY_ID: (institutionId: string, id: string) => `${BASE_URL}/commercial-party/institution/${institutionId}/${id}`,
        CREATE: (institutionId: string) => `${BASE_URL}/commercial-party/institution/${institutionId}`,
        UPDATE: (institutionId: string, id: string) => `${BASE_URL}/commercial-party/institution/${institutionId}/${id}`,
        ACTIVATE: (institutionId: string, id: string) => `${BASE_URL}/commercial-party/institution/${institutionId}/${id}/activate`,
        DEACTIVATE: (institutionId: string, id: string) => `${BASE_URL}/commercial-party/institution/${institutionId}/${id}/deactivate`,
    },
    CASH_INCENTIVE_CLAIM: {
        LIST: (institutionId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}`,
        GET: (institutionId: string, claimId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}/${claimId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}`,
        UPDATE: (institutionId: string, claimId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}/${claimId}`,
        UPDATE_STATUS: (institutionId: string, claimId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}/${claimId}/status`,
        CORRECT_RECEIPT: (institutionId: string, claimId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}/${claimId}/receipt`,
        CORRECT_RATE: (institutionId: string, claimId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}/${claimId}/rate`,
        POST_LEDGER: (institutionId: string, claimId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}/${claimId}/post-ledger`,
        DELETE: (institutionId: string, claimId: string) => `${BASE_URL}/cash-incentive-claim/institution/${institutionId}/${claimId}`,
    },
    QC_INSPECTION: {
        LIST: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/qc-inspection`,
        SUMMARY: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/qc-inspection/summary`,
        PLAN_PREVIEW: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/qc-inspection/plan-preview`,
        GET: (institutionId: string, id: string) => `${BASE_URL}/institution/${institutionId}/qc-inspection/${id}`,
        PDF: (institutionId: string, id: string) => `${BASE_URL}/institution/${institutionId}/qc-inspection/${id}/pdf`,
        CANCEL: (institutionId: string, id: string) => `${BASE_URL}/institution/${institutionId}/qc-inspection/${id}/cancel`,
        RESULT: (institutionId: string, id: string) => `${BASE_URL}/institution/${institutionId}/qc-inspection/${id}/result`,
        REINSPECT: (institutionId: string, id: string) => `${BASE_URL}/institution/${institutionId}/qc-inspection/${id}/reinspect`,
    },
    AGENT_COMMISSION: {
        REGISTER: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/agent-commission`,
        SETTLEMENTS: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/agent-commission/settlements`,
        VOID: (institutionId: string, id: string) => `${BASE_URL}/institution/${institutionId}/agent-commission/settlements/${id}/void`,
        STATEMENT_XLSX: (institutionId: string) => `${BASE_URL}/institution/${institutionId}/agent-commission/statement.xlsx`,
    },
    COMMERCIAL_SETTINGS: {
        GET: (institutionId: string) => `${BASE_URL}/commercial-settings/institution/${institutionId}`,
        UPDATE: (institutionId: string) => `${BASE_URL}/commercial-settings/institution/${institutionId}`,
    },
    // ---- Commercial reports (T11): LC position, unrealized-EXP aging, incentive-claim status.
    // Mirrors backend com.kervolt.oms.common.EndPoint.CommercialReport routes 1:1 — JSON + XLSX
    // sibling for each.
    COMMERCIAL_REPORT: {
        LC_POSITION: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/lc-position`,
        LC_POSITION_XLSX: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/lc-position/xlsx`,
        UNREALIZED_EXP_AGING: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/unrealized-exp-aging`,
        UNREALIZED_EXP_AGING_XLSX: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/unrealized-exp-aging/xlsx`,
        EXPORT_RECEIVABLES: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/export-receivables`,
        INCENTIVE_CLAIM_STATUS: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/incentive-claim-status`,
        INCENTIVE_CLAIM_STATUS_XLSX: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/incentive-claim-status/xlsx`,
        // T8 (brief item 13.3) — bond register, keyed to a buyer order via ?buyerOrderId=.
        BOND_REGISTER: (institutionId: string, buyerOrderId: string) =>
            `${BASE_URL}/commercial-report/institution/${institutionId}/bond-register?buyerOrderId=${buyerOrderId}`,
        BOND_REGISTER_XLSX: (institutionId: string, buyerOrderId: string) =>
            `${BASE_URL}/commercial-report/institution/${institutionId}/bond-register/xlsx?buyerOrderId=${buyerOrderId}`,
        // T6 (brief item 16.3) — order profitability report, keyed to a buyer order via
        // ?buyerOrderId= with an optional ?exchangeRate=.
        ORDER_PROFITABILITY: (institutionId: string, buyerOrderId: string, exchangeRate?: number) =>
            `${BASE_URL}/commercial-report/institution/${institutionId}/order-profitability?buyerOrderId=${buyerOrderId}`
            + (exchangeRate !== undefined && exchangeRate !== null ? `&exchangeRate=${exchangeRate}` : ''),
        ORDER_PROFITABILITY_XLSX: (institutionId: string, buyerOrderId: string, exchangeRate?: number) =>
            `${BASE_URL}/commercial-report/institution/${institutionId}/order-profitability/xlsx?buyerOrderId=${buyerOrderId}`
            + (exchangeRate !== undefined && exchangeRate !== null ? `&exchangeRate=${exchangeRate}` : ''),
    },
    // ---- Bond-warehouse license CRUD (T8, brief item 13.1). Mirrors backend
    // com.kervolt.oms.common.EndPoint.BondLicense ("api/bond-license") 1:1, matching
    // UD_REGISTER's institution/{id}/{bondLicenseId} shape.
    BOND_LICENSE: {
        LIST: (institutionId: string) => `${BASE_URL}/bond-license/institution/${institutionId}`,
        GET: (institutionId: string, bondLicenseId: string) => `${BASE_URL}/bond-license/institution/${institutionId}/${bondLicenseId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/bond-license/institution/${institutionId}`,
        UPDATE: (institutionId: string, bondLicenseId: string) => `${BASE_URL}/bond-license/institution/${institutionId}/${bondLicenseId}`,
        DELETE: (institutionId: string, bondLicenseId: string) => `${BASE_URL}/bond-license/institution/${institutionId}/${bondLicenseId}`,
    },
    // Bank reconciliation lane (T8, frontend part 1). Mirrors backend
    // com.kervolt.oms.bank.controller.{BankAccountController,BankReconciliationController} 1:1 --
    // EndPoint.BankAccount = "api/bank-account", EndPoint.BankReconciliation = "api/bank-reconciliation".
    BANK_ACCOUNT: {
        BASE: `${BASE_URL}/bank-account`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/bank-account/institution/${institutionId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/bank-account/${id}`,
        CREATE: `${BASE_URL}/bank-account`,
        UPDATE: (id: string) => `${BASE_URL}/bank-account/${id}`,
        DELETE: (id: string) => `${BASE_URL}/bank-account/${id}`,
    },
    BANK_RECONCILIATION: {
        LIST_BY_ACCOUNT: (bankAccountId: string) => `${BASE_URL}/bank-reconciliation/bank-account/${bankAccountId}`,
        WORKSPACE: (id: string) => `${BASE_URL}/bank-reconciliation/${id}`,
        CREATE: `${BASE_URL}/bank-reconciliation`,
        DELETE: (id: string) => `${BASE_URL}/bank-reconciliation/${id}`,
        IMPORT: (id: string) => `${BASE_URL}/bank-reconciliation/${id}/import`,
        ADD_LINE: (id: string) => `${BASE_URL}/bank-reconciliation/${id}/lines`,
        EDIT_LINE: (lineId: string) => `${BASE_URL}/bank-reconciliation/lines/${lineId}`,
        REMOVE_LINE: (lineId: string) => `${BASE_URL}/bank-reconciliation/lines/${lineId}`,
        MATCH: (id: string) => `${BASE_URL}/bank-reconciliation/${id}/match`,
        UNMATCH: (id: string) => `${BASE_URL}/bank-reconciliation/${id}/unmatch`,
        ADJUSTMENT: (id: string) => `${BASE_URL}/bank-reconciliation/${id}/adjustment`,
        COMPLETE: (id: string) => `${BASE_URL}/bank-reconciliation/${id}/complete`,
        REOPEN: (id: string) => `${BASE_URL}/bank-reconciliation/${id}/reopen`,
        UNRECONCILED: (bankAccountId: string, asOf: string) =>
            `${BASE_URL}/bank-reconciliation/report/unreconciled?bankAccountId=${bankAccountId}&asOf=${asOf}`,
        UNRECONCILED_XLSX: (bankAccountId: string, asOf: string) =>
            `${BASE_URL}/bank-reconciliation/report/unreconciled/xlsx?bankAccountId=${bankAccountId}&asOf=${asOf}`,
    },
    // ---- FW-4A bank rules (EndPoint.BankRules = "api/bank-rules") ----
    BANK_RULES: {
        FIELDS: `${BASE_URL}/bank-rules/fields`,
        LIST: (institutionId: string) => `${BASE_URL}/bank-rules/institution/${institutionId}`,
        ONE: (institutionId: string, ruleId: string) => `${BASE_URL}/bank-rules/institution/${institutionId}/${ruleId}`,
        ACTIVATE: (institutionId: string, ruleId: string) => `${BASE_URL}/bank-rules/institution/${institutionId}/${ruleId}/activate`,
        DEACTIVATE: (institutionId: string, ruleId: string) => `${BASE_URL}/bank-rules/institution/${institutionId}/${ruleId}/deactivate`,
        ORDER: (institutionId: string) => `${BASE_URL}/bank-rules/institution/${institutionId}/order`,
        TEST: (institutionId: string) => `${BASE_URL}/bank-rules/institution/${institutionId}/test`,
        PREVIEW: (reconciliationId: string) => `${BASE_URL}/bank-rules/reconciliation/${reconciliationId}/preview`,
        APPLY: (reconciliationId: string) => `${BASE_URL}/bank-rules/reconciliation/${reconciliationId}/apply`,
        APPLICATIONS: (reconciliationId: string) => `${BASE_URL}/bank-rules/reconciliation/${reconciliationId}/applications`,
        // ---- FW-4B ----
        HIT_STATS: (institutionId: string) => `${BASE_URL}/bank-rules/institution/${institutionId}/hit-stats`,
        // ---- end FW-4B ----
    },
    // ---- end FW-4A ----
    // ---- FW-3A approvals (EndPoint.Approvals = "api/approvals", ApprovalWorkflows = "api/approval-workflows") ----
    APPROVALS: {
        MINE: (institutionId: string) => `${BASE_URL}/approvals/institution/${institutionId}/mine`,
        SUBMITTED: (institutionId: string) => `${BASE_URL}/approvals/institution/${institutionId}/submitted`,
        DECIDED: (institutionId: string) => `${BASE_URL}/approvals/institution/${institutionId}/decided`,
        ALL: (institutionId: string) => `${BASE_URL}/approvals/institution/${institutionId}`,
        FOR_SUBJECT: (subjectType: string, subjectId: string) => `${BASE_URL}/approvals/subject/${subjectType}/${subjectId}`,
        ONE: (requestId: string) => `${BASE_URL}/approvals/${requestId}`,
        APPROVE: (requestId: string) => `${BASE_URL}/approvals/${requestId}/approve`,
        REJECT: (requestId: string) => `${BASE_URL}/approvals/${requestId}/reject`,
        CANCEL: (requestId: string) => `${BASE_URL}/approvals/${requestId}/cancel`,
        ADMIN_CANCEL: (requestId: string) => `${BASE_URL}/approvals/${requestId}/admin-cancel`,   // FW-3B
    },
    APPROVAL_WORKFLOWS: {
        SUBJECT_TYPES: `${BASE_URL}/approval-workflows/subject-types`,
        LIST: (institutionId: string) => `${BASE_URL}/approval-workflows/institution/${institutionId}`,
        OPTIONS: (institutionId: string) => `${BASE_URL}/approval-workflows/institution/${institutionId}/approver-options`,
        REFERENCE_OPTIONS: (institutionId: string) => `${BASE_URL}/approval-workflows/institution/${institutionId}/reference-options`,
        ORDER: (institutionId: string) => `${BASE_URL}/approval-workflows/institution/${institutionId}/order`,
        ONE: (institutionId: string, ruleId: string) => `${BASE_URL}/approval-workflows/institution/${institutionId}/${ruleId}`,
        ACTIVATE: (institutionId: string, ruleId: string) => `${BASE_URL}/approval-workflows/institution/${institutionId}/${ruleId}/activate`,
        DEACTIVATE: (institutionId: string, ruleId: string) => `${BASE_URL}/approval-workflows/institution/${institutionId}/${ruleId}/deactivate`,
    },
    // ---- end FW-3A ----
    INDIRECT_TAX: {
        PROFILE: (institutionId: string) => `${BASE_URL}/indirect-tax/profile/institution/${institutionId}`,
        PROFILE_SAVE: `${BASE_URL}/indirect-tax/profile`,
        CODES: (institutionId: string) => `${BASE_URL}/indirect-tax/codes/institution/${institutionId}`,
        CODES_SAVE: `${BASE_URL}/indirect-tax/codes`,
        CODE: (id: string) => `${BASE_URL}/indirect-tax/codes/${id}`,
        CODE_ACTIVE: (id: string, active: boolean) => `${BASE_URL}/indirect-tax/codes/${id}/active?active=${active}`,
        LOOKUP: (institutionId: string) => `${BASE_URL}/indirect-tax/codes/lookup/institution/${institutionId}`,
        LOAD_BD_DEFAULTS: (institutionId: string) => `${BASE_URL}/indirect-tax/defaults/bangladesh?institutionId=${institutionId}`,
        RETURN: (institutionId: string, date: string) => `${BASE_URL}/indirect-tax/return?institutionId=${institutionId}&date=${date}`,
        SETTLEMENTS: (institutionId: string) => `${BASE_URL}/indirect-tax/settlements/institution/${institutionId}`,
        SETTLE: `${BASE_URL}/indirect-tax/settlements`,
        REOPEN: (id: string) => `${BASE_URL}/indirect-tax/settlements/${id}/reopen`,
        PAY: `${BASE_URL}/indirect-tax/payments`,
        // Bangladesh Mushak pack (accounting wave 2, lane B)
        MUSHAK_ELIGIBILITY: (institutionId: string) => `${BASE_URL}/indirect-tax/mushak/eligibility/institution/${institutionId}`,
        MUSHAK_REGISTER: (form: '6.1' | '6.2', institutionId: string, from: string, to: string) =>
            `${BASE_URL}/indirect-tax/mushak/${form === '6.1' ? 'purchase' : 'sales'}-register?institutionId=${institutionId}&from=${from}&to=${to}`,
        MUSHAK_REGISTER_EXPORT: (form: '6.1' | '6.2', institutionId: string, from: string, to: string, format: 'xlsx' | 'csv') =>
            `${BASE_URL}/indirect-tax/mushak/${form === '6.1' ? 'purchase' : 'sales'}-register/export?institutionId=${institutionId}&from=${from}&to=${to}&format=${format}`,
        MUSHAK_91: (institutionId: string, date: string) =>
            `${BASE_URL}/indirect-tax/mushak/return-9-1?institutionId=${institutionId}&date=${date}`,
        MUSHAK_91_PDF: (institutionId: string, date: string) =>
            `${BASE_URL}/indirect-tax/mushak/return-9-1/pdf?institutionId=${institutionId}&date=${date}`,
        MUSHAK_91_XLSX: (institutionId: string, date: string) =>
            `${BASE_URL}/indirect-tax/mushak/return-9-1/xlsx?institutionId=${institutionId}&date=${date}`,
        DOCUMENT_TAX_BREAKDOWN: (kind: 'sales-invoice' | 'supplier-bill', id: string) =>
            `${BASE_URL}/indirect-tax/documents/${kind}/${id}/breakdown`,
        MUSHAK_63_PDF: (invoiceId: string) => `${BASE_URL}/sales-invoice/${invoiceId}/mushak-6-3/pdf`,
        // ---- B4-A: Mushak 4.3 coefficient declarations, 6.10 statement, form settings ----
        MUSHAK_COEFFICIENTS: (institutionId: string) =>
            `${BASE_URL}/indirect-tax/mushak/coefficients?institutionId=${institutionId}`,
        MUSHAK_COEFFICIENT: (id: string, institutionId: string) =>
            `${BASE_URL}/indirect-tax/mushak/coefficients/${id}?institutionId=${institutionId}`,
        MUSHAK_COEFFICIENT_ACTION: (id: string, action: 'submit' | 'return-to-draft' | 'accept' | 'pdf' | 'xlsx', institutionId: string) =>
            `${BASE_URL}/indirect-tax/mushak/coefficients/${id}/${action}?institutionId=${institutionId}`,
        MUSHAK_COEFFICIENT_PREFILL: (kind: 'style' | 'item', refId: string, institutionId: string) =>
            `${BASE_URL}/indirect-tax/mushak/coefficients/prefill/${kind}/${refId}?institutionId=${institutionId}`,
        MUSHAK_CONSUMPTION_CHECK: (institutionId: string, buyerOrderId: string) =>
            `${BASE_URL}/indirect-tax/mushak/coefficients/consumption-check?institutionId=${institutionId}&buyerOrderId=${buyerOrderId}`,
        MUSHAK_610: (institutionId: string, from: string, to: string, format?: 'pdf' | 'xlsx') =>
            `${BASE_URL}/indirect-tax/mushak/6-10${format ? `/${format}` : ''}?institutionId=${institutionId}&from=${from}&to=${to}`,
        MUSHAK_FORM_SETTINGS: (institutionId: string) =>
            `${BASE_URL}/indirect-tax/mushak/form-settings?institutionId=${institutionId}`,
        MUSHAK_FORM_DEFAULTS: (institutionId: string) =>
            `${BASE_URL}/indirect-tax/mushak/form-settings/load-defaults?institutionId=${institutionId}`,
        // ---- end B4-A ----
    },
    // Exchange rates + unrealised FX revaluation (accounting wave 2, lane I). Mirrors backend
    // EndPoint.ExchangeRate ("api/exchange-rate") and EndPoint.FxRevaluation ("api/fx-revaluation").
    EXCHANGE_RATE: {
        LIST: (institutionId: string) => `${BASE_URL}/exchange-rate/institution/${institutionId}`,
        LATEST: (institutionId: string) => `${BASE_URL}/exchange-rate/institution/${institutionId}/latest`,
        IMPORT: (institutionId: string) => `${BASE_URL}/exchange-rate/institution/${institutionId}/import`,
        ITEM: (institutionId: string, id: string) => `${BASE_URL}/exchange-rate/institution/${institutionId}/${id}`,
    },
    FX_REVALUATION: {
        PREVIEW: (institutionId: string) => `${BASE_URL}/fx-revaluation/institution/${institutionId}/preview`,
        EXPOSURE: (institutionId: string) => `${BASE_URL}/fx-revaluation/institution/${institutionId}/exposure`,
        RUNS: (institutionId: string) => `${BASE_URL}/fx-revaluation/institution/${institutionId}/runs`,
        RUN: (institutionId: string, runId: string) => `${BASE_URL}/fx-revaluation/institution/${institutionId}/runs/${runId}`,
        UNDO: (institutionId: string, runId: string) => `${BASE_URL}/fx-revaluation/institution/${institutionId}/runs/${runId}/undo`,
    },
    // W2-C: VDS / supplier-TDS withholding on supplier payments.
    WITHHOLDING: {
        SETTINGS: (institutionId: string) => `${BASE_URL}/withholding/settings/institution/${institutionId}`,
        RULES: (institutionId: string) => `${BASE_URL}/withholding/rules/institution/${institutionId}`,
        RULE: (institutionId: string, id: string) => `${BASE_URL}/withholding/rules/institution/${institutionId}/${id}`,
        RULE_ACTIVE: (institutionId: string, id: string, active: boolean) =>
            `${BASE_URL}/withholding/rules/institution/${institutionId}/${id}/active?active=${active}`,
        LOAD_DEFAULTS: (institutionId: string) =>
            `${BASE_URL}/withholding/rules/institution/${institutionId}/load-bangladesh-defaults`,
        SUPPLIER_DEFAULTS: (supplierId: string) => `${BASE_URL}/withholding/supplier/${supplierId}/defaults`,
        PROPOSAL: `${BASE_URL}/withholding/proposal`,
        FOR_PAYMENT: (paymentId: string) => `${BASE_URL}/withholding/payment/${paymentId}`,
        CERTIFICATE_PDF: (id: string) => `${BASE_URL}/withholding/certificate/${id}/pdf`,
        DEPOSITS: (institutionId: string) => `${BASE_URL}/withholding/deposits/institution/${institutionId}`,
        UNDEPOSITED: (institutionId: string) => `${BASE_URL}/withholding/deposits/institution/${institutionId}/undeposited`,
        UNDEPOSITED_SUMMARY: (institutionId: string) => `${BASE_URL}/withholding/deposits/institution/${institutionId}/undeposited-summary`,
        DEPOSIT_REVERSE: (id: string) => `${BASE_URL}/withholding/deposits/${id}/reverse`,
        REGISTER: (institutionId: string) => `${BASE_URL}/withholding/register/institution/${institutionId}`,
        REGISTER_EXPORT: (institutionId: string) => `${BASE_URL}/withholding/register/institution/${institutionId}/export`,
    },
    // ---- W3-E: credit notes, debit notes, supplier advances, shared allocation
    CREDIT_NOTE: {
        CREATE: `${BASE_URL}/credit-note`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/credit-note/institution/${institutionId}`,
        LIST_BY_INVOICE: (invoiceId: string) => `${BASE_URL}/credit-note/invoice/${invoiceId}`,
        CREDITABLE_LINES: (invoiceId: string) => `${BASE_URL}/credit-note/invoice/${invoiceId}/creditable-lines`,
        GET_BY_ID: (id: string) => `${BASE_URL}/credit-note/${id}`,
        VOID: (id: string) => `${BASE_URL}/credit-note/${id}/void`,
        REFUNDS: (id: string) => `${BASE_URL}/credit-note/${id}/refund`,
        REVERSE_REFUND: (refundId: string) => `${BASE_URL}/credit-note/refund/${refundId}/reverse`,
        PDF: (id: string) => `${BASE_URL}/credit-note/${id}/pdf`,
        EMAIL: (id: string) => `${BASE_URL}/credit-note/${id}/email`,
    },
    DEBIT_NOTE: {
        CREATE: `${BASE_URL}/debit-note`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/debit-note/institution/${institutionId}`,
        LIST_BY_BILL: (billId: string) => `${BASE_URL}/debit-note/bill/${billId}`,
        DEBITABLE_LINES: (billId: string) => `${BASE_URL}/debit-note/bill/${billId}/debitable-lines`,
        GET_BY_ID: (id: string) => `${BASE_URL}/debit-note/${id}`,
        VOID: (id: string) => `${BASE_URL}/debit-note/${id}/void`,
        PDF: (id: string) => `${BASE_URL}/debit-note/${id}/pdf`,
    },
    SUPPLIER_ADVANCE: {
        CREATE: `${BASE_URL}/supplier-advance`,
        LIST_BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/supplier-advance/institution/${institutionId}`,
        AGEING: (institutionId: string) => `${BASE_URL}/supplier-advance/institution/${institutionId}/ageing`,
        LIST_BY_SUPPLIER: (supplierId: string) => `${BASE_URL}/supplier-advance/supplier/${supplierId}`,
        LIST_BY_PO: (poId: string) => `${BASE_URL}/supplier-advance/purchase-order/${poId}`,
        GET_BY_ID: (id: string) => `${BASE_URL}/supplier-advance/${id}`,
        REVERSE: (id: string) => `${BASE_URL}/supplier-advance/${id}/reverse`,
    },
    ALLOCATION: {
        CREATE: `${BASE_URL}/allocation`,
        REVERSE: (id: string) => `${BASE_URL}/allocation/${id}/reverse`,
        FOR_CREDIT: (type: string, id: string) => `${BASE_URL}/allocation/credit/${type}/${id}`,
        FOR_TARGET: (type: string, id: string) => `${BASE_URL}/allocation/target/${type}/${id}`,
        OPEN_CREDITS: `${BASE_URL}/allocation/open-credits`,
    },
    // W3-S notifications and reminder engine
    NOTIFICATIONS: {
        BASE: `${BASE_URL}/notifications`,
        UNREAD_COUNT: `${BASE_URL}/notifications/unread-count`,
        READ: (id: string) => `${BASE_URL}/notifications/${id}/read`,
        READ_ALL: `${BASE_URL}/notifications/read-all`,
        PREFERENCES: `${BASE_URL}/notifications/preferences`,
        RULES: `${BASE_URL}/notifications/rules`,
        RULE: (id: string) => `${BASE_URL}/notifications/rules/${id}`,
        LOAD_DEFAULTS: `${BASE_URL}/notifications/rules/load-defaults`,
        RUN_NOW: `${BASE_URL}/notifications/rules/run-now`,
    },
    // ---- W3-B export finance (PC, B2B loan retirement) ----
    EXPORT_FINANCE: {
        B2B_RETIREMENT: `${BASE_URL}/export-finance/b2b-retirement`,
        PC_POSITION: (institutionId: string) => `${BASE_URL}/export-finance/institution/${institutionId}/pc-position`,
        SUMMARY: (institutionId: string) => `${BASE_URL}/export-finance/institution/${institutionId}/summary`,
    },
    // ---- end W3-B ----
    // W3-A bank borrowings register
    BORROWING: {
        FACILITIES: (institutionId: string) => `${BASE_URL}/borrowing/facility/institution/${institutionId}`,
        FACILITY: (id: string) => `${BASE_URL}/borrowing/facility/${id}`,
        FACILITY_CREATE: `${BASE_URL}/borrowing/facility`,
        FACILITY_CLOSE: (id: string) => `${BASE_URL}/borrowing/facility/${id}/close`,
        FACILITY_REOPEN: (id: string) => `${BASE_URL}/borrowing/facility/${id}/reopen`,
        RATE_ADD: (id: string) => `${BASE_URL}/borrowing/facility/${id}/rate`,
        RATE_DELETE: (id: string, rateId: string) => `${BASE_URL}/borrowing/facility/${id}/rate/${rateId}`,
        COVENANTS: (institutionId: string) => `${BASE_URL}/borrowing/covenant/institution/${institutionId}`,
        COVENANT_EVALUATE: (institutionId: string) => `${BASE_URL}/borrowing/covenant/evaluate/${institutionId}`,
        COVENANT_CREATE: `${BASE_URL}/borrowing/covenant`,
        COVENANT: (id: string) => `${BASE_URL}/borrowing/covenant/${id}`,
        DRAWDOWNS: (facilityId: string) => `${BASE_URL}/borrowing/drawdown/facility/${facilityId}`,
        DRAWDOWN: (id: string) => `${BASE_URL}/borrowing/drawdown/${id}`,
        DRAWDOWN_CREATE: `${BASE_URL}/borrowing/drawdown`,
        DRAWDOWN_VOID: (id: string) => `${BASE_URL}/borrowing/drawdown/${id}/void`,
        REPAYMENTS: (facilityId: string) => `${BASE_URL}/borrowing/repayment/facility/${facilityId}`,
        REPAYMENT_PREVIEW: `${BASE_URL}/borrowing/repayment/preview`,
        REPAYMENT_CREATE: `${BASE_URL}/borrowing/repayment`,
        REPAYMENT_VOID: (id: string) => `${BASE_URL}/borrowing/repayment/${id}/void`,
        INTEREST_RUN: (institutionId: string) => `${BASE_URL}/borrowing/interest/run/${institutionId}`,
        INTEREST_RUNS: (institutionId: string) => `${BASE_URL}/borrowing/interest/runs/${institutionId}`,
        INTEREST_RUN_GET: (runId: string) => `${BASE_URL}/borrowing/interest/run/${runId}`,
        INTEREST_REGISTER: (institutionId: string) => `${BASE_URL}/borrowing/interest/register/${institutionId}`,
        INTEREST_LINE_VOID: (id: string) => `${BASE_URL}/borrowing/interest/line/${id}/void`,
        UTILISATION: (institutionId: string) => `${BASE_URL}/borrowing/report/utilisation/${institutionId}`,
        OD_POSITION: (institutionId: string) => `${BASE_URL}/borrowing/report/od-position/${institutionId}`,
        MATURITY: (institutionId: string) => `${BASE_URL}/borrowing/report/maturity/${institutionId}`,
        TIE_OUT: (institutionId: string) => `${BASE_URL}/borrowing/report/tie-out/${institutionId}`,
        DUE_ITEMS: (institutionId: string) => `${BASE_URL}/borrowing/report/due-items/${institutionId}`,
        REPAYMENTS_DUE: (institutionId: string) => `${BASE_URL}/borrowing/report/repayments-due/${institutionId}`,
    },
    // W3-C: inter-segment loans, reconciliation matrix, eliminations, cash by segment.
    INTER_SEGMENT: {
        SETTINGS: (institutionId: string) => `${BASE_URL}/inter-segment/settings/institution/${institutionId}`,
        SETTINGS_SAVE: `${BASE_URL}/inter-segment/settings`,
        SUGGESTED_ACCOUNTS: (institutionId: string) =>
            `${BASE_URL}/inter-segment/settings/suggested-accounts/institution/${institutionId}`,
        LOANS: (institutionId: string) => `${BASE_URL}/inter-segment/loans/institution/${institutionId}`,
        LOAN_CREATE: `${BASE_URL}/inter-segment/loans`,
        LOAN: (loanId: string) => `${BASE_URL}/inter-segment/loans/${loanId}`,
        ADVANCE: (loanId: string) => `${BASE_URL}/inter-segment/loans/${loanId}/advances`,
        REPAYMENT: (loanId: string) => `${BASE_URL}/inter-segment/loans/${loanId}/repayments`,
        INTEREST_PREVIEW: (loanId: string) => `${BASE_URL}/inter-segment/loans/${loanId}/interest-preview`,
        INTEREST: (loanId: string) => `${BASE_URL}/inter-segment/loans/${loanId}/interest`,
        REVERSE_EVENT: (loanId: string, eventId: string) =>
            `${BASE_URL}/inter-segment/loans/${loanId}/events/${eventId}/reverse`,
        CLOSE: (loanId: string) => `${BASE_URL}/inter-segment/loans/${loanId}/close`,
        ALLOCATE: `${BASE_URL}/inter-segment/allocations`,
        RECONCILIATION: (institutionId: string) => `${BASE_URL}/inter-segment/reconciliation/institution/${institutionId}`,
        ELIMINATION_BS: (institutionId: string) =>
            `${BASE_URL}/inter-segment/elimination/balance-sheet/institution/${institutionId}`,
        ELIMINATION_IS: (institutionId: string) =>
            `${BASE_URL}/inter-segment/elimination/income-statement/institution/${institutionId}`,
        CASH_BY_SEGMENT: (institutionId: string) => `${BASE_URL}/inter-segment/cash-by-segment/institution/${institutionId}`,
    },
    // W3-H: cheque register, cheque books, print layouts, bank guarantees, bank due items.
    CHEQUE: {
        LIST: (institutionId: string) => `${BASE_URL}/cheque/institution/${institutionId}`,
        GET: (id: string) => `${BASE_URL}/cheque/${id}`,
        REGISTER_RECEIVED: `${BASE_URL}/cheque/received`,
        REGISTER_ISSUED: `${BASE_URL}/cheque/issued`,
        UPDATE: (id: string) => `${BASE_URL}/cheque/${id}`,
        DEPOSIT: (id: string) => `${BASE_URL}/cheque/${id}/deposit`,
        CLEAR: (id: string) => `${BASE_URL}/cheque/${id}/clear`,
        BOUNCE: (id: string) => `${BASE_URL}/cheque/${id}/bounce`,
        RETURN: (id: string) => `${BASE_URL}/cheque/${id}/return`,
        RELEASE: (id: string) => `${BASE_URL}/cheque/${id}/release`,
        STOP: (id: string) => `${BASE_URL}/cheque/${id}/stop`,
        CANCEL: (id: string) => `${BASE_URL}/cheque/${id}/cancel`,
        PRINT: (id: string, layoutId?: string) =>
            `${BASE_URL}/cheque/${id}/print${layoutId ? `?layoutId=${layoutId}` : ''}`,
    },
    CHEQUE_BOOK: {
        LIST: (institutionId: string) => `${BASE_URL}/cheque-book/institution/${institutionId}`,
        BASE: `${BASE_URL}/cheque-book`,
        ONE: (id: string) => `${BASE_URL}/cheque-book/${id}`,
    },
    CHEQUE_LAYOUT: {
        LIST: (institutionId: string) => `${BASE_URL}/cheque-layout/institution/${institutionId}`,
        BASE: `${BASE_URL}/cheque-layout`,
        ONE: (id: string) => `${BASE_URL}/cheque-layout/${id}`,
        LOAD_DEFAULTS: (institutionId: string) => `${BASE_URL}/cheque-layout/institution/${institutionId}/load-defaults`,
    },
    BANK_GUARANTEE: {
        LIST: (institutionId: string) => `${BASE_URL}/bank-guarantee/institution/${institutionId}`,
        BASE: `${BASE_URL}/bank-guarantee`,
        ONE: (id: string) => `${BASE_URL}/bank-guarantee/${id}`,
        AMEND: (id: string) => `${BASE_URL}/bank-guarantee/${id}/amend`,
        COMMISSION: (id: string) => `${BASE_URL}/bank-guarantee/${id}/commission`,
        RELEASE: (id: string) => `${BASE_URL}/bank-guarantee/${id}/release`,
        INVOKE: (id: string) => `${BASE_URL}/bank-guarantee/${id}/invoke`,
        EXPIRE_LAPSED: (institutionId: string) => `${BASE_URL}/bank-guarantee/institution/${institutionId}/expire-lapsed`,
    },
    BANK_DUE_ITEMS: {
        LIST: (institutionId: string, from: string, to: string) =>
            `${BASE_URL}/bank-due-items/institution/${institutionId}?from=${from}&to=${to}`,
    },
    // ---- W3-D employee loans and salary advances
    EMPLOYEE_LOANS: {
        LIST: (institutionId: string) => `${BASE_URL}/employee-loans/institution/${institutionId}`,
        OUTSTANDING: (institutionId: string, asOf?: string) =>
            `${BASE_URL}/employee-loans/outstanding/institution/${institutionId}${asOf ? `?asOf=${asOf}` : ''}`,
        RECLASS: (institutionId: string) => `${BASE_URL}/employee-loans/reclass/institution/${institutionId}`,
        OPENING_BALANCE: (institutionId: string) => `${BASE_URL}/employee-loans/opening-balance/institution/${institutionId}`,
        CREATE: `${BASE_URL}/employee-loans`,
        BY_ID: (id: string) => `${BASE_URL}/employee-loans/${id}`,
        APPROVE: (id: string) => `${BASE_URL}/employee-loans/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/employee-loans/${id}/reject`,
        CANCEL: (id: string) => `${BASE_URL}/employee-loans/${id}/cancel`,
        DISBURSE: (id: string) => `${BASE_URL}/employee-loans/${id}/disburse`,
        REPAY: (id: string) => `${BASE_URL}/employee-loans/${id}/repay`,
        WRITE_OFF: (id: string) => `${BASE_URL}/employee-loans/${id}/write-off`,
        HOLD_INSTALLMENT: (installmentId: string) => `${BASE_URL}/employee-loans/installments/${installmentId}/hold`,
        BATCHES: (institutionId: string) => `${BASE_URL}/employee-loans/batches/institution/${institutionId}`,
        BATCH_CREATE: `${BASE_URL}/employee-loans/batches`,
        BATCH: (id: string) => `${BASE_URL}/employee-loans/batches/${id}`,
        BATCH_FILE: (id: string) => `${BASE_URL}/employee-loans/batches/${id}/file`,
        BATCH_DISBURSE: (id: string, date?: string) =>
            `${BASE_URL}/employee-loans/batches/${id}/disburse${date ? `?date=${date}` : ''}`,
        BATCH_CANCEL: (id: string) => `${BASE_URL}/employee-loans/batches/${id}/cancel`,
        MY_REQUEST: `${BASE_URL}/my-loans`,
        MY_LIST: (institutionId: string, page = 0, size = 20) =>
            `${BASE_URL}/my-loans/institution/${institutionId}?page=${page}&size=${size}`,
        MY_BY_ID: (id: string) => `${BASE_URL}/my-loans/${id}`,
        MY_CANCEL: (id: string) => `${BASE_URL}/my-loans/${id}/cancel`,
    },
    // ---- W3-P payment runs, supplier bank master, approval bands, bank-file templates
    PAYMENT_RUN: {
        PROPOSE: `${BASE_URL}/payment-run/propose`,
        CREATE: `${BASE_URL}/payment-run`,
        BY_ID: (id: string) => `${BASE_URL}/payment-run/${id}`,
        LIST: (institutionId: string, status?: string, page = 0, size = 20) =>
            `${BASE_URL}/payment-run/institution/${institutionId}?page=${page}&size=${size}${status ? `&status=${status}` : ''}`,
        SUBMIT: (id: string) => `${BASE_URL}/payment-run/${id}/submit`,
        APPROVE: (id: string) => `${BASE_URL}/payment-run/${id}/approve`,
        REJECT: (id: string) => `${BASE_URL}/payment-run/${id}/reject`,
        REVISE: (id: string) => `${BASE_URL}/payment-run/${id}/revise`,
        CANCEL: (id: string) => `${BASE_URL}/payment-run/${id}/cancel`,
        EXECUTE: (id: string) => `${BASE_URL}/payment-run/${id}/execute`,
        REVERSE: (id: string) => `${BASE_URL}/payment-run/${id}/reverse`,
        REVERSE_LINE: (lineId: string) => `${BASE_URL}/payment-run/line/${lineId}/reverse`,
        BANK_FILE_PREVIEW: (id: string, templateId?: string) =>
            `${BASE_URL}/payment-run/${id}/bank-file/preview${templateId ? `?templateId=${templateId}` : ''}`,
        BANK_FILE: (id: string, templateId?: string) =>
            `${BASE_URL}/payment-run/${id}/bank-file${templateId ? `?templateId=${templateId}` : ''}`,
        ADVICE_PDF: (id: string, supplierId: string) => `${BASE_URL}/payment-run/${id}/remittance-advice/${supplierId}/pdf`,
        ADVICE_EMAIL: (id: string, supplierId: string) => `${BASE_URL}/payment-run/${id}/remittance-advice/${supplierId}/email`,
        SETTINGS: (institutionId: string) => `${BASE_URL}/payment-run/settings/institution/${institutionId}`,
        BLOCKED_BILLS: (institutionId: string) => `${BASE_URL}/supplier-bill/institution/${institutionId}/blocked`,
    },
    SUPPLIER_BANK_ACCOUNT: {
        PROFILE: (supplierId: string) => `${BASE_URL}/supplier-bank-account/supplier/${supplierId}`,
        CREATE: `${BASE_URL}/supplier-bank-account`,
        BY_ID: (id: string) => `${BASE_URL}/supplier-bank-account/${id}`,
        MAKE_DEFAULT: (id: string) => `${BASE_URL}/supplier-bank-account/${id}/default`,
        DISCOUNT_TERMS: (supplierId: string) => `${BASE_URL}/supplier-bank-account/supplier/${supplierId}/discount-terms`,
    },
    PAYMENT_APPROVAL_BAND: {
        LIST: (institutionId: string) => `${BASE_URL}/payment-approval-band/institution/${institutionId}`,
        CREATE: `${BASE_URL}/payment-approval-band`,
        BY_ID: (id: string) => `${BASE_URL}/payment-approval-band/${id}`,
    },
    BANK_FILE_TEMPLATE: {
        LIST: (institutionId: string) => `${BASE_URL}/bank-file-template/institution/${institutionId}`,
        FIELDS: `${BASE_URL}/bank-file-template/fields`,
        CREATE: `${BASE_URL}/bank-file-template`,
        BY_ID: (id: string) => `${BASE_URL}/bank-file-template/${id}`,
        LOAD_DEFAULTS: (institutionId: string) => `${BASE_URL}/bank-file-template/institution/${institutionId}/load-defaults`,
    },
    // ---- end W3-P
    // W3-Q: treasury desk (cash position, transfers, FDRs, petty cash)
    TREASURY: {
        CASH_POSITION: (institutionId: string) => `${BASE_URL}/treasury/cash-position/institution/${institutionId}`,
        CASH_POSITION_XLSX: (institutionId: string) => `${BASE_URL}/treasury/cash-position/institution/${institutionId}/xlsx`,
        SETTINGS: (institutionId: string) => `${BASE_URL}/treasury/settings/institution/${institutionId}`,
        SETTINGS_SAVE: `${BASE_URL}/treasury/settings`,
        SUGGESTED_ACCOUNTS: (institutionId: string) => `${BASE_URL}/treasury/settings/institution/${institutionId}/suggested-accounts`,
    },
    BANK_TRANSFER: {
        LIST: (institutionId: string) => `${BASE_URL}/bank-transfer/institution/${institutionId}`,
        BASE: `${BASE_URL}/bank-transfer`,
        ONE: (id: string) => `${BASE_URL}/bank-transfer/${id}`,
        ACTION: (id: string, action: string) => `${BASE_URL}/bank-transfer/${id}/${action}`,
    },
    FDR: {
        LIST: (institutionId: string) => `${BASE_URL}/fdr/institution/${institutionId}`,
        BASE: `${BASE_URL}/fdr`,
        ONE: (id: string) => `${BASE_URL}/fdr/${id}`,
        LIEN: (id: string) => `${BASE_URL}/fdr/${id}/lien`,
        LIEN_RELEASE: (id: string) => `${BASE_URL}/fdr/${id}/lien/release`,
        ENCASH: (id: string) => `${BASE_URL}/fdr/${id}/encash`,
        RENEW: (id: string) => `${BASE_URL}/fdr/${id}/renew`,
        INTEREST_RUN: `${BASE_URL}/fdr/interest-run`,
        INTEREST_RUNS: (institutionId: string) => `${BASE_URL}/fdr/interest-run/institution/${institutionId}`,
        INTEREST_RUN_GET: (runId: string) => `${BASE_URL}/fdr/interest-run/${runId}`,
        INTEREST_REGISTER: (institutionId: string) => `${BASE_URL}/fdr/interest-line/institution/${institutionId}`,
        INTEREST_LINE_VOID: (lineId: string) => `${BASE_URL}/fdr/interest-line/${lineId}/void`,
    },
    PETTY_CASH: {
        FUNDS: (institutionId: string) => `${BASE_URL}/petty-cash/institution/${institutionId}/funds`,
        MY_FUNDS: `${BASE_URL}/petty-cash/my/funds`,
        FUND: `${BASE_URL}/petty-cash/fund`,
        FUND_ONE: (id: string) => `${BASE_URL}/petty-cash/fund/${id}`,
        FUND_EXPENSE_ACCOUNTS: (id: string) => `${BASE_URL}/petty-cash/fund/${id}/expense-accounts`,
        FUND_CLOSE: (id: string) => `${BASE_URL}/petty-cash/fund/${id}/close`,
        FUND_VOUCHERS: (id: string) => `${BASE_URL}/petty-cash/fund/${id}/vouchers`,
        PROPOSAL: (id: string) => `${BASE_URL}/petty-cash/fund/${id}/replenishment-proposal`,
        VOUCHER: `${BASE_URL}/petty-cash/voucher`,
        VOUCHER_VOID: (id: string) => `${BASE_URL}/petty-cash/voucher/${id}/void`,
        RECEIPTS: (id: string) => `${BASE_URL}/petty-cash/voucher/${id}/receipts`,
        RECEIPT_DOWNLOAD: (id: string, attachmentId: string) => `${BASE_URL}/petty-cash/voucher/${id}/receipts/${attachmentId}/download`,
        REPLENISHMENT: `${BASE_URL}/petty-cash/replenishment`,
        REPLENISHMENT_VOID: (id: string) => `${BASE_URL}/petty-cash/replenishment/${id}/void`,
        COUNT: `${BASE_URL}/petty-cash/count`,
    },
    // ---- W3-L 13-week cash forecast (read-only; settings + manual adjustment lines)
    CASH_FORECAST: {
        GRID: (institutionId: string) => `${BASE_URL}/cash-forecast/institution/${institutionId}`,
        ITEMS: (institutionId: string) => `${BASE_URL}/cash-forecast/institution/${institutionId}/items`,
        XLSX: (institutionId: string) => `${BASE_URL}/cash-forecast/institution/${institutionId}/xlsx`,
        SETTINGS: (institutionId: string) => `${BASE_URL}/cash-forecast/settings/${institutionId}`,
        ADJUSTMENTS: (institutionId: string) => `${BASE_URL}/cash-forecast/adjustments/${institutionId}`,
        ADJUSTMENT: (institutionId: string, id: string) => `${BASE_URL}/cash-forecast/adjustments/${institutionId}/${id}`,
    },
    // W3-G corporate tax: AIT credit ledger, computation + provision, deferred tax, challan payments, AIT set-off.
    CORPORATE_TAX: {
        SETTINGS: (institutionId: string) => `${BASE_URL}/corporate-tax/settings/institution/${institutionId}`,
        DETECT_AIT: (institutionId: string) => `${BASE_URL}/corporate-tax/settings/institution/${institutionId}/detect-ait`,
        SUGGESTED_ACCOUNTS: (institutionId: string) =>
            `${BASE_URL}/corporate-tax/settings/institution/${institutionId}/suggested-accounts`,
        RATES: (institutionId: string) => `${BASE_URL}/corporate-tax/rates/institution/${institutionId}`,
        RATE: (institutionId: string, id: string) => `${BASE_URL}/corporate-tax/rates/institution/${institutionId}/${id}`,
        LOAD_DEFAULTS: (institutionId: string) =>
            `${BASE_URL}/corporate-tax/rates/institution/${institutionId}/load-defaults`,
        LEDGER: (institutionId: string) => `${BASE_URL}/corporate-tax/ledger/institution/${institutionId}`,
        EVIDENCE: (institutionId: string, lineId: string) =>
            `${BASE_URL}/corporate-tax/evidence/institution/${institutionId}/line/${lineId}`,
        COMPUTATIONS: (institutionId: string) => `${BASE_URL}/corporate-tax/computation/institution/${institutionId}`,
        COMPUTATION: (institutionId: string, id: string) =>
            `${BASE_URL}/corporate-tax/computation/institution/${institutionId}/${id}`,
        COMPUTATION_PREVIEW: (institutionId: string) =>
            `${BASE_URL}/corporate-tax/computation/institution/${institutionId}/preview`,
        COMPUTATION_POST: (institutionId: string, id: string) =>
            `${BASE_URL}/corporate-tax/computation/institution/${institutionId}/${id}/post`,
        COMPUTATION_REVERSE: (institutionId: string, id: string) =>
            `${BASE_URL}/corporate-tax/computation/institution/${institutionId}/${id}/reverse`,
        DEFERRED_LIST: (institutionId: string) => `${BASE_URL}/corporate-tax/deferred/institution/${institutionId}`,
        DEFERRED: (institutionId: string, id: string) => `${BASE_URL}/corporate-tax/deferred/institution/${institutionId}/${id}`,
        DEFERRED_PREVIEW: (institutionId: string) =>
            `${BASE_URL}/corporate-tax/deferred/institution/${institutionId}/preview`,
        DEFERRED_POST: (institutionId: string, id: string) =>
            `${BASE_URL}/corporate-tax/deferred/institution/${institutionId}/${id}/post`,
        DEFERRED_REVERSE: (institutionId: string, id: string) =>
            `${BASE_URL}/corporate-tax/deferred/institution/${institutionId}/${id}/reverse`,
        PAYMENTS: (institutionId: string) => `${BASE_URL}/corporate-tax/payment/institution/${institutionId}`,
        PAYMENT_REVERSE: (institutionId: string, id: string) =>
            `${BASE_URL}/corporate-tax/payment/institution/${institutionId}/${id}/reverse`,
        SET_OFFS: (institutionId: string) => `${BASE_URL}/corporate-tax/set-off/institution/${institutionId}`,
        SET_OFF_REVERSE: (institutionId: string, id: string) =>
            `${BASE_URL}/corporate-tax/set-off/institution/${institutionId}/${id}/reverse`,
    },
    // ---- W3-R compliance: salary-TDS deposits, statutory remittances, funding check, close checklist, filing calendar
    SALARY_TAX_DEPOSIT: {
        LIST: (institutionId: string, year?: number) =>
            `${BASE_URL}/salary-tax-deposit/institution/${institutionId}${year ? `?year=${year}` : ''}`,
        REGISTER: (institutionId: string, year: number) =>
            `${BASE_URL}/salary-tax-deposit/institution/${institutionId}/register?year=${year}`,
        SUGGESTION: (institutionId: string, year: number, month: number) =>
            `${BASE_URL}/salary-tax-deposit/institution/${institutionId}/suggestion?year=${year}&month=${month}`,
        CREATE: (institutionId: string) => `${BASE_URL}/salary-tax-deposit/institution/${institutionId}`,
        REVERSE: (id: string) => `${BASE_URL}/salary-tax-deposit/${id}/reverse`,
    },
    STATUTORY_REMITTANCE: {
        LIST: (institutionId: string) => `${BASE_URL}/statutory-remittance/institution/${institutionId}`,
        SUGGESTION: (institutionId: string) => `${BASE_URL}/statutory-remittance/institution/${institutionId}/suggestion`,
        CREATE: (institutionId: string) => `${BASE_URL}/statutory-remittance/institution/${institutionId}`,
        REVERSE: (id: string) => `${BASE_URL}/statutory-remittance/${id}/reverse`,
    },
    PAYROLL_FUNDING_CHECK: {
        CHECK: (institutionId: string) => `${BASE_URL}/payroll/funding-check/institution/${institutionId}`,
    },
    CLOSE_CHECKLIST: {
        TEMPLATES: (institutionId: string) => `${BASE_URL}/close-checklist/templates/institution/${institutionId}`,
        TEMPLATE: (id: string) => `${BASE_URL}/close-checklist/templates/${id}`,
        LOAD_DEFAULTS: (institutionId: string) => `${BASE_URL}/close-checklist/templates/institution/${institutionId}/load-defaults`,
        PERIODS: (institutionId: string, year?: number) =>
            `${BASE_URL}/close-checklist/periods/institution/${institutionId}${year ? `?year=${year}` : ''}`,
        PERIOD: (id: string) => `${BASE_URL}/close-checklist/periods/${id}`,
        TASK_STATUS: (taskId: string) => `${BASE_URL}/close-checklist/tasks/${taskId}/status`,
        TASK_OWNER: (taskId: string) => `${BASE_URL}/close-checklist/tasks/${taskId}/owner`,
        SIGN_OFF: (id: string) => `${BASE_URL}/close-checklist/periods/${id}/sign-off`,
        REOPEN: (id: string) => `${BASE_URL}/close-checklist/periods/${id}/reopen`,
        GATE: (institutionId: string) => `${BASE_URL}/close-checklist/gate/institution/${institutionId}`,
    },
    COMPLIANCE: {
        OBLIGATIONS: (institutionId: string) => `${BASE_URL}/compliance/obligations/institution/${institutionId}`,
        OBLIGATION: (id: string) => `${BASE_URL}/compliance/obligations/${id}`,
        LOAD_DEFAULTS: (institutionId: string) => `${BASE_URL}/compliance/obligations/institution/${institutionId}/load-defaults`,
        TASKS: (institutionId: string) => `${BASE_URL}/compliance/tasks/institution/${institutionId}`,
        TASK: (id: string) => `${BASE_URL}/compliance/tasks/${id}`,
    },
    // ---- end W3-R
    // ---- W3-J statutory provisions (gratuity, festival bonus) and provident fund
    PAYROLL_PROVISIONS: {
        SETTINGS: (institutionId: string) => `${BASE_URL}/payroll-provisions/settings/institution/${institutionId}`,
        SUGGESTED_ACCOUNTS: (institutionId: string) =>
            `${BASE_URL}/payroll-provisions/settings/institution/${institutionId}/suggested-accounts`,
        GRATUITY_RUNS: (institutionId: string) => `${BASE_URL}/payroll-provisions/gratuity/institution/${institutionId}/runs`,
        GRATUITY_PREVIEW: (institutionId: string) => `${BASE_URL}/payroll-provisions/gratuity/institution/${institutionId}/preview`,
        GRATUITY_RUN: (runId: string) => `${BASE_URL}/payroll-provisions/gratuity/runs/${runId}`,
        GRATUITY_REVERSE: (runId: string) => `${BASE_URL}/payroll-provisions/gratuity/runs/${runId}/reverse`,
        FESTIVAL_PLANS: (institutionId: string) => `${BASE_URL}/payroll-provisions/festival/institution/${institutionId}/plans`,
        FESTIVAL_PLAN: (planId: string) => `${BASE_URL}/payroll-provisions/festival/plans/${planId}`,
        FESTIVAL_RUNS: (institutionId: string) => `${BASE_URL}/payroll-provisions/festival/institution/${institutionId}/runs`,
        FESTIVAL_PREVIEW: (institutionId: string) => `${BASE_URL}/payroll-provisions/festival/institution/${institutionId}/preview`,
        FESTIVAL_RUN: (runId: string) => `${BASE_URL}/payroll-provisions/festival/runs/${runId}`,
        FESTIVAL_REVERSE: (runId: string) => `${BASE_URL}/payroll-provisions/festival/runs/${runId}/reverse`,
    },
    PROVIDENT_FUND: {
        SETTINGS: (institutionId: string) => `${BASE_URL}/provident-fund/settings/institution/${institutionId}`,
        MEMBERS: (institutionId: string) => `${BASE_URL}/provident-fund/members/institution/${institutionId}`,
        MEMBER: (memberId: string) => `${BASE_URL}/provident-fund/members/${memberId}`,
        MEMBER_LEDGER: (memberId: string) => `${BASE_URL}/provident-fund/members/${memberId}/ledger`,
        MEMBER_STATEMENT: (memberId: string) => `${BASE_URL}/provident-fund/members/${memberId}/statement.pdf`,
        RUNS: (institutionId: string) => `${BASE_URL}/provident-fund/runs/institution/${institutionId}`,
        RUN_PREVIEW: (institutionId: string) => `${BASE_URL}/provident-fund/runs/institution/${institutionId}/preview`,
        RUN: (runId: string) => `${BASE_URL}/provident-fund/runs/${runId}`,
        RUN_REVERSE: (runId: string) => `${BASE_URL}/provident-fund/runs/${runId}/reverse`,
        PROFIT: (institutionId: string) => `${BASE_URL}/provident-fund/profit/institution/${institutionId}`,
        PROFIT_PREVIEW: (institutionId: string) => `${BASE_URL}/provident-fund/profit/institution/${institutionId}/preview`,
        PROFIT_REVERSE: (institutionId: string, year: number) =>
            `${BASE_URL}/provident-fund/profit/institution/${institutionId}/year/${year}/reverse`,
    },
    MY_PROVIDENT_FUND: {
        MINE: (institutionId: string) => `${BASE_URL}/my-provident-fund/institution/${institutionId}`,
        STATEMENT: (institutionId: string) => `${BASE_URL}/my-provident-fund/institution/${institutionId}/statement.pdf`,
    },
    // ---- W3-W garments compliance finance ----
    UD_RECONCILIATION: {
        STATEMENT: (institutionId: string, udId: string) => `${BASE_URL}/ud-reconciliation/institution/${institutionId}/${udId}`,
        XLSX: (institutionId: string, udId: string) => `${BASE_URL}/ud-reconciliation/institution/${institutionId}/${udId}/xlsx`,
        PDF: (institutionId: string, udId: string) => `${BASE_URL}/ud-reconciliation/institution/${institutionId}/${udId}/pdf`,
        ORDERS: (institutionId: string, udId: string) => `${BASE_URL}/ud-reconciliation/institution/${institutionId}/${udId}/orders`,
        ORDER: (institutionId: string, udId: string, linkId: string) => `${BASE_URL}/ud-reconciliation/institution/${institutionId}/${udId}/orders/${linkId}`,
        LINE_ITEM: (institutionId: string, udId: string, lineId: string) => `${BASE_URL}/ud-reconciliation/institution/${institutionId}/${udId}/lines/${lineId}/item`,
    },
    EXP_OVERDUE: {
        WORKLIST: (institutionId: string) => `${BASE_URL}/exp-overdue/institution/${institutionId}/worklist`,
        OPEN: (institutionId: string, expId: string) => `${BASE_URL}/exp-overdue/institution/${institutionId}/open/${expId}`,
        CASE: (institutionId: string, caseId: string) => `${BASE_URL}/exp-overdue/institution/${institutionId}/cases/${caseId}`,
        TRANSITION: (institutionId: string, caseId: string) => `${BASE_URL}/exp-overdue/institution/${institutionId}/cases/${caseId}/transition`,
        NOTES: (institutionId: string, caseId: string) => `${BASE_URL}/exp-overdue/institution/${institutionId}/cases/${caseId}/notes`,
    },
    REALISATION_PERFORMANCE: {
        REPORT: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/realisation-performance`,
        XLSX: (institutionId: string) => `${BASE_URL}/commercial-report/institution/${institutionId}/realisation-performance/xlsx`,
    },
    // ---- end W3-W ----
    // ---- W3-U expense v2 (limits, rates, corporate cards) ----
    EXPENSE_RULES: {
        GRADES: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/grades`,
        GRADE_CREATE: `${BASE_URL}/expense-rules/grades`,
        GRADE: (id: string) => `${BASE_URL}/expense-rules/grades/${id}`,
        GRADE_ACTIVE: (id: string) => `${BASE_URL}/expense-rules/grades/${id}/active`,
        GRADES_SUGGEST: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/grades/suggest-from-wage-grades`,
        ASSIGNMENTS: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/grade-assignments`,
        ASSIGNMENT_CREATE: `${BASE_URL}/expense-rules/grade-assignments`,
        ASSIGNMENT: (id: string) => `${BASE_URL}/expense-rules/grade-assignments/${id}`,
        LIMITS: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/limits`,
        LIMIT_CREATE: `${BASE_URL}/expense-rules/limits`,
        LIMIT: (id: string) => `${BASE_URL}/expense-rules/limits/${id}`,
        LOCATIONS: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/locations`,
        LOCATION_CREATE: `${BASE_URL}/expense-rules/locations`,
        LOCATION: (id: string) => `${BASE_URL}/expense-rules/locations/${id}`,
        LOCATION_ACTIVE: (id: string) => `${BASE_URL}/expense-rules/locations/${id}/active`,
        PER_DIEM_RATES: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/per-diem-rates`,
        PER_DIEM_RATE_CREATE: `${BASE_URL}/expense-rules/per-diem-rates`,
        PER_DIEM_RATE: (id: string) => `${BASE_URL}/expense-rules/per-diem-rates/${id}`,
        MILEAGE_RATES: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/mileage-rates`,
        MILEAGE_RATE_CREATE: `${BASE_URL}/expense-rules/mileage-rates`,
        MILEAGE_RATE: (id: string) => `${BASE_URL}/expense-rules/mileage-rates/${id}`,
        LOAD_DEFAULTS: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/load-defaults`,
        LOOKUPS: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/lookups`,
        QUOTE: (inst: string) => `${BASE_URL}/expense-rules/institution/${inst}/quote`,
    },
    EXPENSE_CARD: {
        CARDS: (inst: string) => `${BASE_URL}/expense-card/institution/${inst}/cards`,
        CARD: (inst: string, id: string) => `${BASE_URL}/expense-card/institution/${inst}/cards/${id}`,
        CARD_ACTIVE: (inst: string, id: string) => `${BASE_URL}/expense-card/institution/${inst}/cards/${id}/active`,
        IMPORT_PREVIEW: (inst: string, cardId: string) => `${BASE_URL}/expense-card/institution/${inst}/cards/${cardId}/statements/preview`,
        IMPORT_COMMIT: (inst: string, cardId: string) => `${BASE_URL}/expense-card/institution/${inst}/cards/${cardId}/statements`,
        STATEMENTS: (inst: string) => `${BASE_URL}/expense-card/institution/${inst}/statements`,
        STATEMENT: (inst: string, id: string) => `${BASE_URL}/expense-card/institution/${inst}/statements/${id}`,
        STATEMENT_PAY: (inst: string, id: string) => `${BASE_URL}/expense-card/institution/${inst}/statements/${id}/pay`,
        TRANSACTIONS: (inst: string) => `${BASE_URL}/expense-card/institution/${inst}/transactions`,
        MY_TRANSACTIONS: (inst: string) => `${BASE_URL}/expense-card/institution/${inst}/transactions/mine`,
        PERSONAL: (inst: string, id: string) => `${BASE_URL}/expense-card/institution/${inst}/transactions/${id}/personal`,
        WRITE_TO_RECEIVABLE: (inst: string, id: string) => `${BASE_URL}/expense-card/institution/${inst}/transactions/${id}/write-to-receivable`,
    },
    // ---- end W3-U ----
    // ---- W3-M inter-company ----
    INSTITUTION_GROUP: {
        BASE: `${BASE_URL}/institution-group`,
        ONE: (groupId: string) => `${BASE_URL}/institution-group/${groupId}`,
        MEMBERS: (groupId: string) => `${BASE_URL}/institution-group/${groupId}/members`,
        MEMBER: (groupId: string, memberId: string) => `${BASE_URL}/institution-group/${groupId}/members/${memberId}`,
        MINE: (institutionId: string) => `${BASE_URL}/institution-group/mine/institution/${institutionId}`,
    },
    // ---- polish 6 group-company access ----
    INSTITUTION_GROUP_ACCESS: {
        GRANT: `${BASE_URL}/institution-group-access/grant`,
        LIST: (institutionId: string) => `${BASE_URL}/institution-group-access/institution/${institutionId}`,
        CANDIDATES: (institutionId: string) => `${BASE_URL}/institution-group-access/institution/${institutionId}/candidates`,
        REVOKE: (institutionId: string, membershipId: string) => `${BASE_URL}/institution-group-access/institution/${institutionId}/${membershipId}`,
    },
    // ---- end polish 6 ----
    INTERCOMPANY: {
        TXNS: (institutionId: string) => `${BASE_URL}/intercompany/institution/${institutionId}/txns`,
        TXN_BASE: `${BASE_URL}/intercompany/txns`,
        TXN: (id: string) => `${BASE_URL}/intercompany/txns/${id}`,
        TXN_ACTION: (id: string, action: string) => `${BASE_URL}/intercompany/txns/${id}/${action}`,
        MAPS: (institutionId: string) => `${BASE_URL}/intercompany/institution/${institutionId}/maps`,
        MAP_SAVE: `${BASE_URL}/intercompany/maps`,
        SUGGESTED_ACCOUNTS: (institutionId: string) => `${BASE_URL}/intercompany/institution/${institutionId}/maps/suggested-accounts`,
        RECONCILIATION: (institutionId: string) => `${BASE_URL}/intercompany/institution/${institutionId}/reconciliation`,
    },
    GROUP_CONSOLIDATION: {
        BALANCE_SHEET: (institutionId: string) => `${BASE_URL}/group-consolidation/institution/${institutionId}/balance-sheet`,
        INCOME_STATEMENT: (institutionId: string) => `${BASE_URL}/group-consolidation/institution/${institutionId}/income-statement`,
        BALANCE_SHEET_EXPORT: (institutionId: string) => `${BASE_URL}/group-consolidation/institution/${institutionId}/balance-sheet/export`,
        INCOME_STATEMENT_EXPORT: (institutionId: string) => `${BASE_URL}/group-consolidation/institution/${institutionId}/income-statement/export`,
    },
    // ---- end W3-M ----
    // ---- W3-K statements: changes in equity, notes pack, cash-flow export ----
    FINANCIAL_STATEMENTS: {
        EQUITY: (institutionId: string) => `${BASE_URL}/financial-statements/institution/${institutionId}/equity-statement`,
        EQUITY_EXPORT: (institutionId: string) => `${BASE_URL}/financial-statements/institution/${institutionId}/equity-statement/export`,
        NOTES: (institutionId: string) => `${BASE_URL}/financial-statements/institution/${institutionId}/notes`,
        NOTES_EXPORT: (institutionId: string) => `${BASE_URL}/financial-statements/institution/${institutionId}/notes/export`,
        CASH_FLOW_EXPORT: (institutionId: string) => `${BASE_URL}/financial-statements/institution/${institutionId}/cash-flow/export`,
    },
    // ---- end W3-K statements ----
    // ---- W3-K audit log ----
    AUDIT_LOG: {
        LIST: (institutionId: string) => `${BASE_URL}/audit-log/institution/${institutionId}`,
        ENTITY_TYPES: (institutionId: string) => `${BASE_URL}/audit-log/institution/${institutionId}/entity-types`,
        EXPORT: (institutionId: string) => `${BASE_URL}/audit-log/institution/${institutionId}/export`,
    },
    // ---- end W3-K audit log ----
    // ---- W3-K tally export and journal import ----
    TALLY_EXPORT: {
        MASTERS: (institutionId: string) => `${BASE_URL}/tally-export/institution/${institutionId}/masters`,
        VOUCHERS: (institutionId: string) => `${BASE_URL}/tally-export/institution/${institutionId}/vouchers`,
        LEDGER_MAP: (institutionId: string) => `${BASE_URL}/tally-export/institution/${institutionId}/ledger-map`,
        LEDGER_MAP_ONE: (institutionId: string, accountId: string) => `${BASE_URL}/tally-export/institution/${institutionId}/ledger-map/${accountId}`,
    },
    JOURNAL_IMPORT: {
        DRY_RUN: (institutionId: string) => `${BASE_URL}/journal-import/institution/${institutionId}/dry-run`,
        COMMIT: (institutionId: string) => `${BASE_URL}/journal-import/institution/${institutionId}/commit`,
        BATCHES: (institutionId: string) => `${BASE_URL}/journal-import/institution/${institutionId}/batches`,
        BATCH: (batchId: string) => `${BASE_URL}/journal-import/batch/${batchId}`,
    },
    // ---- end W3-K tally export and journal import ----
    // ---- W3-K asset categories and CWIP ----
    FIXED_ASSET_CATEGORY: {
        LIST: (institutionId: string) => `${BASE_URL}/fixed-asset-category/institution/${institutionId}`,
        CREATE: (institutionId: string) => `${BASE_URL}/fixed-asset-category/institution/${institutionId}`,
        MAP: (institutionId: string) => `${BASE_URL}/fixed-asset-category/institution/${institutionId}/map-categories`,
        UPDATE: (id: string) => `${BASE_URL}/fixed-asset-category/${id}`,
        DEACTIVATE: (id: string) => `${BASE_URL}/fixed-asset-category/${id}/deactivate`,
        ACTIVATE: (id: string) => `${BASE_URL}/fixed-asset-category/${id}/activate`,
    },
    CWIP_PROJECT: {
        LIST: (institutionId: string) => `${BASE_URL}/cwip-project/institution/${institutionId}`,
        CREATE: `${BASE_URL}/cwip-project`,
        BY_ID: (id: string) => `${BASE_URL}/cwip-project/${id}`,
        CANCEL: (id: string) => `${BASE_URL}/cwip-project/${id}/cancel`,
        LINKABLE: (id: string) => `${BASE_URL}/cwip-project/${id}/linkable-lines`,
        LINKS: (id: string) => `${BASE_URL}/cwip-project/${id}/links`,
        LINK: (id: string, linkId: string) => `${BASE_URL}/cwip-project/${id}/links/${linkId}`,
        CAPITALISE: (id: string) => `${BASE_URL}/cwip-project/${id}/capitalise`,
        REVERSE: (id: string) => `${BASE_URL}/cwip-project/${id}/reverse`,
    },
    // ---- end W3-K asset categories and CWIP ----
    // ---- W3-I garments costing ----
    COSTING: {
        SETTINGS: (institutionId: string) => `${BASE_URL}/costing/institution/${institutionId}/settings`,
        SUGGESTED_ACCOUNTS: (institutionId: string) => `${BASE_URL}/costing/institution/${institutionId}/settings/suggested-accounts`,
        ENABLED: (institutionId: string) => `${BASE_URL}/costing/institution/${institutionId}/enabled`,
        OUTPUTS: (institutionId: string) => `${BASE_URL}/production-output/institution/${institutionId}`,
        OUTPUT: (id: string) => `${BASE_URL}/production-output/${id}`,
        RUNS: (institutionId: string) => `${BASE_URL}/cost-absorption/institution/${institutionId}`,
        RUN_PREVIEW: (institutionId: string) => `${BASE_URL}/cost-absorption/institution/${institutionId}/preview`,
        RUN: (id: string) => `${BASE_URL}/cost-absorption/${id}`,
        RUN_POST: (id: string) => `${BASE_URL}/cost-absorption/${id}/post`,
        RUN_REVERSE: (id: string) => `${BASE_URL}/cost-absorption/${id}/reverse`,
        ORDERS: (institutionId: string) => `${BASE_URL}/order-cost/institution/${institutionId}`,
        ORDER: (institutionId: string, orderId: string) => `${BASE_URL}/order-cost/institution/${institutionId}/order/${orderId}`,
        PENDING_SHIPMENTS: (institutionId: string) => `${BASE_URL}/order-cost/institution/${institutionId}/pending-shipments`,
        TRANSFER_TO_FG: (institutionId: string, orderId: string) => `${BASE_URL}/order-cost/institution/${institutionId}/order/${orderId}/transfer-to-fg`,
        CLOSE: (institutionId: string, orderId: string) => `${BASE_URL}/order-cost/institution/${institutionId}/order/${orderId}/close`,
        COST_SHIPMENT: (institutionId: string, invoiceId: string) => `${BASE_URL}/order-cost/institution/${institutionId}/invoice/${invoiceId}/cost-shipment`,
        REVERSE_EVENT: (institutionId: string, eventId: string) => `${BASE_URL}/order-cost/institution/${institutionId}/event/${eventId}/reverse`,
    },
    // ---- end W3-I ----
    // ---- W3-V FP&A ----
    FPA: {
        VERSIONS: (i: string) => `${BASE_URL}/fpa/institution/${i}/versions`,
        VERSION: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/versions/${id}`,
        IMPORT_LEGACY: (i: string) => `${BASE_URL}/fpa/institution/${i}/versions/import-legacy`,
        ROLL_FORWARD: (i: string) => `${BASE_URL}/fpa/institution/${i}/versions/roll-forward`,
        LINES: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/versions/${id}/lines`,
        APPROVE: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/versions/${id}/approve`,
        KIND: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/versions/${id}/kind`,
        LOCK: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/versions/${id}/lock`,
        REOPEN: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/versions/${id}/reopen`,
        TEMPLATE: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/versions/${id}/template`,
        IMPORT: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/versions/${id}/import`,
        VARIANCE: (i: string) => `${BASE_URL}/fpa/institution/${i}/variance`,
        VARIANCE_EXPORT: (i: string) => `${BASE_URL}/fpa/institution/${i}/variance/export`,
        VARIANCE_COMMENTS: (i: string) => `${BASE_URL}/fpa/institution/${i}/variance/comments`,
        KPIS: (i: string) => `${BASE_URL}/fpa/institution/${i}/kpis`,
        KPI_SETTINGS: (i: string) => `${BASE_URL}/fpa/institution/${i}/kpi-settings`,
        BUYER_PROFITABILITY: (i: string) => `${BASE_URL}/fpa/institution/${i}/buyer-profitability`,
        BOARD_PACKS: (i: string) => `${BASE_URL}/fpa/institution/${i}/board-packs`,
        BOARD_PACK: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/board-packs/${id}`,
        BOARD_PACK_FINALIZE: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/board-packs/${id}/finalize`,
        BOARD_PACK_TABLE: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/board-packs/${id}/table`,
        BOARD_PACK_PDF: (i: string, id: string) => `${BASE_URL}/fpa/institution/${i}/board-packs/${id}/pdf`,
    },
    // ---- end W3-V ----
    // ---- W3-X data in/out ----
    DATA_IMPORT: {
        TEMPLATE: (i: string, kind: string) => `${BASE_URL}/data-import/institution/${i}/${kind}/template`,
        DRY_RUN: (i: string, kind: string) => `${BASE_URL}/data-import/institution/${i}/${kind}/dry-run`,
        COMMIT: (i: string, kind: string) => `${BASE_URL}/data-import/institution/${i}/${kind}/commit`,
        HISTORY: (i: string, kind: string) => `${BASE_URL}/data-import/institution/${i}/${kind}/history`,
        JOB: (jobId: string) => `${BASE_URL}/data-import/job/${jobId}`,
        // ---- FW-1 ----
        EXPORT: (i: string, kind: string) => `${BASE_URL}/data-import/institution/${i}/${kind}/export`,
        // ---- end FW-1 ----
    },
    INTEGRATION_KEY: {
        LIST: (i: string) => `${BASE_URL}/integration-key/institution/${i}`,
        CREATE: `${BASE_URL}/integration-key`,
        REVOKE: (keyId: string) => `${BASE_URL}/integration-key/${keyId}/revoke`,
    },
    WEBHOOK: {
        SETTINGS: (i: string) => `${BASE_URL}/webhook/institution/${i}/settings`,
        LIST: (i: string) => `${BASE_URL}/webhook/institution/${i}`,
        CREATE: `${BASE_URL}/webhook`,
        ONE: (id: string) => `${BASE_URL}/webhook/${id}`,
        ROTATE: (id: string) => `${BASE_URL}/webhook/${id}/rotate-secret`,
        TEST: (id: string) => `${BASE_URL}/webhook/${id}/test`,
        DELIVERIES: (i: string) => `${BASE_URL}/webhook/institution/${i}/deliveries`,
        DELIVERY: (id: string) => `${BASE_URL}/webhook/delivery/${id}`,
        RETRY: (id: string) => `${BASE_URL}/webhook/delivery/${id}/retry`,
        SEND_NOW: (i: string) => `${BASE_URL}/webhook/institution/${i}/send-now`,
    },
    // ---- Xero slice 1: connect, organisation pick, test, go-live date, disconnect (INTEGRATION_MANAGE) ----
    XERO: {
        VIEW: (i: string) => `${BASE_URL}/integration/xero/institution/${i}`,
        CONNECT: (i: string) => `${BASE_URL}/integration/xero/institution/${i}/connect`,
        CALLBACK: (i: string) => `${BASE_URL}/integration/xero/institution/${i}/callback`,
        PICK: (i: string) => `${BASE_URL}/integration/xero/institution/${i}/pick`,
        TEST: (i: string) => `${BASE_URL}/integration/xero/institution/${i}/test`,
        GO_LIVE: (i: string) => `${BASE_URL}/integration/xero/institution/${i}/go-live`,
        DISCONNECT: (i: string) => `${BASE_URL}/integration/xero/institution/${i}`,
    },
    RETENTION: {
        LIST: (i: string) => `${BASE_URL}/retention/institution/${i}`,
        SAVE: (i: string) => `${BASE_URL}/retention/institution/${i}`,
        CLASSES: (i: string) => `${BASE_URL}/retention/institution/${i}/classes`,
        LOAD_DEFAULTS: (i: string) => `${BASE_URL}/retention/institution/${i}/load-defaults`,
        REPORT: (i: string) => `${BASE_URL}/retention/institution/${i}/report`,
    },
    // ---- end W3-X ----
    // ---- B4-G: supplier statement reconciliation ----
    SUPPLIER_STATEMENT: {
        LIST: (institutionId: string) => `${BASE_URL}/supplier-statement?institutionId=${institutionId}`,
        REPORT: (id: string, institutionId: string) => `${BASE_URL}/supplier-statement/${id}/report?institutionId=${institutionId}`,
        REPORT_XLSX: (id: string, institutionId: string) => `${BASE_URL}/supplier-statement/${id}/report.xlsx?institutionId=${institutionId}`,
        LETTER: (id: string, institutionId: string) => `${BASE_URL}/supplier-statement/${id}/confirmation-letter?institutionId=${institutionId}`,
        DRY_RUN: (institutionId: string) => `${BASE_URL}/supplier-statement/import/dry-run?institutionId=${institutionId}`,
        IMPORT: (institutionId: string) => `${BASE_URL}/supplier-statement/import?institutionId=${institutionId}`,
        ACTION: (id: string, action: 'auto-match' | 'match' | 'sign-off', institutionId: string) =>
            `${BASE_URL}/supplier-statement/${id}/${action}?institutionId=${institutionId}`,
        UNMATCH: (id: string, lineId: string, institutionId: string) =>
            `${BASE_URL}/supplier-statement/${id}/unmatch/${lineId}?institutionId=${institutionId}`,
        ONE: (id: string, institutionId: string) => `${BASE_URL}/supplier-statement/${id}?institutionId=${institutionId}`,
    },
    // ---- end B4-G ----
    // ---- B4-B FC bank and ERQ ----
    FC_CONVERSION: {
        LIST: (institutionId: string) => `${BASE_URL}/fc-conversion/institution/${institutionId}`,
        POSITIONS: (institutionId: string) => `${BASE_URL}/fc-conversion/institution/${institutionId}/positions`,
        BASE: `${BASE_URL}/fc-conversion`,
        PREVIEW: `${BASE_URL}/fc-conversion/preview`,
        ONE: (id: string) => `${BASE_URL}/fc-conversion/${id}`,
        REVERSE: (id: string) => `${BASE_URL}/fc-conversion/${id}/reverse`,
        ANCHOR: (institutionId: string, bankAccountId: string) => `${BASE_URL}/fc-conversion/institution/${institutionId}/bank-account/${bankAccountId}/anchor`,
    },
    // ---- end B4-B ----
    // ---- B4-F: PO approval bands, raise a PO from a requisition ----
    PO_APPROVAL: {
        BANDS: (institutionId: string) => `${BASE_URL}/po-approval/bands/institution/${institutionId}`,
        PENDING: (institutionId: string) => `${BASE_URL}/po-approval/pending/institution/${institutionId}`,
        OF_PO: (id: string) => `${BASE_URL}/po-approval/purchase-order/${id}`,
        RAISABLE_REQUISITIONS: (institutionId: string) => `${BASE_URL}/requisition/raise-po/institution/${institutionId}`,
        PO_PREFILL: (requisitionId: string) => `${BASE_URL}/requisition/${requisitionId}/po-prefill`,
    },
    // ---- end B4-F ----
    // ---- B4-H department (cost-centre) dimension ----
    COST_CENTRE: {
        DEPARTMENTS: (institutionId: string) => `${BASE_URL}/cost-centre/institution/${institutionId}/departments`,
        DEPARTMENT_PL: (institutionId: string) => `${BASE_URL}/cost-centre/institution/${institutionId}/department-pl`,
        DEPARTMENT_PL_EXPORT: (institutionId: string) => `${BASE_URL}/cost-centre/institution/${institutionId}/department-pl/export`,
    },
    // ---- end B4-H ----
    // ---- FW-2A sales product/service catalogue ----
    SALES_CATALOGUE: {
        BY_INSTITUTION: (institutionId: string) => `${BASE_URL}/sales-catalogue/institution/${institutionId}`,
    },
    // ---- end FW-2A ----
    // ---- FW-2B cash sale ----
    CASH_SALE: {
        BASE: `${BASE_URL}/cash-sale`,
        LIST: (institutionId: string) => `${BASE_URL}/cash-sale/institution/${institutionId}`,
        VOID: (id: string) => `${BASE_URL}/cash-sale/${id}/void`,
        SETTINGS: (institutionId: string) => `${BASE_URL}/cash-sale/settings/institution/${institutionId}`,
        SAVE_SETTINGS: `${BASE_URL}/cash-sale/settings`,
        WALK_IN_CUSTOMER: (institutionId: string) => `${BASE_URL}/cash-sale/settings/institution/${institutionId}/walk-in-customer`,
    },
    // ---- end FW-2B ----
    // ---- P1-A projects ----
    PROJECTS: {
        LIST: (i: string) => `${BASE_URL}/projects/institution/${i}`,
        MINE: (i: string) => `${BASE_URL}/projects/institution/${i}/mine`,
        OPTIONS: (i: string) => `${BASE_URL}/projects/institution/${i}/options`,
        BY_ID: (i: string, id: string) => `${BASE_URL}/projects/institution/${i}/${id}`,
        STATUS: (i: string, id: string) => `${BASE_URL}/projects/institution/${i}/${id}/status`,
        PROJECT_PL: (i: string) => `${BASE_URL}/projects/institution/${i}/project-pl`,
        PROJECT_PL_EXPORT: (i: string) => `${BASE_URL}/projects/institution/${i}/project-pl/export`,
        PL: (i: string, id: string) => `${BASE_URL}/projects/institution/${i}/${id}/pl`,
        BUDGET_VS_ACTUAL: (i: string, id: string) => `${BASE_URL}/projects/institution/${i}/${id}/budget-vs-actual`,
        LEDGER: (i: string, id: string) => `${BASE_URL}/projects/institution/${i}/${id}/ledger`,
        LEDGER_EXPORT: (i: string, id: string) => `${BASE_URL}/projects/institution/${i}/${id}/ledger/export`,
        TASKS: (i: string, id: string) => `${BASE_URL}/projects/institution/${i}/${id}/tasks`,
    },
    // ---- end P1-A ----
    // ---- P1-B customer portal and gateway refunds ----
    PORTAL: {
        BASE: `${BASE_URL}/portal`,
    },
    PORTAL_ADMIN: {
        SETTINGS: (i: string) => `${BASE_URL}/portal-admin/institution/${i}/settings`,
        CONTACTS: (i: string, customerId: string) => `${BASE_URL}/portal-admin/institution/${i}/customers/${customerId}/contacts`,
        REINVITE: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/contacts/${contactId}/reinvite`,
        RESET_LINK: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/contacts/${contactId}/reset-link`,
        UNLOCK: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/contacts/${contactId}/unlock`,
        DEACTIVATE: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/contacts/${contactId}/deactivate`,
        REACTIVATE: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/contacts/${contactId}/reactivate`,
        ACTIVITY: (i: string, customerId: string) => `${BASE_URL}/portal-admin/institution/${i}/customers/${customerId}/activity`,
        ACTIVITY_EXPORT: (i: string, customerId: string) => `${BASE_URL}/portal-admin/institution/${i}/customers/${customerId}/activity/export`,
        UPLOADS: (i: string, customerId: string) => `${BASE_URL}/portal-admin/institution/${i}/customers/${customerId}/uploads`,
        UPLOAD_DOWNLOAD: (i: string, uploadId: string) => `${BASE_URL}/portal-admin/institution/${i}/uploads/${uploadId}/download`,
        UPLOAD_REVIEW: (i: string, uploadId: string) => `${BASE_URL}/portal-admin/institution/${i}/uploads/${uploadId}/review`,
    },
    GATEWAY_REFUND: {
        ELIGIBILITY: (noteId: string) => `${BASE_URL}/gateway-refunds/credit-note/${noteId}/eligibility`,
        BY_NOTE: (noteId: string) => `${BASE_URL}/gateway-refunds/credit-note/${noteId}`,
        RECHECK: (id: string) => `${BASE_URL}/gateway-refunds/${id}/recheck`,
        RESOLVE: (id: string) => `${BASE_URL}/gateway-refunds/${id}/resolve`,
        BOOK: (id: string) => `${BASE_URL}/gateway-refunds/${id}/book`,
        BOOK_MANUAL: (id: string) => `${BASE_URL}/gateway-refunds/${id}/book-manual`,
        SETTINGS: (i: string) => `${BASE_URL}/gateway-refunds/institution/${i}/settings`,
    },
    // ---- end P1-B ----
    // ---- F5 sales fulfilment ----
    SALES_FULFILMENT: {
        PACKAGES: (i: string, challanId: string) => `${BASE_URL}/sales/institution/${i}/challans/${challanId}/packages`,
        PACKAGE: (i: string, challanId: string, packageId: string) => `${BASE_URL}/sales/institution/${i}/challans/${challanId}/packages/${packageId}`,
        AUTO_PACK: (i: string, challanId: string) => `${BASE_URL}/sales/institution/${i}/challans/${challanId}/packages/auto`,
        SHIPMENT: (i: string, challanId: string) => `${BASE_URL}/sales/institution/${i}/challans/${challanId}/shipment`,
        SHIPMENT_STATUS: (i: string, challanId: string) => `${BASE_URL}/sales/institution/${i}/challans/${challanId}/shipment/status`,
        PACKING_SLIP: (i: string, challanId: string) => `${BASE_URL}/sales/institution/${i}/challans/${challanId}/packing-slip.pdf`,
        SHIPMENTS: (i: string) => `${BASE_URL}/sales/institution/${i}/shipments`,
        SHIPMENT_EMAIL: (i: string, challanId: string) => `${BASE_URL}/sales/institution/${i}/challans/${challanId}/shipment/email`, // F7
    },
    // ---- end F5 ----
    // ---- F10 asset location and transfer ----
    FIXED_ASSET_TRANSFER: {
        LOCATIONS: (i: string) => `${BASE_URL}/fixed-assets/institution/${i}/locations`,
        LOCATION: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/locations/${id}`,
        LOCATION_DEACTIVATE: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/locations/${id}/deactivate`,
        LOCATION_ACTIVATE: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/locations/${id}/activate`,
        ASSET_TRANSFERS: (i: string, assetId: string) => `${BASE_URL}/fixed-assets/institution/${i}/assets/${assetId}/transfers`,
        REGISTER: (i: string) => `${BASE_URL}/fixed-assets/institution/${i}/transfers`,
        REVERSE: (i: string, transferId: string) => `${BASE_URL}/fixed-assets/institution/${i}/transfers/${transferId}/reverse`,
        MY_ASSETS: (i: string) => `${BASE_URL}/fixed-assets/institution/${i}/my-assets`,
        CUSTODIANS: (i: string) => `${BASE_URL}/fixed-assets/institution/${i}/custodians`,
    },
    // ---- end F10 ----
    // ---- F7 e-mail templates ----
    EMAIL_TEMPLATES: {
        LIST: (i: string) => `${BASE_URL}/email-templates/institution/${i}`,
        ONE: (i: string, key: string) => `${BASE_URL}/email-templates/institution/${i}/${key}`,
        PREVIEW: (i: string, key: string) => `${BASE_URL}/email-templates/institution/${i}/${key}/preview`,
    },
    // ---- end F7 ----
    // ---- F6a lot expiry ----
    EXPIRY_REPORT: {
        REPORT: (i: string) => `${BASE_URL}/inventory/institution/${i}/reports/expiry`,
        XLSX: (i: string) => `${BASE_URL}/inventory/institution/${i}/reports/expiry.xlsx`,
    },
    // ---- end F6a ----
    // ---- G6a inventory costing settings ----
    INVENTORY_SETTINGS: {
        GET: (i: string) => `${BASE_URL}/inventory/settings/institution/${i}`,
        LOT_COSTING_METHOD: (i: string) => `${BASE_URL}/inventory/settings/institution/${i}/lot-costing-method`,
    },
    // ---- end G6a ----
    // ---- F8 supplier portal and employee bits ----
    SUPPLIER_PORTAL_ADMIN: {
        SETTINGS: (i: string) => `${BASE_URL}/portal-admin/institution/${i}/settings/supplier-portal`,
        CONTACTS: (i: string, supplierId: string) => `${BASE_URL}/portal-admin/institution/${i}/suppliers/${supplierId}/contacts`,
        REINVITE: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/supplier-contacts/${contactId}/reinvite`,
        RESET_LINK: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/supplier-contacts/${contactId}/reset-link`,
        UNLOCK: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/supplier-contacts/${contactId}/unlock`,
        DEACTIVATE: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/supplier-contacts/${contactId}/deactivate`,
        REACTIVATE: (i: string, contactId: string) => `${BASE_URL}/portal-admin/institution/${i}/supplier-contacts/${contactId}/reactivate`,
        ACTIVITY: (i: string, supplierId: string) => `${BASE_URL}/portal-admin/institution/${i}/suppliers/${supplierId}/activity`,
    },
    SUPPLIER_BILL_REQUEST: {
        LIST: (i: string) => `${BASE_URL}/procurement/institution/${i}/bill-requests`,
        ONE: (i: string, id: string) => `${BASE_URL}/procurement/institution/${i}/bill-requests/${id}`,
        FILE: (i: string, id: string) => `${BASE_URL}/procurement/institution/${i}/bill-requests/${id}/file`,
        COMMENT: (i: string, id: string) => `${BASE_URL}/procurement/institution/${i}/bill-requests/${id}/comment`,
        REJECT: (i: string, id: string) => `${BASE_URL}/procurement/institution/${i}/bill-requests/${id}/reject`,
        CONVERT: (i: string, id: string) => `${BASE_URL}/procurement/institution/${i}/bill-requests/${id}/convert`,
        COVERED_GRN_LINES: (i: string, id: string) => `${BASE_URL}/procurement/institution/${i}/bill-requests/${id}/covered-grn-lines`,
        PO_ACK: (i: string, poId: string) => `${BASE_URL}/procurement/institution/${i}/purchase-orders/${poId}/supplier-ack`,
    },
    ASSET_REQUISITION: {
        MINE: (i: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/mine`,
        CATEGORIES: (i: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/categories`,
        DEPARTMENTS: (i: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/departments`,
        LIST: (i: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions`,
        ONE: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/${id}`,
        SUBMIT: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/${id}/submit`,
        CANCEL: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/${id}/cancel`,
        FULFIL: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/${id}/fulfil`,
        LINK_PO: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/${id}/link-po`,
        ATTACHMENTS: (i: string, id: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/${id}/attachments`,
        ATTACHMENT: (i: string, id: string, attachmentId: string) => `${BASE_URL}/fixed-assets/institution/${i}/requisitions/${id}/attachments/${attachmentId}`,
    },
    // ---- end F8 ----
    // ---- F6c kits ----
    KIT: {
        COMPONENTS: (i: string, itemId: string) => `${BASE_URL}/inventory/institution/${i}/items/${itemId}/kit-components`,
    },
    // ---- end F6c ----
    // ---- F6b serial numbers ----
    SERIAL: {
        SEARCH: (i: string) => `${BASE_URL}/inventory/institution/${i}/serials`,
        AVAILABLE: (i: string) => `${BASE_URL}/inventory/institution/${i}/serials/available`,
        SOLD_ON_CHALLAN: (i: string) => `${BASE_URL}/inventory/institution/${i}/serials/sold-on-challan`,
        TRACKED_ITEMS: (i: string) => `${BASE_URL}/inventory/institution/${i}/serials/tracked-items`,
        BY_DOCUMENT: (i: string) => `${BASE_URL}/inventory/institution/${i}/serials/by-document`,
        DETAIL: (i: string, id: string) => `${BASE_URL}/inventory/institution/${i}/serials/${id}`,
    },
    // ---- end F6b ----
    // ---- MAINTENANCE (L0): equipment register, equipment types, settings + failure codes ----
    MAINTENANCE: {
        EQUIPMENT_LIST: (i: string) => `${BASE_URL}/maintenance/equipment/institution/${i}`,
        EQUIPMENT: `${BASE_URL}/maintenance/equipment`,
        EQUIPMENT_BY_ID: (id: string) => `${BASE_URL}/maintenance/equipment/${id}`,
        EQUIPMENT_MOVES: (id: string) => `${BASE_URL}/maintenance/equipment/${id}/moves`,
        EQUIPMENT_MOVE: (id: string) => `${BASE_URL}/maintenance/equipment/${id}/move`,
        EQUIPMENT_STATUS: (id: string) => `${BASE_URL}/maintenance/equipment/${id}/status`,
        EQUIPMENT_METERS: (id: string) => `${BASE_URL}/maintenance/equipment/${id}/meters`,
        METER_BY_ID: (meterId: string) => `${BASE_URL}/maintenance/equipment/meters/${meterId}`,
        EQUIPMENT_IMPORT: (i: string) => `${BASE_URL}/maintenance/equipment/institution/${i}/import`,
        EQUIPMENT_EXPORT: (i: string) => `${BASE_URL}/maintenance/equipment/institution/${i}/export.csv`,
        TYPE_LIST: (i: string) => `${BASE_URL}/maintenance/equipment/types/institution/${i}`,
        TYPES: `${BASE_URL}/maintenance/equipment/types`,
        TYPE_BY_ID: (id: string) => `${BASE_URL}/maintenance/equipment/types/${id}`,
        GROUP_LIST: (i: string) => `${BASE_URL}/maintenance/equipment-groups/institution/${i}`,
        GROUPS: `${BASE_URL}/maintenance/equipment-groups`,
        GROUP_BY_ID: (id: string) => `${BASE_URL}/maintenance/equipment-groups/${id}`,
        GROUP_DEACTIVATE: (id: string) => `${BASE_URL}/maintenance/equipment-groups/${id}/deactivate`,
        GROUP_ACTIVATE: (id: string) => `${BASE_URL}/maintenance/equipment-groups/${id}/activate`,
        SETTINGS: (i: string) => `${BASE_URL}/maintenance/settings/institution/${i}`,
        SEED_DEFAULTS: (i: string) => `${BASE_URL}/maintenance/settings/institution/${i}/seed-defaults`,
        FAILURE_CODE_LIST: (i: string) => `${BASE_URL}/maintenance/settings/institution/${i}/failure-codes`,
        FAILURE_CODES: `${BASE_URL}/maintenance/settings/failure-codes`,
        FAILURE_CODE_BY_ID: (id: string) => `${BASE_URL}/maintenance/settings/failure-codes/${id}`,
        // L2 readings
        LOG_SHEET: (i: string) => `${BASE_URL}/maintenance/meters/institution/${i}/log-sheet`,
        READINGS_BATCH: (i: string) => `${BASE_URL}/maintenance/meters/institution/${i}/readings`,
        METER_SUMMARY: (meterId: string) => `${BASE_URL}/maintenance/meters/${meterId}`,
        METER_READINGS: (meterId: string) => `${BASE_URL}/maintenance/meters/${meterId}/readings`,
        READING_CORRECT: (readingId: string) => `${BASE_URL}/maintenance/meters/readings/${readingId}/correct`,
        // ---- L1: work orders, breakdown requests, self-service ----
        WO_LIST: (i: string) => `${BASE_URL}/maintenance/work-orders/institution/${i}`,
        WO_MINE: (i: string) => `${BASE_URL}/maintenance/work-orders/institution/${i}/mine`,
        WO_TECHNICIANS: (i: string) => `${BASE_URL}/maintenance/work-orders/institution/${i}/technicians`,
        WO: `${BASE_URL}/maintenance/work-orders`,
        WO_BY_ID: (id: string) => `${BASE_URL}/maintenance/work-orders/${id}`,
        WO_ACTION: (id: string, action: string) => `${BASE_URL}/maintenance/work-orders/${id}/${action}`,
        WO_LABOUR: (id: string) => `${BASE_URL}/maintenance/work-orders/${id}/labour`,
        WO_LABOUR_BY_ID: (id: string, labourId: string) => `${BASE_URL}/maintenance/work-orders/${id}/labour/${labourId}`,
        WO_CHECKLIST: (id: string) => `${BASE_URL}/maintenance/work-orders/${id}/checklist`,
        WO_CHECKLIST_ITEM: (id: string, itemId: string) => `${BASE_URL}/maintenance/work-orders/${id}/checklist/${itemId}`,
        WO_PARTS: (id: string) => `${BASE_URL}/maintenance/work-orders/${id}/parts`,
        WO_PARTS_ATTACH: (id: string) => `${BASE_URL}/maintenance/work-orders/${id}/parts/attach`,
        WO_EXTERNAL: (id: string) => `${BASE_URL}/maintenance/work-orders/${id}/external`,
        REQUEST_LIST: (i: string) => `${BASE_URL}/maintenance/requests/institution/${i}`,
        REQUEST_ACTION: (id: string, action: string) => `${BASE_URL}/maintenance/requests/${id}/${action}`,
        REQUEST_BY_ID: (id: string) => `${BASE_URL}/maintenance/requests/${id}`,
        PM_LIST: (i: string) => `${BASE_URL}/maintenance/pm-plans/institution/${i}`,
        PM_DUE: (i: string) => `${BASE_URL}/maintenance/pm-plans/institution/${i}/due`,
        PM_FOR_EQUIPMENT: (i: string, equipmentId: string) => `${BASE_URL}/maintenance/pm-plans/institution/${i}/equipment/${equipmentId}`,
        PM_BULK: (i: string) => `${BASE_URL}/maintenance/pm-plans/institution/${i}/bulk`,
        PM_GENERATE_NOW: (i: string) => `${BASE_URL}/maintenance/pm-plans/institution/${i}/generate-now`,
        PM: `${BASE_URL}/maintenance/pm-plans`,
        PM_BY_ID: (id: string) => `${BASE_URL}/maintenance/pm-plans/${id}`,
        PM_BATCH: (batchKey: string) => `${BASE_URL}/maintenance/pm-plans/batch/${batchKey}`,
        MY_BREAKDOWNS: `${BASE_URL}/my-breakdown-requests`,
        MY_BREAKDOWN_LIST: (i: string) => `${BASE_URL}/my-breakdown-requests/institution/${i}`,
        MY_BREAKDOWN_EQUIPMENT: (i: string) => `${BASE_URL}/my-breakdown-requests/institution/${i}/equipment`,
        MY_BREAKDOWN_LOCATIONS: (i: string) => `${BASE_URL}/my-breakdown-requests/institution/${i}/locations`,
        MY_BREAKDOWN_BY_ID: (id: string) => `${BASE_URL}/my-breakdown-requests/${id}`,
        MY_BREAKDOWN_CANCEL: (id: string) => `${BASE_URL}/my-breakdown-requests/${id}/cancel`,
        DASHBOARD_MANAGER: (i: string) => `${BASE_URL}/maintenance/dashboard/institution/${i}/manager`,
        DASHBOARD_TECHNICIAN: (i: string) => `${BASE_URL}/maintenance/dashboard/institution/${i}/technician`,
        // ---- L5 reports: `slug` is the report name, `.csv` twin appended by the caller ----
        REPORT: (i: string, slug: string) => `${BASE_URL}/maintenance/reports/institution/${i}/${slug}`,
        REPORT_CSV: (i: string, slug: string) => `${BASE_URL}/maintenance/reports/institution/${i}/${slug}.csv`,
        // ---- repair bills: maintenance submits, accounts approves ----
        REPAIR_BILLS_OF_WO: (woId: string) => `${BASE_URL}/maintenance/repair-bills/work-order/${woId}`,
        REPAIR_BILL: (id: string) => `${BASE_URL}/maintenance/repair-bills/${id}`,
        REPAIR_BILL_SUBMIT: (id: string) => `${BASE_URL}/maintenance/repair-bills/${id}/submit`,
        REPAIR_BILL_APPROVE_WITH_BILL: (id: string) => `${BASE_URL}/maintenance/repair-bills/${id}/approve-with-bill`,
        REPAIR_BILL_LINK: (id: string) => `${BASE_URL}/maintenance/repair-bills/${id}/link`,
        REPAIR_BILL_REJECT: (id: string) => `${BASE_URL}/maintenance/repair-bills/${id}/reject`,
        REPAIR_BILL_FILES: (id: string) => `${BASE_URL}/maintenance/repair-bills/${id}/files`,
        REPAIR_BILL_FILE: (id: string, fileId: string) => `${BASE_URL}/maintenance/repair-bills/${id}/files/${fileId}`,
        REPAIR_BILL_QUEUE: (i: string) => `${BASE_URL}/maintenance/repair-bills/queue/institution/${i}`,
        REPAIR_BILL_QUEUE_COUNT: (i: string) => `${BASE_URL}/maintenance/repair-bills/queue/institution/${i}/count`,
    },
    // ---- end MAINTENANCE ----
} as const;
